import { Popover } from 'antd'
import React, { useRef, useCallback, forwardRef, useMemo } from 'react'
import { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import './broadcastStyles.css'
import ActionButtons from './localComponent/actionButtons';
import RightColumn from './localComponent/rightColumn.js';
import { setRightViewType, setMuteState, setCameraState, clearGroupChat, updateUserList, 
    updateUserCount, addMessageToGroup, setUserType, setRightView, addMessageToPrivate, 
    setStreamId, postChat, postChatImage, clearPrivateChat,
    getVideoResourceSections, postRecordedVideoLesson, postRecordCount, getRoomData, updateUnreadCount, BroadcastRecordingEdit, setLocalRecordingName,
    setCurrentPrivateChatReciever, postMessageOpenStatus, recordConsumption } from 'actions/broadcast'
import ConsumptionTracker from 'services/consumptionTracker'
import consumptionPhaseLogger from 'services/consumptionPhaseLogger'
import { postCreateTopic, getStorageDetails } from 'actions/digitalLibrary'
import Canvas from './localComponent/sketchCanvas.js'
import RoomClient from './roomClient'
import { v4 as uuidv4 } from 'uuid';
import { Notification, Utils, Api } from 'services';
import MessageNotification from './localComponent/messageNotification.js'
import PageDataLoader from 'components/pageDataLoader';
import ConfirmationModal from './localComponent/confirmationModal';
import ChatClient from './chatClient'
import { setUpChatSocket, setUpRoomClientSocket } from './utils';
import Loader from 'pages/Test/localComponent/loader';
import { BsCameraVideoFill, BsFillCameraReelsFill } from "react-icons/bs";
import { BsFillRecord2Fill } from "react-icons/bs";
import { PiProjectorScreenChartFill } from 'react-icons/pi'
import { MdNetworkWifi1Bar, MdStopScreenShare, MdNetworkWifi } from "react-icons/md";
import { VideoView } from 'components';
import VideoPlayer from './video';
import { AiFillSwitcher, AiOutlineFullscreen } from 'react-icons/ai';
import { FiX } from 'react-icons/fi';
import { EventRegister } from 'react-native-event-listeners';
import RecordingModal from './localComponent/recordingModal';
import LiveTopBar from './localComponent/liveTopBar';
import LiveControlBar from './localComponent/liveControlBar';
import ShareScreenModal from './localComponent/shareScreenModal';
import ParticipantsPanel, { initialsOf, roleOf } from './localComponent/participantsPanel';
import DraggablePip from './localComponent/draggablePip';
import ChatPanel from './localComponent/chatPanel';
import { useInterval } from '../../hooks'
import audiosrc from './localComponent/assets/broadcast_stopped.m4a';
import audioDisconnectSrc from './localComponent/assets/audio_disconnect.wav';
import videoDisconnectSrc from './localComponent/assets/video_disconnect.wav';
import audiovideoDisconnectSrc from './localComponent/assets/audio_video_disconnect.wav';
import { recorder } from './browserRecorder';
import useMicLevel from './useMicLevel';
import { measureDownlink, measureUplink } from './networkSpeedTest';
import { VIDEO_LADDER, labelForHeight, describeFrame, WEAK_NOTICE_MS, rungForSpeed } from './videoLadder';
import PassiveCanvas from './localComponent/passiveCanvas';
import { isBoardReady } from './boardCapture';
import AulasSubscriptionModal from 'pages/common/aulasSubsriptionModal';



let shareType = 'screen';
// The mediasoup label of the live video producer, which is no longer the same question as
// what is being sent on it. A label is fixed when the producer is created and lives as long
// as the producer does; the screen/camera swaps below go through replaceTrack, which leaves
// the producer — and so its label — exactly where it was. Read the producer map rather than
// shareType, and fall back to shareType only when there is no producer yet and the label is
// about to be chosen.
const videoLabel = () => {
    const labels = roomClient?.producerLabel
    const fallback = shareType==='screen' ? 'screenType' : 'videoType'
    if (!labels) return fallback
    // "Has a label" and "has a producer" are different questions here:
    // closeProducer(type, false) drops the producer but keeps the label on purpose, so that
    // produce(type, true) can find the stream again on the way back from a reconnect. An
    // open producer therefore wins, and a label left behind for a reconnect is the next best
    // answer — only with neither is there nothing yet and the label about to be chosen.
    const open = ['videoType', 'screenType'].find((label) => {
        const producerId = labels.get(label)
        return producerId && roomClient?.producers?.has(producerId)
    })
    return open ?? ['videoType', 'screenType'].find((label) => labels.has(label)) ?? fallback
}
let audio = null;
let audioDisconnect = null;
let videoDisconnect = null;
let audiovideoDisconnect = null;
let previousAudioList = [];
let previousVideoList = [];

// ---- connection readout helpers -------------------------------------------------------
// Decimal units, not binary: a class is reported against a data plan, and plans are sold in
// MB of 1,000,000 bytes.
export const formatBytes = (bytes = 0) => {
    if (!Number.isFinite(bytes) || bytes <= 0) return '0 MB'
    if (bytes < 1000000) return `${Math.max(Math.round(bytes / 1000), 1)} KB`
    if (bytes < 1000000000) return `${(bytes / 1000000).toFixed(bytes < 10000000 ? 1 : 0)} MB`
    return `${(bytes / 1000000000).toFixed(2)} GB`
}

export const formatBitrate = (bitsPerSecond = 0) => {
    if (!Number.isFinite(bitsPerSecond) || bitsPerSecond <= 0) return '0'
    if (bitsPerSecond < 1000000) return `${Math.round(bitsPerSecond / 1000)}k`
    return `${(bitsPerSecond / 1000000).toFixed(1)}M`
}

// Mbps / kbps spelled out, because this is the figure a teacher is meant to read and weigh
// against what they know of their own line. formatBitrate stays as it is for the compact
// throughput arrows beside it, where a full unit would not fit.
export const formatSpeed = (bitsPerSecond = 0) => {
    if (!Number.isFinite(bitsPerSecond) || bitsPerSecond <= 0) return '—'
    if (bitsPerSecond < 1000) return `${Math.round(bitsPerSecond)} bps`
    if (bitsPerSecond < 1000000) return `${Math.round(bitsPerSecond / 1000)} kbps`
    return `${(bitsPerSecond / 1000000).toFixed(bitsPerSecond < 10000000 ? 2 : 1)} Mbps`
}

// Budgets for the two kinds of test. The one on join can afford to be thorough — nothing is
// being published yet, so it competes with nothing. Every later test runs while a class is
// in progress, so it settles for a rougher figure at a third of the cost; by then the
// question is only "has this got worse", which does not need three seconds to answer.
//
// Each slot carries both directions, because a peer is measured in the direction it uses:
// `uplink` is what a publisher runs, the budgetMs/maxBytes pair is what a student runs.
// Three megabytes on join — enough to outlast the send ramp on a slow line without making
// a fast one wait; one on a recheck, where the question is only whether the line has moved.
export const SPEED_TEST_JOIN = {budgetMs: 3000, maxBytes: 12000000,
                                uplink: {bytes: 3000000, timeoutMs: 4000}};
// A third of a second and 1.5MB. Deliberately small: this one runs during a live class, and
// every byte of it is bandwidth the class does not get. Accuracy suffers — a short sample on
// a fast line understates it — but by this point the question is "has the line changed",
// which a rough figure answers.
export const SPEED_TEST_RECHECK = {budgetMs: 900, maxBytes: 1500000,
                                   uplink: {bytes: 1000000, timeoutMs: 2500}};
// Floor between tests, so a connection flapping across a quality boundary cannot put the
// class into a re-test loop.
export const SPEED_RECHECK_COOLDOWN_MS = 30000;
// Ceiling on staleness. A 5s cadence was asked for and is not affordable: even this 1.5MB
// probe every 5s is 18MB a minute, roughly a gigabyte an hour, spent telling the class how
// much bandwidth it has. Two minutes costs ~45MB an hour, and the age shown beside the
// figure covers the gap honestly rather than letting a stale number look live.
export const SPEED_IDLE_REFRESH_MS = 120000;
// Except while the ladder is held at 360p. Getting off that hold needs a measurement clear
// of the weak-line threshold, so a two-minute gap is up to two minutes of a class sitting at
// 360p on a connection that has already recovered. A minute is the compromise: often enough
// to notice the recovery, rare enough that a struggling line is not spending 1.5MB on the
// question every thirty seconds.
export const SPEED_WEAK_REFRESH_MS = 60000;
// One publisher heartbeat period (2s) plus room for a late first message, before the
// publishers map is treated as complete enough to start a class against.
export const PUBLISH_EVIDENCE_MS = 3000;
// A new reading this far below the previous one is called out rather than quietly swapped
// in, because the drop is the news, not the number.
export const SPEED_DROP_RATIO = 0.6;
// Ceiling on how long the player may keep running after the publish signal says the class
// has ended.
//
// The backend holds the tail of a finished stream fetchable for 30s after its encoder exits
// (HLS_ENDLIST_DRAIN_MS) and asks the client to play through to #EXT-X-ENDLIST rather than
// tear down the moment publishing stops. A viewer sits 12-16s behind the live edge and the
// publish heartbeat can take PUBLISHER_STALE_MS more to report the stop, so the drain has to
// outlast both. This is only the cap: a stream that reaches its ENDLIST ends on the video
// element's own `ended` well before it, and the cap is here so that a stream which never
// gets one cannot keep the "stream will start" placeholder hidden for the rest of the class.
export const DRAIN_CEILING_MS = 45000;
// How long a 'file is creating' report stands for before it stops counting as current.
//
// The flag it governs used to latch on the first report and be cleared only when publishing
// stopped, so a producer that quietly stopped being written left every viewer mounting a
// player over a dead playlist with nothing anywhere saying so. Read as a freshness window
// instead: the backend monitor polls every 6s, so this is three missed polls — long enough
// that an ordinary late report does not blink the player out, short enough that a stream
// which has really stopped stops being announced as live.
export const FILE_CREATING_STALE_MS = 20000;

// mediasoup's producer score is 0-10 off packet loss; five bars is the familiar shape.
export const scoreToBars = (score) => {
    if (!Number.isFinite(score)) return 0
    if (score >= 9) return 5
    if (score >= 7) return 4
    if (score >= 5) return 3
    if (score >= 3) return 2
    return 1
}

/**
 * One verdict, and — this is the part that was missing — what is causing it.
 *
 * Returns {level, cause}. level is good/fair/poor as before; cause names which of three
 * different faults is behind it, because they have three different remedies and only one
 * of them is the wifi:
 *
 *   'link'   — packets are being lost or delayed between here and the class.
 *   'uplink' — the link is fine, but the encoder is being given less than the rung it is
 *              publishing costs. Moving closer to the router does nothing for this.
 *   'cpu'    — the machine cannot encode fast enough. Nothing about the network at all.
 *   'ok'     — nothing to report.
 *
 * Collapsing all three into "your network connection is poor" is the bug this fixes: a
 * teacher on good wifi, whose uplink simply could not carry 720p, was told their internet
 * was bad and sent off to reset a router that was working perfectly.
 */
export const connectionQuality = ({lossPct = 0, rtt = null, score = null,
                                   limitedBy = null, estimateBps = null,
                                   rungCostBps = null, sendBps = null} = {}) => {
    // Loss and round trip, and nothing else. This is the only signal permitted to call
    // something a connection problem. Loss is weighted hardest because it is what actually
    // breaks the picture; RTT only counts once it is bad enough to disturb turn-taking.
    const linkLevel = (lossPct >= 8 || (rtt !== null && rtt > 1)) ? 'poor'
        : (lossPct >= 3 || (rtt !== null && rtt > 0.4)) ? 'fair'
        : 'good';

    // What the congestion controller will let this peer spend, against what the current
    // rung costs. libwebrtc's own word for it comes first when it has one.
    const hasEstimate = Number.isFinite(estimateBps) && estimateBps > 0;
    // Whether the encoder is actually pushing against what it has been allowed, and the
    // reason both inferred signals below are gated on it.
    //
    // availableOutgoingBitrate is not a measurement of the line. It is congestion control's
    // send-side estimate, and it is demand-driven: it grows only while something is pressing
    // against it, and settles a little above whatever is being sent once nothing is. A
    // whiteboard is near-static line art costing a couple of hundred kbps, so on a 30 Mbps
    // connection the estimate plateaus in the high hundreds and simply stays there — nothing
    // is wrong, and nothing has been limited.
    //
    // Comparing that plateau against what the stream nominally *may* spend is then comparing
    // a demand figure with a supply one. For a screen or a board, whose 1.5 Mbps ceiling is
    // a figure for moving video that static content never approaches, the two can never
    // agree, and the pill latched on "Upload limited" for the whole of a healthy class.
    //
    // Pressing says the two are comparable: we are sending about as much as we are allowed,
    // so an allowance below what we need is a real shortage. Three quarters, because the
    // pacer never runs the estimate exactly to the line.
    const pressing = hasEstimate && Number.isFinite(sendBps) && sendBps > 0
        && sendBps >= estimateBps * 0.75;
    const shortOfRung = pressing && Number.isFinite(rungCostBps) && rungCostBps > 0
        && estimateBps < rungCostBps * 0.8;
    // libwebrtc's own word needs no such gate: 'bandwidth' is the encoder reporting that it
    // wanted more and was refused, which is the thing `pressing` is inferring.
    const uplinkTight = limitedBy === 'bandwidth' || shortOfRung;
    // Below the bottom rung there is nothing left to step down to, so this is as poor as a
    // publishing connection gets — but it is still an upload fault, not a wifi one. Gated
    // the same way: a muted, camera-off peer sending nothing has a tiny estimate and no
    // problem at all.
    const uplinkFailing = pressing && estimateBps < VIDEO_LADDER[0].maxBitrate;
    const cpuTight = limitedBy === 'cpu';

    // mediasoup's producer score is advisory here, never decisive. It is derived from the
    // loss the server sees, so it says nothing the link signals above do not already say,
    // and letting it reach 'poor' on its own is what put the warning in front of teachers
    // whose connection was healthy. It may drag the verdict to 'fair'; no further.
    const scoreDrag = Number.isFinite(score) && score <= 7;

    const level = (linkLevel === 'poor' || uplinkFailing) ? 'poor'
        : (linkLevel === 'fair' || uplinkTight || cpuTight || scoreDrag) ? 'fair'
        : 'good';

    // Worst-actionable-first. A link that is losing packets is the story whatever else is
    // true; after that the encoder's own limiter is more specific than anything inferred.
    const cause = linkLevel !== 'good' ? 'link'
        : cpuTight ? 'cpu'
        : (uplinkTight || uplinkFailing) ? 'uplink'
        : level === 'good' ? 'ok'
        : 'link';

    return {level, cause}
}

// What the self-view chip shows for the mic: live level bars while it is open, the word
// while it is not. The bars used to stay put and just turn red when muted, which reads as
// "quiet room" rather than "you are muted" - and it disagreed with the pre-join chip,
// which has always spelled it out. Same shape before and after joining.
const MicChip = ({ muted, bars = 5 }) =>
  muted ? (
    <span className="bn-mute-tag">muted</span>
  ) : (
    <span className="bn-levels">
      {Array.from({ length: bars }, (_, index) => <i key={index} />)}
    </span>
  );

const DummyVideoView = forwardRef((props, ref) => {
    const [showControls,setShowControls] = useState(false);
    const makeFullScreen = () => {
        let div = ref.current
        if (div.requestFullscreen) 
            div.requestFullscreen();
        else if (div.webkitRequestFullscreen) 
            div.webkitRequestFullscreen();
        else if (div.msRequestFullScreen) 
          div.msRequestFullScreen();
      }
    return (
        <div style={{width:props.rightView?"70vw":"100vw", height:"96vh", position:"absolute", top:'2vh', left:0, bottom:'2vh', right:0}} className='r-c-c'>
        <div style={{position:"relative", width:"100%", height:"100%"}} className='r-c-c'>
        <video onClick={()=>{
          setShowControls(!showControls)
        }} ref={ref} autoPlay playsInline 
        controls={false} 
        muted={props.muted}
        style={{width:"100%", height:"100%", objectFit:"contain", visibility:props.visible!=undefined?props.visible?"visible":"hidden":"visible",  zIndex:!props.visible?0:1}}>
    
        </video>
                  {
                    showControls?
                  <div className="r-c-fe" style={{position:"absolute", bottom:5, height:40, width:"100%", background:"black", opacity:0.5, zIndex: 105}}>
                    <div style={{color:"white", opacity:1}} className='m-r-20 r-c-c cursor-pointer' onClick={makeFullScreen}><AiOutlineFullscreen style={{color:"white", fontSize:25, color:"white", opacity:1}}/></div>
                  </div>
                    :null
                    }
                    </div>
        </div>
    )
})


const SubjectInfo = ({subjectname, standardNames})=>{
    return (
        <div className='disable-text-selection'>
            <div className="black" style={{fontSize:14, fontWeight:'600'}}>
                {subjectname}
            </div>
            <div className="black opacity50" style={{fontSize:11}}>
                {standardNames&&standardNames.length>0
                ?
                standardNames?.map((standardName, index)=>(
                    <>
                        <> { index != 0 ? <>•</> : null} </>
                        <> { standardName} </>
                    </>
                ))
                :
                null
                }
            </div>
        </div>
    )
}




const TopRow = ({setRightViewType, userCount, setRightView, 
        rightView, rightViewType, broadcastSelectedClass, 
        isPublishing, onMenuClick, isMenuVisible, isRecordingState,
        recordTimer, isInternetSlow
        })=>{
    const RecordInfo = ({timeleft})=>{
        const displayTime = parseInt(timeleft/3600).toString().padStart(2, '0')+' : '+parseInt((timeleft%3600)/60).toString().padStart(2, '0')+' : '+`${timeleft%60}`.padStart(2, '0')
        return (
            <div className="r-ac topRowCards p-l-15 p-r-15 m-r-20 disable-text-selection">
                    <div className="recRed bold-900 liveBlink m-r-5" style={{fontSize:12}}> REC • </div>
                    <div className="white bold" style={{fontSize:12}}> {displayTime} </div>
            </div>
        )
    }
    const ParticipantInfo = ()=>{
        return (
            <div className="topRowCards r-c-c cursor-pointer recBtn disable-text-selection" style={{width:60, height:30}} onClick={()=>{
                if ((rightView==false)||(rightViewType=='')){
                    setRightView(true);
                    setRightViewType('participantsView');
    
                }
                else{
                    if (rightViewType=='participantsView'){
                        setRightView(false); 
                    }
                    else{
                    setRightViewType('participantsView');}
                }
            }}>
                <div className="r-c-c m-r-10"> 
                    <img style={{height:20, width:20}}  src={require('./assets/Group 11815.svg').default} alt="" />
                </div>
                <div className="white" style={{fontSize:11}}> {userCount} </div>
            </div>
        )
    }
    const MenuButton = () => (
        <div className='topRowCards r-c-c m-l-10 cursor-pointer recBtn disable-text-selection'  style={{width:60, height:30,borderRadius:5, zIndex:10}} onClick={onMenuClick}>
        <div style={{fontSize:11, color:"white"}}>        
        {isMenuVisible?"Hide":'Menu'}</div>
        </div>
    )
    const SlowInternetWarning = () => (
        <>
        {
        isPublishing!=0 && isInternetSlow?
        <div className='r-c-fs disable-text-selection'  style={{backgroundColor: isInternetSlow?'#FF6347':'#006A4E', paddingTop:5, paddingBottom:5, paddingLeft:10, zIndex:1500}}>
            <div className="r-c-c m-r-10"> 
                {   isInternetSlow? 
                    <Loader style={{fontSize:16, color:"white"}}/>
                    :
                    <MdNetworkWifi style={{ color:"white", fontSize:20}}/>
                }
            </div>
        <div style={{fontSize:11, color:"white", fontWeight:"bold"}}>        
            {isInternetSlow ?"Your network connection is poor!":'High'}
        </div>
        </div>
        :null
        }
        </>
    )
    return(
        <>

        {/*isPublishing!=0 && isInternetSlow?
                <SlowInternetWarning/>
            :null
        */}

            <div className={`${isMenuVisible?'r-jsb':'r-c-fe'} p-20 absolute`} style={{top:10, width:rightView==false?"100%":"75%", zIndex: 105}}>
                {
                    isMenuVisible?
                    <>
                    <div>
                    <SubjectInfo subjectname={broadcastSelectedClass && broadcastSelectedClass.subject?.name} 
                                 standardNames={ (broadcastSelectedClass&&broadcastSelectedClass.standards?.length>0) && [...broadcastSelectedClass.standards?.map((standard, index)=>{return `${standard.std} ${standard.section}`})]}
                                    />
                    </div>
                    <div className="display-flex" style={{zIndex:105}}>
                        {
                            isPublishing==2 && isRecordingState===2?
                            <RecordInfo timeleft={recordTimer}/>
                            :null
                        }
                        <ParticipantInfo />
                        <MenuButton/>
                    </div>
                    </>
                    :
                    <div className="display-flex" style={{zIndex:105}}>
                        <MenuButton/>
                    </div>
                }

            </div>
        </>
    )
}

const VideoBoxRow = ({rightView, streamId, ifAnyOnePublishing, onStreamEnded, playerKey, reloadToggler, toggleReloader, isMenuVisible, activeClass, mediaRef})=>{
    return(
        <div style={{position:"absolute", top:0, bottom:0, left:0, right:0}}>
                {
            /* The player fills 100% of the stage, not of the window. These were viewport
               heights - 100vh, or 60vh with the menu open - from the layout where the
               stream really did own the whole page. The stage is now an inset tile a good
               deal shorter than the viewport, and .r-c-c centres rather than stretches, so
               a 100vh child kept its full height, overflowed the tile top and bottom, and
               was clipped: what survived was the small letterboxed middle. */
            ifAnyOnePublishing?
            <div style={{width:"100%", height:"100%"}} className='r-c-c'>
            <VideoPlayer key={playerKey}
                         streamId={streamId}
                         contentId={activeClass?.occurance?.id}
                         onEnded={onStreamEnded}
                         /* so the class can measure the audio it is already playing — see
                            captureRemoteAudio. Optional: the player owns its own ref when
                            nothing is passed. */
                         mediaRef={mediaRef}
                         style={{width:"100%", height:"100%"}}/>
            </div>
            :
            <div style={{height:"100%", width:"100%"}} className="r-c-c">
            <div style={{fontSize:30, textAlign:"center", width:300, fontFamily:"sans-serif", color:"white"}}>Stream will start playing automatically when it's live</div>
            </div>
                }
        </div>
    )
}

let roomClient = null;

const ShareScreenPopover = ({onShareClick, setPopover}) => {
    return (
    <div style={{color:"white"}}>
        <div className="r-c-fs m-b-10 cursor-pointer" onClick={()=>{
            shareType = 'screen'
            onShareClick();
            setPopover(false);
        }}>
            <div className="m-r-10">
                <PiProjectorScreenChartFill/>
            </div>
            <div>
                Whiteboard
            </div>
        </div>
        <div className="r-c-fs m-b-10 cursor-pointer" onClick={()=>{
            shareType = 'camera'
            onShareClick();
            setPopover(false);
        }}>
            <div className="m-r-10">
                <BsFillCameraReelsFill/>
            </div>
            <div>
                Camera
            </div>
        </div>
    </div>)
}
const ActionBoxRow = ({adapter, chat, sessionuser, isPublishing, onShareClick, ifAnyOnePublishing, 
    chatClient, onMicClick, onCameraClick, streamId, onLeave, onParticipantsClick, isCamOn, 
    micIsMuted, onPrivateChatClick, onGroupChatClick, popover, setPopover, whiteboard, setWhiteboard,
    onRecordClick, isRecordingState, groupUnreadCount, privateUnreadCount, onlineCount}) =>{
    const Wrapper = (props) => {
        if (isPublishing===0){
            return (
                <Popover open={popover} color={"#3e3e3e"} content={<ShareScreenPopover onShareClick={onShareClick} setPopover={setPopover}/>} title={null} trigger="click" onOpenChange={setPopover} style={{zIndex:10}}>
                    {props.children}
                </Popover>
            )
        }else{
            return (
                <>
                {props.children}
                </>
            )
        }
    }
    return(
        <div className="r-jc">
            <div id="broadcastButtonRow" className="r-c-sa absolute" style={{bottom:20, zIndex: 105}}>
            {!sessionuser.access.includes("schedule-student")
                ?
                <>
                
                <ActionButtons label={'Participants'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11815.svg').default} alt="" />}  
                                onClick={onParticipantsClick}
                                unreadCount={onlineCount}
                                badgeStyle={{backgroundColor:"green"}}/>
                <ActionButtons label={'Private Chat'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11867.svg').default} alt="" />} 
                                onClick={onPrivateChatClick}
                                unreadCount={privateUnreadCount}/>
                <ActionButtons label={'Group Chat'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11830.svg').default} alt="" />} 
                                onClick={onGroupChatClick}
                                unreadCount={groupUnreadCount}/>
                {
                    shareType==='screen' && isPublishing===2?
                    <ActionButtons label={isCamOn?'Camera on':'Camera off'} 
                    icon={
                        <>{isCamOn?<BsCameraVideoFill color="white" style={{height:"40%", width:"40%"}}/>
                            :<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11810.svg').default} alt="" />
                        }</>} 
                    onClick={onCameraClick}/>
                    :null
                }
                {  shareType==='camera' && isPublishing===2?
                    <ActionButtons label={whiteboard?'Camera':'Whiteboard'}
                    icon={<AiFillSwitcher color="white" />} onClick={()=>{setWhiteboard(!whiteboard)}}/>
                    :null
                }
                {
                    isPublishing===2?
                    <ActionButtons label={micIsMuted?'Mic off':'Mic on'}
                                    type={'mic'}
                                    icon={
                                        <> {micIsMuted
                                            ?
                                                <img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11818.svg').default} alt="" />
                                            :
                                                <img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11777.svg').default} alt="" />
                                            }
                                        </>}
                                    onClick={onMicClick}/>
                    :null
                }
                    <Wrapper>
                        <ActionButtons label={isPublishing===2?'Stop sharing':'Share'} 
                                        icon={
                                            <> {
                                                isPublishing==2?
                                                <MdStopScreenShare color={"white"} size={10}/>
                                                :isPublishing==1?
                                                <Loader style={{fontSize:10}}/>
                                                :
                                                <img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group11903.svg').default} alt="" />
                                                }
                                            </>} 
                                        onClick={()=>{
                                            if (isPublishing===0){
                                                setPopover(!popover)
                                            }else if(isPublishing===2){
                                                onShareClick()
                                            }
                                        }}/>
                    </Wrapper>
                    <ActionButtons label={'Leave'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Icon metro-phone.svg').default} alt="" />} 
                                onClick={onLeave}/>
                    {
                        isPublishing===2?
                        <ActionButtons label={isRecordingState===2?'Stop recording':isRecordingState===0?'Start recording':''} 
                        icon={
                            <> {
                                isRecordingState==2?
                                <BsFillRecord2Fill color={"red"} size={30}/>
                                :isRecordingState==1?
                                <Loader style={{fontSize:10}}/>
                                :
                                <div className="bold-900 rfbc0p8" style={{backgroundColor:"red", borderRadius:10, padding:2}}>REC</div>
                                }
                            </>} 
                        onClick={onRecordClick}/>
                        :null
                    }
                </>
                :
                <>
                <ActionButtons label={'Group Chat'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11830.svg').default} alt="" />} 
                                onClick={onGroupChatClick}
                                unreadCount={groupUnreadCount}/>
                <ActionButtons label={'Leave'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Icon metro-phone.svg').default} alt="" />} 
                                onClick={onLeave}/>
                <ActionButtons label={'Private Chat'} 
                                icon={<img style={{height:"40%", width:"40%"}}  src={require('./localComponent/assets/Group 11867.svg').default} alt="" />} 
                                onClick={onPrivateChatClick}
                                unreadCount={privateUnreadCount}/>
                </>
                }
            </div>
        </div>
    )
}
const ChatBoxColumn = ({}) => {
    return(
        <div>

        </div>
    )
}
function useMemoizeArgs(args) {
    const ref = useRef();
    const prevArgs = ref.current;
    const argsAreEqual =
          prevArgs !== undefined && JSON.stringify(args)===JSON.stringify(prevArgs)
    useEffect(() => {
        if (!argsAreEqual) {
          ref.current = args;
        }
    });
    return argsAreEqual ? prevArgs : args;
  }
let intervalId=null;
let t1 = null
let broadcastHealthTimer = null;

// The camera-off stage: initials, wrapped in the layers the speaking wave is painted on.
// The three <i> carry no content — they exist because the effect needs three independently
// timed shapes and pseudo-elements only give two. Everything else about them is CSS,
// driven by the --bn-mic that useMicLevel writes on the shell.
const StageAvatar = ({initials}) => (
    <div className="bn-stage-avatar">
        <span className="bn-wave" aria-hidden="true"><i/><i/><i/></span>
        <div className="bn-stage-initials">{initials}</div>
    </div>
);

function Broadcast({rightView, setRightViewType, setMuteState, 
                    setCameraState, clearGroupChat, isCamOn, 
                    userCount, updateUserCount, updateUserList, 
                    addMessageToGroup, sessionuser, setUserType, userType, setRightView, 
                    rightViewType,streamId, addMessageToPrivate, broadcastSelectedClass, 
                    history, broadcastStudentsList, postChat, postChatImage, broadcastLoader, setStreamId,
                    micIsMuted, clearPrivateChat,
                    activeClass, getVideoResourceSections, postRecordedVideoLesson,
                    sectionList, recordCount, postRecordCount, getRoomData, updateUnreadCount, unreadCount,
                    usersList, BroadcastRecordingEdit, setLocalRecordingName, localRecordingName, cardData,
                    postCreateTopic, startPrefs, onEndClass, orgData, setCurrentPrivateChatReciever,
                    groupMessages, privateMessages, currentPrivateChatReciever, postMessageOpenStatus,
                    getStorageDetails
                }){
    const [inc, setInc] = useState(0);
    const isStudentUser = !!sessionuser?.access?.includes('schedule-student');
    // Header label for the new live chrome: "<subject> · <batches>", the same fields the
    // old SubjectInfo card read.
    const classTitle = useMemo(()=>{
        const subject = broadcastSelectedClass?.subject?.name
        const batches = broadcastSelectedClass?.standards?.length
            ? broadcastSelectedClass.standards.map((standard)=>`${standard.std??''} ${standard.section??''}`.trim()).filter(Boolean).join(', ')
            : broadcastSelectedClass?.batchName
        return [subject, batches].filter(Boolean).join(' · ') || 'Live class'
    }, [broadcastSelectedClass]);
    // Badge for that same header line. icon is a bare S3 key, as everywhere else subjects
    // are drawn; initial is the fallback, trimmed because subject names come back with
    // leading spaces often enough that charAt(0) alone renders a blank square.
    const subjectBadge = useMemo(()=>{
        const subject = broadcastSelectedClass?.subject
        return {
            icon: subject?.icon ? `${Api._s3_url}${subject.icon}` : '',
            initial: (subject?.name ?? '').trim().charAt(0).toUpperCase() || 'C',
        }
    }, [broadcastSelectedClass]);
    const callTimestampsRef = useRef([]);
    const processIdRef = useRef('0');
    // Every processId this tab has minted for the CURRENT publish.
    //
    // A reconnect mints a new one (roomClient.js — a uuidv4 per audio producer) and the
    // backend monitor is a 6s poll, so its "file is creating" for the previous id routinely
    // lands after the next id already exists. Matching processIdRef alone therefore dropped
    // exactly the reports that prove the playlist is being written: in a room churning
    // through reconnects the flag never latched, the 2s heartbeat carried fileCreating false
    // for the whole class, and every web viewer sat on the "stream will start" placeholder
    // while a mobile viewer — which does not read this gate — played the same playlist.
    //
    // A set rather than a comparison because uuids carry no ordering; there is no reading of
    // the value that says which of two ids is newer. The set is the ordering. What the guard
    // is really for is ignoring *other peers'* processIds, and this still does that.
    const processIdsRef = useRef(new Set());
    // When a 'file is creating' last landed, rather than merely that one once did. See
    // FILE_CREATING_STALE_MS and isFileCreatingNow below.
    const fileCreatingAtRef = useRef(0);
    const [isRecordModalVisible, setRecordModalVisible] = useState(false);
    // Library storage gate for recording. A recording's size cannot be known before the
    // class is over, so the rule is only ever "is there any space left at all": the class
    // that takes the library past its quota is allowed to finish and transcode, and it is
    // the NEXT REC press that gets stopped. Raises the same AulasSubscriptionModal the
    // upload flows use.
    const [isStorageModalVisible, setStorageModalVisible] = useState(false);
    const [storageAvailableBytes, setStorageAvailableBytes] = useState(0);
    const storageCheckRef = useRef(false);
    // Set once the pre-join recording choice has been written into state, so the confirm
    // below runs on the next render instead of against a stale closure.
    const [recordPrefsSeeded, setRecordPrefsSeeded] = useState(false);

    // Nothing but a re-render tells the pre-join effect to look again for the producers it
    // needs, and they appear without any state of their own moving. This is that re-render.
    const [producerWaitTick, setProducerWaitTick] = useState(0);
    // Live on the mic alone: no camera, no screen, no whiteboard. The roomClient event
    // handlers read the ref (they close over the first render); the bar and the stage read
    // the state.
    const audioOnlyRef = useRef(false);
    const [audioOnly, setAudioOnly] = useState(false);
    const setAudioOnlyMode = (value) => {
        audioOnlyRef.current = value;
        setAudioOnly(value);
    }
    // shareType is module-level so the roomClient event handlers, which close over the first
    // render, can read what is being published without a stale copy. The cost is that
    // assigning it does not re-render, and the control bar's share button now reads off it —
    // so mirror it into state and let every assignment in the component go through here.
    const [shareMode, setShareMode] = useState(shareType);
    const setShareTypeMode = (value) => {
        shareType = value;
        setShareMode(value);
    }
    // A screen swap is a getDisplayMedia picker plus a replaceTrack, and both take long
    // enough for a second click to land in the middle of them. The ref is the re-entrancy
    // guard, the state is what greys the button out.
    const swappingShareRef = useRef(false);
    const [shareSwapping, setShareSwapping] = useState(false);
    const setSwappingShare = (value) => {
        swappingShareRef.current = value;
        setShareSwapping(value);
    }
    const [isAccessModalVisible, setAccessModalVisible] = useState(false);
    const [isRecordDownloadModalVisible, setRecordDownloadModalVisible] = useState(false);
    const isRecording = useRef(0);
    const [isInternetSlow, setIsInternetSlow] = useState(false);
    // Live connection picture from roomClient's network monitor: bitrate now, bytes for the
    // session, round-trip time and packet loss. Null until the first 2s sample lands.
    const [netStats, setNetStats] = useState(null);
    // Rung the adaptive ladder currently has the camera on: {rung, label, ceiling, reason}.
    // Null until the controller moves off the rung it started on — there is nothing to
    // report while it is simply holding where it began.
    const [videoRung, setVideoRung] = useState(null);
    // What the quality menu is set to: a ladder index, or null for Auto. Held here rather
    // than read back off roomClient so the menu updates on the click instead of waiting for
    // the round trip that changes the layers.
    const [videoQuality, setVideoQuality] = useState(null);
    // How many times a sustained-trouble report has arrived while holding a quality the line
    // cannot carry. One asks, two acts — see escalateWeakNetwork.
    const weakStrikesRef = useRef(0);
    // The pending "not recommended" question: {rung, ceiling}, or null.
    const [qualityWarning, setQualityWarning] = useState(null);
    // ---- publisher-side quality menu: withdrawn --------------------------------------
    // The control-bar quality picker, and the spatial-layer switching behind it, are the part
    // of the new broadcast implementation that correlates with the audio breaking up. The
    // evidence that settled it is that pinning a quality from the OTHER menu — the one on the
    // player overlay, which predates this work — clears the alien sound immediately and it
    // returns a moment later. That menu changes the .m3u8 URL, which re-initialises hls.js
    // and hands the page a fresh MediaSource. So the fault accumulates in the player's buffer
    // and is cleared by a restart, which is what a run of broken presentation timestamps
    // looks like, and every layer switch this menu makes is a chance to produce one.
    //
    // Withdrawn rather than deleted: setVideoQuality, the ladder, the controller and the menu
    // component are all still here and still work. Restoring this is passing
    // onVideoQualityChange back to LiveControlBar and putting the body of this function back.
    // Worth doing only once the transcoder tolerates a mid-stream resolution change, or once
    // consumers take WebRTC directly and no ffmpeg sits in the path at all.
    //
    // Nothing is lost to viewers meanwhile: the backend already publishes 360/480/720 as
    // separate renditions, and the player-overlay menu — the one that has always been there —
    // is how a student picks between them.
    const applyVideoQuality = useCallback((rung)=>{
        setVideoQuality(rung)
        weakStrikesRef.current = 0
        // roomClient?.setVideoQuality?.(rung)   // ← re-enable with the menu
    }, [])
    // What the line is measured to carry right now, or null when nothing has been measured.
    // A fallback is not evidence: rungForSpeed answers 480p when it has nothing to go on, and
    // contradicting someone's choice on the strength of that would be wrong on a line that is
    // in fact fine.
    const lineCeilingRung = () => {
        const bps = lineSpeedRef.current
        return Number.isFinite(bps) && bps>0 ? rungForSpeed(bps) : null
    }
    const onVideoQualityChange = useCallback((rung)=>{
        const ceiling = lineCeilingRung()
        // Asking for more than the line carries is allowed — setVideoQuality never clamps an
        // explicit pick — but it should be chosen knowingly. Left silent, the menu reads 720p
        // while the class receives less, and nothing on screen says why. Auto never comes
        // here: the controller asks for no more than the line affords.
        if (rung!==null && ceiling!==null && rung>ceiling){
            setQualityWarning({rung, ceiling})
            return
        }
        applyVideoQuality(rung)
    }, [applyVideoQuality])
    // Assigned during render so the roomClient event handler, which closes over the first
    // one, calls a version that can still see the current camera and quality state.
    const escalateWeakNetworkRef = useRef(null);
    // Raised by the ABR controller once most of the last half minute has been spent in
    // trouble with a real picture going out: {lossPct, lineSpeedBps, label, limitedBy,
    // strainedPct}, or null when there is nothing to ask. The camera is the largest thing on
    // the wire and the most expendable, so the offer is to drop it — but it stays an offer.
    // A class where the teacher is demonstrating something is a class where the video is the
    // lesson, and turning it off unasked would be the client deciding that for them.
    const [weakNetworkPrompt, setWeakNetworkPrompt] = useState(null);

    // userId -> {audio, video} mediasoup producer scores, 0-10. Everyone publishing in the
    // room, so a student can see the teacher's uplink health and not just their own.
    const [producerScores, setProducerScores] = useState({});
    // The monitor keeps the authoritative byte totals; this ref lets the leave path read
    // them without waiting for a render.
    const netTotalsRef = useRef({bytesSent: 0, bytesReceived: 0});
    // Last measured line speed. Declared here rather than beside the speed-test state that
    // writes it, because the RoomClient constructor further up the body reads it on handover
    // and a const declared below that point would still be in its temporal dead zone.
    const lineSpeedRef = useRef(null);
    // What is being published right now, refreshed on every render and read by the 2s
    // consumption tick. A ref rather than the state itself because shareType is a
    // module-level variable that changes without causing a render, so an effect keyed on
    // state would miss a camera -> screen switch until something else re-rendered.
    const publishModeRef = useRef({});
    // Wall-clock time in the room, for the LIVE consumption entry. Set on mount rather than
    // on publish: a student's whole time in the class counts, and they never publish.
    const joinedAtRef = useRef(Date.now());
    const [isRecordingState, setRecording] = useState(0);
    const [isPublishing, setPublishing] = useState(0);
    // Root for the speaking indicator. useMicLevel writes the live mic level onto this
    // element as --bn-mic and toggles .bn-speaking / .bn-mic-live on it; every part of the
    // indicator — the halo around the stage avatar, the rim on the camera tile, the bars in
    // the name chips — inherits from here, so they all move off one measurement.
    const micRootRef = useRef(null);
    // Only while actually publishing and unmuted. mute() pauses the producer, which sets
    // track.enabled = false, so the analyser would read a flat line anyway — but gating it
    // here also releases the AudioContext, and browsers cap how many a page may hold.
    useMicLevel(micRootRef, () => {
        const producerId = roomClient?.producerLabel?.get('audioType');
        return producerId ? roomClient?.allTracks?.get(producerId) : null;
    }, isPublishing===2 && !micIsMuted);
    const isPublishingRef = useRef(0);
    const [publishers, setPublishers] = useState({});
    // userId -> whether that publisher has their mic muted, as they last announced it, or
    // undefined where they have not said. See the micMuted field on the publish heartbeat.
    const [publisherMic, setPublisherMic] = useState({});
    // TEMP DIAGNOSTIC (safe to remove). Last mute reading printed, so the 2s heartbeat does
    // not fill the console — see [BN-DIAG rx].
    const micDiagRef = useRef('');
    // The <video> playing the remote publisher's HLS stream, handed up by VideoPlayer. The
    // level meter for a remote teacher is measured off it — see the second useMicLevel below.
    const remoteMediaRef = useRef(null);
    const eventListeners = useRef(null);
    const [connecting, setConnecting] = useState(sessionuser?.role?.includes('Student')?false:true);
    // Whether this peer has been in the room long enough to know who else is publishing.
    //
    // The only evidence is the 2s Event heartbeat every non-student sends, so a teacher who
    // joins into a class that is already live knows nothing for the first couple of seconds -
    // publishers is empty and ifAnyOnePublishing answers false. That is long enough for the
    // pre-join auto-start to sail straight past the one-publisher check and go live alongside
    // the teacher already sharing, which is how two people ended up publishing without either
    // of them clicking Share. One heartbeat round plus a margin, then the map can be trusted.
    // Only the automatic start waits: a click happens long after this, and is never delayed.
    const [publishEvidenceReady, setPublishEvidenceReady] = useState(false);
    useEffect(()=>{
        if (connecting) return undefined
        const id = setTimeout(()=>setPublishEvidenceReady(true), PUBLISH_EVIDENCE_MS)
        return ()=>clearTimeout(id)
    }, [connecting]);
    // Set when the join sequence has not reported back in time, so the screen can say so
    // instead of spinning indefinitely.
    const [connectFailed, setConnectFailed] = useState(false);
    const [whiteboard, setWhiteboard] = useState(false);
    const [isMenuVisible, setMenuVisible] = useState(true);
    const isFileCreatingRef = useRef(false);
    const [loadplayer, setloadplayer] = useState(false);
    const localVideoRef = useRef(null);
    const videoStreamRef = useRef(null)
    const ispublishingmanually = useRef(true);
    const ismanuallystoppingrecording = useRef(false);
    const ismanuallystoppedproducing = useRef(false);
    // Which button owns the Starting…/Stopping… spinner while the publish is in between. The
    // bar used to hang that on the share button unconditionally, because the share button was
    // once the publish switch — so turning off the last of mic and camera lit "Stopping…" on
    // a screen share that was never running, on a button the teacher had not touched. The
    // publish still comes down exactly as before; only the button reporting it changes.
    //
    // A click is a *claim*, not the answer: most clicks move nothing (muting a mic with the
    // camera still on), and the claim would then sit there until some later reconnect wore it
    // as its own. So the claim is timestamped and only cashed in if the publish actually
    // starts moving shortly after, and it is read once — when isPublishing enters 1 — and
    // held for the whole transition rather than re-evaluated on every render underneath it.
    // Null means nobody claimed it (an auto reconnect, the pre-join start), and the share
    // button reports those exactly as it does today.
    const transitionClaimRef = useRef(null);
    const [transitionOwner, setTransitionOwner] = useState(null);
    /*
     * Which way the publish is moving while isPublishing sits at 1 — the only thing that
     * decides whether the spinner says Starting… or Stopping….
     *
     * The bar used to read ismanuallystoppedproducing for this, and that flag does not mean
     * what its name says. It means "this transition is ours rather than something that
     * happened to us", and it is set on the way *up* as well as the way down: rtmpStarted
     * reads it to bring a fresh publish up unmuted, audioAdded reads it to take a new
     * capture instead of reusing a track, and the reconnect guards read it to stay out of
     * the way of a deliberate change. onShareClick sets it before it has even looked at
     * which branch it is taking.
     *
     * So a class starting from the lobby with its camera on set it, entered isPublishing 1,
     * and spent the whole of its start-up telling the teacher it was "Stopping…" — on the
     * share button, which nobody had pressed. Said separately here, there is nothing left to
     * misread.
     */
    const transitionKindRef = useRef('start');
    /*
     * The lobby asked for something to go live, and it has not been acted on yet.
     *
     * The automatic start is deliberately not immediate: it waits PUBLISH_EVIDENCE_MS after
     * the join so the heartbeat has had a round to say whether another teacher already holds
     * the room (see publishEvidenceReady). For those three seconds isPublishing is still 0,
     * so the bar rendered its full idle state — every control live, the camera button
     * reading "Camera off" — for a teacher who had switched their camera on one screen
     * earlier and was watching for it to appear. Three seconds is long enough to press
     * something, and pressing anything there raced the start that was already coming.
     *
     * Holding the intent in state rather than inferring it from startPrefs on every render
     * is what lets the bar show the wait as a wait: this is the control the lobby chose, and
     * the bar spins that one until the publish either starts or is called off. Cleared by
     * the startPrefs effect on every path out of it, including the ones that decide not to
     * publish at all.
     */
    const [pendingStartControl, setPendingStartControl] = useState(
        () => (startPrefs?.camOn ? 'camera' : startPrefs?.micOn ? 'mic' : null));
    // Generous enough to cover a camera swap settling before the teardown lands, short
    // enough that a click from earlier in the class can never claim a later reconnect.
    const TRANSITION_CLAIM_MS = 5000;
    const claimTransition = (control) => {
        transitionClaimRef.current = {control, at: Date.now()};
    };
    // True only for the lifetime of an auto reconnect (throttledReconnect ->
    // reconnectProducer). Kept separate from ismanuallystoppedproducing, which also drives
    // audioAdded's "fresh camera capture vs reuse the existing track" choice and
    // rtmpStarted's "force unmuted vs respect the previous mic mute state" choice (see those
    // handlers) -- a normal reconnect should reuse the track and keep whatever mute state the
    // user had, not behave like the trackEnded device-swap case. This ref exists only so
    // rtmpRemoved/consumererror/fileNotCreating/fileEndCreating can recognise "this is our
    // own reconnectProducer teardown echoing back" and not fire another reconnect over it.
    const isAutoReconnectingRef = useRef(false);
    // Bumped each time a reconnect starts; a delayed grace-period timeout only clears
    // isAutoReconnectingRef if it's still the one that scheduled it (see throttledReconnect).
    const reconnectGraceTokenRef = useRef(0);
    const [popover, setPopover] = useState(false);
    const [shareModalStep, setShareModalStep] = useState(null); // null | 'pick'
    // Why the screen is being asked for. The dialog serves two flows now: the whiteboard is
    // only visible to students through a screen capture, and an online recording is built on
    // the RTMP link the backend raises around the screen producer. Same dialog, different
    // words, and a different thing to do once the share is live.
    // Only 'record' reaches this dialog now. The whiteboard used to need it too — it was the
    // click getDisplayMedia wanted before it would open its picker — but the board publishes
    // its own canvas and asks the browser for nothing, so it no longer comes here at all.
    // An online recording still genuinely needs a screen, and a screen still needs the picker.
    const [shareModalReason, setShareModalReason] = useState('record'); // 'record'
    // The record choice that is waiting on that share, replayed once a screen producer exists.
    const pendingRecordRef = useRef(null);
    const afterScreenShareRef = useRef(null);
    // The roomClient event handler is built on the first render and keeps that closure for
    // the life of the room, so the browser's own "Stop sharing" bar reaches the current
    // stopScreenShare through here rather than the one from render zero.
    const stopScreenShareRef = useRef(null);
    const stopWatchdogRef = useRef(null);
    const [selectedSection, setSelectedSection] = useState({name:''});
    // One {standardId, chapterId, chapterName, topicId, topicName} entry per batch this
    // class spans — a single Broadcast occurrence can be taught to multiple standards at
    // once (see RecordingModal), so a single chapter/topic pair isn't enough.
    const [recordingBatches, setRecordingBatches] = useState([]);
    const [recordTimer, setRecordTimer] = useState(0); 
    const isAttemptingRecord = useRef(false);
    const isAttemptingShare = useRef(false);
    const micStateRef = useRef(null);
    const leaveClickedRef = useRef(false);
    const isOfflineRecordingRef = useRef(true);
    // Switching what is being shared (camera -> whiteboard, whiteboard -> screen) is a full
    // stop and restart of the publish. A recording is not meant to end there, so it is
    // remembered across the gap and re-armed on the new producer once it is up.
    // The publish now starting is for the whiteboard, so its video producer has to be built
    // from the board's canvas rather than from a camera or the screen picker. Read in the
    // 'audioAdded' handler, which is where the video half of a publish gets produced, and
    // cleared when the publish ends — a stale true here would put the board on the wire for
    // the next class the teacher started with their camera.
    const boardIntentRef = useRef(false);
    // Whether the camera was on before a share switch, so it can be put back afterwards.
    const cameraWasOnRef = useRef(false);
    // And whether a recording was running, for the same reason. While this is set the
    // download modal is held back too: the class is not over, the chunks are not final, and
    // asking to save a half class in the middle of a switch is what made it look like the
    // recording had been lost.
    //
    // Nothing arms it any more. Switching what is shared no longer stops anything to do it —
    // the screen goes onto the producer that is already live and continueLocalRecording
    // carries the recording across the track change in place, so there is no gap for a
    // recording to be remembered across. Kept for the teardown paths that remain (a publish
    // that was only ever a screen share, ending when its capture does), where the flag being
    // false is the right answer: that recording really has ended and should be offered.
    const recordingWasOnRef = useRef(false);
    // Server-side recordings come back through rtmpRecordStarted, which cannot tell a brand
    // new recording from one being picked up again and so resets the clock in the header to
    // 00:00. That is the "it starts from zero" a teacher sees after opening the whiteboard:
    // the recording did carry on, but the only thing on screen saying so said otherwise. Set
    // just before a resume so that one event keeps the clock running, and cleared as it is
    // consumed, since the next start really is a new recording.
    const keepRecordTimerRef = useRef(false);
    const recordFileNameRef = useRef(null);
    useEffect(()=>{
        micStateRef.current = micIsMuted
    }, [micIsMuted]);
    useEffect(()=>{
        if (isPublishing!=2){
            isFileCreatingRef.current = false
            // The ids belonged to the publish that is ending. Kept in step with the flag so
            // a report arriving from the previous publish cannot re-latch it, and so the set
            // cannot grow across a whole session. processIdGenerated repopulates it: the
            // publish goes to 1 before produce() is called, so the wipe always lands first.
            fileCreatingAtRef.current = 0
            processIdsRef.current = new Set()
            if (isPublishing==0){
                setShareTypeMode('screen')
                boardIntentRef.current = false
                // The board is only ever open because something is being published through
                // it. A publish that failed on the way up, or one that has just come down,
                // leaves it drawn over a dead stage otherwise.
                setWhiteboard(false)
                audioOnlyRef.current = false
                setAudioOnly(false)
                // The producer and its track are gone; leaving isCamOn true renders a
                // <video> pointed at a stopped stream, which is the black tile with the
                // camera light off that looks like the camera is broken.
                setCameraState(false)
                videoStreamRef.current = null
                roomClient?.stopcamera();
                setMuteState(true)
                isAttemptingShare.current = false
            }
        }else if(isPublishing===2){
            if (isRecording.current===2 && ispublishingmanually.current===false){
                throttledRecordingReconnect.current();
            }
            // Camera on before the switch means camera on after it. In screen mode the
            // camera is a separate overlay stream, so it has to be asked for again.
            if (cameraWasOnRef.current){
                cameraWasOnRef.current = false
                // Both modes where the camera is the overlay rather than the thing on the
                // wire: it has to be asked for again as its own capture.
                if (shareType==='screen' || shareType==='board'){
                    roomClient.opencamera();
                }
            }
        }
    }, [isPublishing])

    useEffect(()=>{
        if (isRecordingState===0){
            isAttemptingRecord.current = false
            return undefined
        }
        if (isRecordingState!==1) return undefined
        // Same problem on the recording side: without rtmpRecordStarted coming back the REC
        // pill spins indefinitely. Fail visibly so the switch can be tried again.
        const timer = setTimeout(()=>{
            if (isRecording.current!==1) return
            isRecording.current = 0
            setRecording(0)
            Notification.error("", "Recording could not be started. Try the REC switch again")
        }, 25000)
        return ()=>clearTimeout(timer)
    }, [isRecordingState]);

    // roomClient emits connectionCompleted at the end of the join sequence. If any step
    // before it throws, nothing else ever clears connecting, and the class sat on a bare
    // spinner with no message.
    useEffect(()=>{
        if (!connecting) {
            setConnectFailed(false)
            return undefined
        }
        const timer = setTimeout(()=>{
            setConnectFailed(true)
            Notification.error("", "Could not connect to the class. Check your connection and try again")
        }, 30000)
        return ()=>clearTimeout(timer)
    }, [connecting]);

    const [start, stop] = useInterval(()=>{
        if (isRecording.current===2){
            setRecordTimer(recordTimer+1)
        }
    }, 1000);
    const audioVideoNotification = (audioelement, text="Error") => {
        if (window.location.pathname==='/broadcast'){
            Notification.error("", text)
            audioelement.play();
        }
    }
    const throttledReconnect = useRef(Utils.throttleHigh((stopTrack) => {
        const now = Date.now();
        callTimestampsRef.current.push(now);
        callTimestampsRef.current = callTimestampsRef.current.filter(timestamp => now - timestamp <= 60000);
        
        // Check if the function has been called more than 10 times within 50 seconds
        if (callTimestampsRef.current?.length > 5) {
            audioVideoNotification(audio, "Connection interrupted, join again to resume the class")
            history.goBack();
            // You can add additional logic here, such as preventing further calls
        }
        // The reconnect this triggers closes the old producers itself (reconnectProducer
        // -> closeProducer). Without some flag, the server's delayed teardown confirmation
        // for those very producers comes back as rtmpRemoved/consumererror/fileNotCreating/
        // fileEndCreating, index.js reads it as a fresh unexpected drop, and calls
        // throttledReconnect.current again -> another reconnectProducer -> another delayed
        // echo -> reconnect loop, spaced far enough apart (past the 2s throttle window) to
        // fire repeatedly until the callTimestampsRef bailout below kicks the user out.
        // isAutoReconnectingRef guards those four handlers; see its declaration for why this
        // is not reusing ismanuallystoppedproducing. NOT cleared on rtmpStarted any more --
        // that only confirms the WebRTC producer exists, not that the server's RTMP file/
        // monitor has stabilised, and clearing it that early let fileNotCreating/rtmpRemoved
        // for the producer we JUST created retrigger another reconnect within ~2s, forever.
        // Cleared after a fixed grace period instead, giving the server time to settle.
        isAutoReconnectingRef.current = true
        // 25s still wasn't enough: observed logs show the server can take 30-40+ seconds
        // after a reconnect to report fileNotCreating/rtmpRemoved for the *new* producer
        // (ICE reconnect alone ran 10-15s, plus a long run of undated "file is creating"
        // pings before the next real signal). 60s is a much safer margin, though this is
        // still a timing-based mitigation, not a fix for a genuinely unhealthy producer --
        // see the "track ended" investigation in the conversation for the separate, likely
        // more important issue.
        const reconnectGraceToken = ++reconnectGraceTokenRef.current
        setTimeout(() => {
            // Only clear if a newer reconnect hasn't started (and rescheduled) since.
            if (reconnectGraceTokenRef.current === reconnectGraceToken){
                isAutoReconnectingRef.current = false
            }
        }, 60000)
        ispublishingmanually.current = false
        isPublishingRef.current = 1;
        setPublishing(1);
        if (stopTrack){
            roomClient.reconnectProducer(true);
        }else{
            roomClient.reconnectProducer(false);
        }
      }, 2000, { leading: true, trailing: false }));
    
    const throttledRecordingReconnect = useRef(Utils.throttleHigh(() => {
        if (!isOfflineRecordingRef.current){
            isRecording.current = 1
            setRecording(1)
            // Nobody asked for this, so no dialog: carry the server-side recording on under
            // the name it already has. 'default' would file the rest of the class under a
            // different name from the part before the interruption.
            keepRecordTimerRef.current = true
            roomClient.startRecord(recordFileNameRef.current || 'default')
        }
      }, 2000, { leading: true, trailing: false }));

    const onAccessDeny = () => {
        setAccessModalVisible(false);
        abandonRecordingResume();
        Notification.error("", "Screen share access denied")
        isPublishingRef.current = 0
        setPublishing(0);
    }
    const onAccessGrant = () => {
        setAccessModalVisible(false);
        roomClient.produce('screenType');
    }
    // Paints the stage as the class actually looks with no video of its own: the same radial
    // gradient, initials circle and name chip the screen shows (broadcastNext.css:
    // --bn-stage-gradient, .bn-stage-initials, .bn-stage-name-chip). Stands in for a
    // released camera so the stream does not play back as a black rectangle.
    const paintStageFrame = (canvas) => {
        const context = canvas.getContext('2d');
        const {width, height} = canvas;
        // radial-gradient(120% 80% at 50% 40%, ...): an ellipse, so squash a round one.
        const centerX = width * 0.5;
        const centerY = height * 0.4;
        const radius = width * 1.2;
        context.save();
        context.translate(centerX, centerY);
        context.scale(1, (height * 0.8) / radius);
        const gradient = context.createRadialGradient(0, 0, 0, 0, 0, radius);
        gradient.addColorStop(0, '#3a2f5c');
        gradient.addColorStop(0.6, '#1e1a2e');
        gradient.addColorStop(1, '#0f0d18');
        context.fillStyle = gradient;
        context.fillRect(-width * 2, -height * 2, width * 4, height * 4);
        context.restore();

        const initials = initialsOf(sessionuser?.name);
        context.beginPath();
        context.arc(width / 2, height / 2, 80, 0, Math.PI * 2);
        context.fillStyle = '#594099';
        context.fill();
        context.fillStyle = '#ffffff';
        context.font = '600 52px Inter, system-ui, sans-serif';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(initials, width / 2, height / 2 + 2);

        const label = `${sessionuser?.name ?? ''} (You)`;
        context.font = '500 14px Inter, system-ui, sans-serif';
        context.textAlign = 'left';
        const chipWidth = context.measureText(label).width + 24;
        const chipHeight = 30;
        const chipX = 16;
        const chipY = height - 16 - chipHeight;
        context.fillStyle = 'rgba(0, 0, 0, 0.55)';
        if (context.roundRect){
            context.beginPath();
            context.roundRect(chipX, chipY, chipWidth, chipHeight, 8);
            context.fill();
        }else{
            context.fillRect(chipX, chipY, chipWidth, chipHeight);
        }
        context.fillStyle = '#ffffff';
        context.fillText(label, chipX + 12, chipY + chipHeight / 2);
    }
    // The new design lets the camera be released without dropping the producer
    // (swapVideoToStill / swapVideoToCamera): the producer survives but its track is
    // replaced, and MediaRecorder cannot follow that — it holds the track it was handed and
    // would quietly freeze. Stop and start again on the new one, which lands in the same
    // room database under its own groupId and comes out as another file in the zip.
    // This is the only place a running recording is carried across a track change; every
    // other interruption ends the recording, exactly as before the redesign.
    const restartLocalRecording = () => {
        if (!hasVideoProducer() || !hasAudioProducer()) return false
        roomClient.stopLocalRecording();
        roomClient.startLocalRecording(videoLabel());
        recordingStarted(false);
        return true
    }
    // resetTimer is false only for the track swap above: the class is still being recorded,
    // so the clock in the header should keep counting rather than appear to start over.
    const recordingStarted = (resetTimer=true) => {
        ismanuallystoppingrecording.current = false
        if (resetTimer){
            setRecordTimer(0);
        }
        start();
        isRecording.current = 2
        setRecording(2)
        setRecordModalVisible(false)
    }
    const recordingStopped = () => {
        stop();
        isRecording.current = 0
        setRecording(0)
        setRecordModalVisible(false)
    }
    // Events that must survive the publish gate below. Network and score reporting starts
    // the moment the room is joined and matters most for students, who never publish at all
    // — gating them on isPublishing would mean the readout only ever appeared for a teacher
    // who was already live.
    const ALWAYS_HANDLED = ['rtmpRecordStopped', 'networkStats', 'producerScore', 'videoQuality',
                            'networkWeak'];
    const eventCallback = (event, dataReceived) => {
        if (isPublishingRef.current===0 && !ALWAYS_HANDLED.includes(event)) return
    if (event==='videoQuality'){
        setVideoRung(dataReceived);
        return
    }
    if (event==='networkWeak'){
        // Holding a quality the line cannot carry has its own escalation, and it replaces the
        // generic snackbar rather than stacking a second banner on top of it.
        if (escalateWeakNetworkRef.current?.(dataReceived)) return
        setWeakNetworkPrompt(dataReceived);
        return
    }
    if (event==='networkStats'){
        setNetStats(dataReceived);
        netTotalsRef.current = {
            bytesSent: dataReceived?.bytesSent ?? 0,
            bytesReceived: dataReceived?.bytesReceived ?? 0,
        };
        // Same sample, split by publish mode and printed to the console. Diagnostics only:
        // the billed total still comes from netTotalsRef on the way out. setMode first, so a
        // mode change that happened since the last tick opens its phase before this tick's
        // bytes are attributed.
        consumptionPhaseLogger.setMode(publishModeRef.current);
        consumptionPhaseLogger.tick(dataReceived);
        return
    }else if (event==='producerScore'){
        const {userId, kind, score} = dataReceived || {};
        if (!userId) return
        consumptionPhaseLogger.recordScore({userId, kind, score});
        setProducerScores((previous)=>{
            const existing = previous[userId] || {};
            if (existing[kind]===score) return previous
            return {...previous, [userId]: {...existing, [kind]: score}}
        });
        return
    }
    if (event==='trackEnded'){
        // The capture this publish existed for has gone, so the publish follows it down.
        transitionKindRef.current = 'stop'
        ismanuallystoppingrecording.current = true
        ismanuallystoppedproducing.current = true
        isPublishingRef.current = 1
        setPublishing(1)
        roomClient.closeProducer(videoLabel());
        setTimeout(()=>{
            roomClient.closeProducer('audioType');
        }, 1000);
        if (isRecording.current===2&&isOfflineRecordingRef.current){
            setRecordDownloadModalVisible(true)
        }
    }else if(event==='audioTrackEnded'){
        // A device dropped out and is being republished onto the same class. Recovery reads
        // as starting, which is what it is — nothing here is coming down.
        transitionKindRef.current = 'start'
        ispublishingmanually.current = true
        isAttemptingShare.current = true
        isPublishingRef.current = 1
        setPublishing(1);
        audioVideoNotification(audioDisconnect, "An audio device has been disconnected")
    }
    else if(event==='rtmpRecordStarted'){
        recordingStarted(!keepRecordTimerRef.current);
        keepRecordTimerRef.current = false
        // Whatever asked for the last stop is done with: leaving this set makes the next
        // rtmpRecordStopped look deliberate and skips the resume.
        ismanuallystoppingrecording.current = false
    }else if(event==='rtmpRecordStopped'){
        if (ismanuallystoppingrecording.current){
            recordingStopped();
        }else{
            throttledRecordingReconnect.current();
        }
    }else if(event==='rtmpStarted'){
        if ((dataReceived && processIdRef.current!=dataReceived)) return
        if (ismanuallystoppedproducing.current){
            setMuteState(false);
        }else{
            if (micStateRef.current){
                roomClient.mute();
            }
        }
        isPublishingRef.current = 2
        setPublishing(2);
        ismanuallystoppedproducing.current = false
        // isAutoReconnectingRef is cleared by the grace-period timeout in throttledReconnect,
        // not here -- rtmpStarted only confirms the producer exists, not that the server's
        // RTMP file/monitor has stabilised.
    }else if(event==='cameraOn'){
        // Keep the stream even when the <video> isn't mounted yet: in camera mode this event
        // fires from inside produce(), before isCamOn is true, so the element it used to write
        // to did not exist and the stage came up blank. An effect below attaches it on mount.
        videoStreamRef.current = dataReceived;
        setCameraState(true);
        if (localVideoRef.current){
            localVideoRef.current.srcObject = dataReceived;
        }
    }else if(event==='cameraOff'){
        setCameraState(false);
    }else if(event==='screenOn'){
        // The producer is carrying the screen now. The stage's <video> is the camera self
        // view, and in screen mode that comes from the separate overlay capture — so let go
        // of the camera stream this was holding rather than reattaching a stopped track.
        videoStreamRef.current = null;
    }else if(event==='boardOn'){
        // Same as 'screenOn': the producer carries the board now, and the stage's <video> is
        // the camera self view, which in board mode comes from the separate overlay capture.
        // Holding the old camera stream here would reattach a track that has been stopped.
        videoStreamRef.current = null;
    }else if(event==='screenShareEnded'){
        // The browser's own "Stop sharing" bar, on a screen that was swapped onto a live
        // class. That ends the screen half of the class, not the class: the producer, the
        // audio and the RTMP link are all still up, so put the camera back exactly as the
        // control bar's Stop sharing does. This is a different event from 'trackEnded'
        // above, which belongs to a publish that was a screen share and nothing else — there
        // the screen ending really is the end of everything being published.
        if (isPublishingRef.current===2){
            // Nobody clicked a button for this, so the spinner belongs to the share rather
            // than to whichever control the teacher happened to touch last. It only shows at
            // all if putting the camera back leaves nothing on the wire and the publish comes
            // down behind it.
            claimTransition('screen')
            stopScreenShareRef.current?.()
        }
    }else if(event==='roomAlreadyExists'){
        // Notification.error("", "Room already exists");
    }else if(event==='rtmpRemoved'){
        if (isAttemptingShare.current===false || (dataReceived && processIdRef.current!=dataReceived)) return

        if (ismanuallystoppedproducing.current===true){
            roomClient.closeProducer('audioType');
            roomClient.closeProducer('videoType');
            roomClient.closeProducer('screenType');
            setTimeout(()=>{
                if (isRecording.current!=0){
                    if (isOfflineRecordingRef.current){
                        // A local recording lives on the track being published, so it ends
                        // with it. The chunks are offered right here — the room database is
                        // the only place they exist.
                        roomClient.stopLocalRecording();
                        // ...unless this teardown is the middle of a share switch, where the
                        // recording carries on as another segment in the same zip once the new
                        // producer is up. Every path that can abandon the switch puts the modal
                        // back, so the chunks are never left unoffered.
                        if (!recordingWasOnRef.current){
                            setRecordDownloadModalVisible(true)
                        }
                        recordingStopped();
                    }
                }
                isPublishingRef.current = 0;
                setPublishing(0);
                setCameraState(false);
                setMuteState(true);
            }, 15000);
        }else if (isAutoReconnectingRef.current){
            // This is reconnectProducer's own teardown of the old producers echoing back,
            // not a fresh drop -- throttledReconnect is already in flight for it.
        }else{
            roomClient._netLog(`index.js: rtmpRemoved(processId=${dataReceived}) -> throttledReconnect`); // TEMP DIAGNOSTIC
            throttledReconnect.current(false);
        }
    }
    else if(event==='SharePermissionDenied'){
        abandonRecordingResume();
        isPublishingRef.current = 0;
        setPublishing(0);
        ismanuallystoppedproducing.current = true
        ismanuallystoppingrecording.current = true
        roomClient.closeProducer('audioType');
        setMuteState(true);
    }else if(event==='audioAdded'){
        // Mic-only broadcast: stop here instead of going on to a camera or screen track.
        // The audio producer exists and the room consumes it directly, so this is already
        // live — there is no rtmpStarted to wait on when no video follows.
        if (audioOnlyRef.current){
            isPublishingRef.current = 2
            setPublishing(2)
            ismanuallystoppedproducing.current = false
            roomClient.unMute()
            setMuteState(false)
            return
        }
        if (navigator.userAgent.includes("Chrome")) {
            // videoLabel(), not the shareType mapping: on a reconnect this has to name the
            // producer that is still there, which after a screen swap is the label the
            // camera created. With nothing left to reuse it falls back to shareType, which
            // is what a fresh publish needs.
            //
            // Skipped mid auto-reconnect: reconnectProducer already restored
            // videoType/screenType itself (see roomClient.js), so producing it again here
            // would create a second, duplicate producer for the same track right behind it.
            if (!isAutoReconnectingRef.current){
                // A whiteboard publish builds its video producer from the board canvas, so
                // nothing here opens a picker or a camera. Ignored on the republish path
                // (existing=true), which reuses the track it already has.
                roomClient.produce(videoLabel(), ismanuallystoppedproducing.current?false:true,
                                   boardIntentRef.current ? 'board' : null)
            }
          } else {
            // This fallback code is much less performant, but works
            setAccessModalVisible(true);
          }
    }else if(event==='fileNotCreating'){
        if (isPublishingRef.current===0||ismanuallystoppedproducing.current||isAutoReconnectingRef.current|| (dataReceived && processIdRef.current!=dataReceived)) return
        roomClient._netLog(`index.js: fileNotCreating(processId=${dataReceived}) -> throttledReconnect`); // TEMP DIAGNOSTIC
        throttledReconnect.current(false);
    }else if(event==='consumererror'){
        if (isPublishingRef.current===0||ismanuallystoppedproducing.current||isAutoReconnectingRef.current) return
        roomClient._netLog(`index.js: consumererror -> throttledReconnect`); // TEMP DIAGNOSTIC
        throttledReconnect.current(false);
    }else if(event==='fileEndCreating'){
        if (isPublishingRef.current===0||ismanuallystoppedproducing.current||isAutoReconnectingRef.current||isFileCreatingRef.current||(dataReceived && processIdRef.current!=dataReceived) ) return
        roomClient._netLog(`index.js: fileEndCreating(processId=${dataReceived}) -> throttledReconnect`); // TEMP DIAGNOSTIC
        throttledReconnect.current(false);
    }else if(event==='fileCreating'){
        if (isPublishingRef.current===0) return
        // Any id this publish has minted, not only the newest one — the monitor's 6s poll
        // means a report for the id before last is the normal case after a reconnect, not a
        // stale message from somebody else's stream. See processIdsRef.
        if (dataReceived && !processIdsRef.current.has(dataReceived)) return
        isFileCreatingRef.current = true
        fileCreatingAtRef.current = Date.now()
    }else if(event==='producerTransportClose'){
        if (isPublishingRef.current===0||ismanuallystoppedproducing.current) return
        // throttledReconnect.current(false);
    }else if(event==='processIdGenerated'){
        processIdRef.current = dataReceived
        if (dataReceived) processIdsRef.current.add(dataReceived)
    }
    // 'internetQuality' is gone. It carried round-trip time only and set the banner on
    // rtt > 0.3s; the banner is now derived from packet loss and score — see connectionQuality.
    };
    const socketCallback = (event, data) => {
        if (event==='muxError'){
        }else if(event==='connect'){
            clearTimeout(broadcastHealthTimer)
        }
        else if(event==='disconnect'){
            if (broadcastHealthTimer){
                clearTimeout(broadcastHealthTimer)
            }
            broadcastHealthTimer = setTimeout(() => {
                if (window.location.pathname==='/broadcast'){
                  Notification.error("", "Socket disconnected, join again to resume the class")
                  audio.play();
                  history.goBack();
                }
              }, 10000);
        }
    }
    const NotificationHandler = () => {
        if ((rightViewType=='groupChatView')&&(rightView==true)){
        }
        else{
            MessageNotification.group();     
        }
    }
    const onlineUserIds = useMemo(()=>{
        return usersList && usersList.length? usersList.filter((item)=>item.statustoshow==='online')?.map((item)=>item.user?.id?.toString()): []
      }, [usersList]);
    
    const ifAnyOnePublishing = useCallback(() => {
        return Object.keys(publishers).length && Object.keys(publishers).some((k)=>{
            return publishers[k] && (onlineUserIds.includes(k))
        })
        }, [publishers, usersList])
    const handlePublishEvent = (data) => {
        let isUpdated = false
        let newState = data.state;
        let newUser = data.user;
        if (data.state){
            setloadplayer(data.fileCreating)
        }
        if (!(newUser.id in publishers)){
            isUpdated = true
        }else{
            if(newState!=publishers[newUser.id]){
                isUpdated=true
            }
        }
        if (isUpdated){
            publishers[newUser.id] = newState
            setPublishers({...publishers})
        }
        // Kept beside `publishers` rather than inside it: that map is read as a plain
        // boolean in half a dozen places and turning its values into objects would touch
        // every one of them. Set on every heartbeat rather than only on the `isUpdated`
        // edges above — mute moves far more often than publish does — but only when it has
        // actually changed, so a 2s keepalive does not re-render the class for nothing.
        //
        // Three states, not two. `!!data.micMuted` was two, and that is what made a muted
        // teacher read as unmuted: a heartbeat with no micMuted on it at all — a publisher
        // on an older build, a field the relay did not carry — coerced to false, which is
        // not "we have not been told" but the confident claim "their mic is open". Left as
        // undefined it stays unknown, and unknown is drawn as quiet further down, which is
        // the reading that cannot put a live-mic indicator over someone who is muted.
        const nextMuted = !newState ? undefined
            : data.micMuted === undefined ? undefined
            : !!data.micMuted
        // TEMP DIAGNOSTIC (safe to remove), and the counterpart of [BN-DIAG tx]. The two
        // together say which side of the wire a mute was lost on: tx printing micMuted true
        // with no rx to match it is the relay, no tx at all is the publisher's tab running
        // an older build, and `undefined` here is the field arriving absent.
        if (micDiagRef.current !== `${newUser.id}|${nextMuted}`){
            micDiagRef.current = `${newUser.id}|${nextMuted}`
            console.log('[BN-DIAG rx]', {publisher: newUser.id, micMuted: data.micMuted, reading: nextMuted})
        }
        setPublisherMic((previous)=>(
            previous[newUser.id]===nextMuted ? previous : {...previous, [newUser.id]: nextMuted}
        ))
    }


    const clientChatCallback = (e) => {
        switch (e.event) {
          case "userList":
            let newUserList = [];
            e.data.forEach((item, index)=>{
            let newObj = {
                statustoshow: item.statusToShow,
            }
            newObj.user = {
                id: item.userId,
                userId: item.userId,
                role: item.role?.split(','),
                privilage: item.privilege?.split(','),
                image: item.image,
                name: item.userName??'user'
            }
            newUserList.push(newObj);
            })
            updateUserList(newUserList, broadcastStudentsList!=undefined?broadcastStudentsList:[])

              break;
          case "rcvChat":
            if(e.data.type=="Image"){
                addMessageToGroup({id:uuidv4(), 
                    type:"Image", 
                    image:e.data.data.image, 
                    createdAt: new Date(),
                    user: e.data.data.user})
                if (sessionuser.id==e.data.data.user.id){

                }else{
                    updateUnreadCount('groupIncrement')
                }
            }
            else if(e.data.type=='Text'){
                if (typeof e.data.data==='string'){
                    e.data.data = JSON.parse(e.data.data);
                  }
                const groupTextMessage = {
                                    type:e.data.type, 
                                    userId: e.data.userId, 
                                    user:e.data.data.user, 
                                    text: e.data.data.text, 
                                    createdAt: e.data.data.createdAt, 
                                    id:uuidv4()
                                    }
                if (sessionuser.id==e.data.data.user.id){
                    postChat(groupTextMessage, "Group");}
                else{
                    updateUnreadCount('groupIncrement');
                    }
                addMessageToGroup(groupTextMessage);
            }else if (e.data.type=='Event'){
                if (typeof e.data.data.user === 'string'){
                  e.data.data.user = JSON.parse(e.data.data.user);
                }
                if (!e.data.data.user?.access?.includes("schedule-student") && e.data.data.user.id!=sessionuser.id){
                  // Somebody has just arrived in the room and is asking who is publishing.
                  // Answer now rather than leaving them to overhear the next heartbeat: that
                  // wait is up to two seconds of blank screen between their pressing Join and
                  // the class appearing, and this reply is the whole of what removes it. The
                  // answer is the same either way — this teacher is live, or is not — so a
                  // room where nobody is publishing closes the question just as fast as one
                  // where somebody is. Read off the ref: the chat callback is built once and
                  // keeps its first render's `isPublishing` for the life of the room.
                  if (e.data.data.probe){
                    if (!sessionuser.access.includes("schedule-student")){
                      sendPublishState(isPublishingRef.current===2)
                    }
                    return
                  }
                  handlePublishEvent(e.data.data);
                }
              }
            if (sessionuser.id!=e.data.data.user.id && (e.data.type==='Text' || e.data.type==='Image')){
                NotificationHandler();
            }
            break;
        case 'privateChatRcv':
            if (e.data.type=="Image"){
                addMessageToPrivate( sessionuser.id==e.data.data.user.id?e.userId:e.data.data.user.id, {id:uuidv4(), 
                    type:"Image", 
                    image:e.data.data.image, 
                    createdAt: new Date(),
                    user: e.data.data.user})
                if (sessionuser.id==e.data.data.user.id){

                }else{
                    updateUnreadCount('privateIncrement', undefined, e.data.data.user.id);
                }
            }
            else if(e.data.type=='Text'){
                const privateTextMessage = {
                    type:e.data?.type, 
                    userId: e.data?.userId, 
                    user:e.data?.data?.user, 
                    text: e.data?.data?.text, 
                    createdAt: e.data?.data?.createdAt, 
                    id:uuidv4()
                }
                let reciever = sessionuser.id==e.data.data.user.id?e.userId:e.data.data.user.id;
                if (sessionuser.id==e.data.data.user.id){
                    postChat({...privateTextMessage, reciever:reciever}, "Private");
                }else{
                    updateUnreadCount('privateIncrement', undefined, e.data.data.user.id);
                  }
                addMessageToPrivate(reciever, privateTextMessage);
            }
            if (sessionuser.id!=e.data.data.user.id){
                MessageNotification.private(e.data.data.user.name);
            }
            break;    
        }
    }
    const getClient = useCallback(() => {
        return new ChatClient(setUpChatSocket(), sessionuser.id, streamId, sessionuser.name , sessionuser.privilage?.join(','), sessionuser.role?.join(',') , sessionuser.image, activeClass.occurance?.id, streamId?.split('xxxx')[0], sessionuser.org.url, clientChatCallback)
    }, [])
    // TEMP DIAGNOSTIC (safe to remove) — last value logged by sendPublishState/the stage log,
    // so each only prints when something actually changes.
    const txDiagRef = useRef('');
    const stageDiagRef = useRef('');
    const [chatClient, setChatClient] = useState(null);
    const [reloadToggler, toggleReloader] = useState(false);
    const chatClientRef = useRef(null);
    // Whether this teacher is live is published to the room as a chat Event, and it is the
    // only thing other teachers have to go on when they decide whether sharing is free.
    // Is the backend still telling us the playlist is being written?
    //
    // Not the same question as "did it ever tell us", which is all the bare flag answered.
    // Clearing the flag on each new processId instead would have worked too, but a reconnect
    // then drops it to false for up to a poll interval and the viewer's player unmounts and
    // remounts on every reconnect — the same stutter as the bug, just shorter. A freshness
    // window costs nothing and cannot flicker: a late report only ever moves it back to true.
    const isFileCreatingNow = () =>
        isFileCreatingRef.current && (Date.now() - fileCreatingAtRef.current) < FILE_CREATING_STALE_MS;
    const sendPublishState = (state)=>{
        // TEMP DIAGNOSTIC (safe to remove). What this peer is telling the room about itself,
        // which is the only thing anyone else has to go on. Logged on change rather than on
        // every 2s heartbeat so the console stays readable.
        // micMuted is part of the key so a mute prints: the chip everyone else sees is built
        // from it, and without it in here the one field that decides that chip was the one
        // field a change to could never be seen leaving this tab.
        const txDiag = `${state}|${isFileCreatingNow()}|${micStateRef.current}`
        if (txDiagRef.current !== txDiag){
            txDiagRef.current = txDiag
            console.log('[BN-DIAG tx]', {
                announcing: state,                       // false => this peer is not live
                micMuted: micStateRef.current,           // what the other end draws in the chip
                fileCreating: isFileCreatingNow(),        // false => consumers will not mount a player
                // How long ago the monitor last said so, and every processId this publish has
                // minted. A growing list here is the reconnect churn that caused the original
                // bug; a large lastReportAgoMs with fileCreating false is the monitor having
                // gone quiet rather than a report having been dropped.
                lastReportAgoMs: fileCreatingAtRef.current ? Date.now()-fileCreatingAtRef.current : null,
                processIds: [...processIdsRef.current],
                isPublishing: isPublishingRef.current,    // 2 is live; 1 is still starting
                producers: roomClient?.producerLabel ? [...roomClient.producerLabel.keys()] : 'no roomClient',
                shareType,
                studentAccess: sessionuser.access?.includes("schedule-student"), // true => nobody is listening
                me: sessionuser.id,
            })
        }
        chatClientRef.current?.sendGroupChat(sessionuser.id, streamId,
            {
                type: 'Event',
                data: {
                    state,
                    fileCreating: isFileCreatingNow(),
                    // The room's only source for "is the teacher on the stage muted".
                    // Everyone else is watching an HLS stream, which carries the audio but
                    // not the intent behind it — a teacher who has muted and a teacher who
                    // has simply stopped talking sound exactly alike, and the name chip has
                    // to say which. It rides the heartbeat rather than travelling as its own
                    // message so a dropped one corrects itself two seconds later instead of
                    // leaving the room with a stuck chip; the edge effect below sends it
                    // immediately as well, so the usual case is not a two-second wait.
                    micMuted: micStateRef.current,
                    user:sessionuser
                },
            }
            )
    }
    const [startPublisherInterval, stopPublisherInterval] = useInterval(()=>{
            sendPublishState(isPublishing==2)
    }, 2000);
    // The heartbeat alone means a start or a stop is invisible to the rest of the room until
    // the next tick, so a teacher who has just stopped still reads as live and keeps everyone
    // else locked out for up to two seconds. Announce the edges the moment they happen; the
    // interval stays as the keepalive that covers a dropped message.
    // micIsMuted is in the deps for the same reason isPublishing is: it is on the heartbeat
    // now, and a mute that waits up to two seconds to reach the room is a chip that
    // contradicts the button that was just pressed. micStateRef is read rather than the
    // state itself, and the effect that writes it is declared above this one — React runs
    // effects in declaration order, so it holds this render's value by the time we get here.
    useEffect(()=>{
        if (sessionuser.access.includes("schedule-student")) return
        if (isPublishing===0 || isPublishing===2){
            sendPublishState(isPublishing===2)
        }
    }, [isPublishing, micIsMuted]);
    const onUnload = (e) => {
        onUnmount();
    }
    const onContextMenu = (e) => {
            if (window.location.hostname == "localhost"){
                return
            }
            e.preventDefault();
    }
    const onkeydown = (e) => {
        if (e.key == 123) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.key == 'I') {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.key == 'C') {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.key == 'J') {
            e.preventDefault();
        }
        if (e.ctrlKey && e.key == 'U') {
            e.preventDefault();
        }
    }
    const setUpListeners = useCallback(()=>{
        eventListeners.current = EventRegister.addEventListener('broadcast', data => {
            if (data==='connectionCompleted'){
              setConnecting(false)
            }
        });
      }, []);
    function isDeviceRemoved(plist, clist) {
        if (plist.length > clist.length) return true;
        if (plist.length < clist.length) return false;
        const ids1 = plist.map(device => device.deviceId).sort();
        const ids2 = clist.map(device => device.deviceId).sort();
        return !(ids1.every((id, index) => id === ids2[index]));
    }
    function updateDeviceList() {
        const audioList = [];
        const videoList = [];
        let count = 0;
        navigator.mediaDevices?.enumerateDevices().then((devices) => {
            console.log("878", devices)
          devices.forEach((device) => {
            const [kind, type, direction] = device.kind.match(/(\w+)(input|output)/i);
            device.direction = direction;
            if (type === "audio") {
              audioList.push(device);
            } else if (type === "video") {
              videoList.push(device);
            }
          });
          if (isDeviceRemoved(previousAudioList, audioList)) {
              count = 1
          }
          if (isDeviceRemoved(previousVideoList, videoList)) {
              count += 2
          }
          if (count===1){
              //audio removed
            //   audioVideoNotification(audioDisconnect, "An audio device has been disconnected")
          }else if(count===2){
              //video removed
              audioVideoNotification(videoDisconnect, "A video device has been disconnected")
          }else if(count===3){
              // both audio and video removed
              audioVideoNotification(audiovideoDisconnect, "An audio and a video device has been disconnected")
          }
          previousAudioList = audioList;
          previousVideoList = videoList;
        });
      }
    const throttledUpdateDeviceList = useCallback(Utils.throttleHigh(updateDeviceList, 500, {trailing:true}), []); ; 

    useEffect(() => {
        previousAudioList = [];
        previousVideoList = [];
        updateDeviceList();
        navigator.mediaDevices?.addEventListener("devicechange", throttledUpdateDeviceList);
        audio = new Audio(audiosrc)
        audioDisconnect = new Audio(audioDisconnectSrc);
        videoDisconnect = new Audio(videoDisconnectSrc);
        audiovideoDisconnect = new Audio(audiovideoDisconnectSrc);
        clearTimeout(broadcastHealthTimer);
        broadcastHealthTimer = null
        setUpListeners();
        window.addEventListener("beforeunload", onUnload);
        document.addEventListener('contextmenu', onContextMenu);
        document.addEventListener('keydown', onkeydown);
        // The live class is a fixed-height screen, so stop the document itself from
        // scrolling: at some browser zoom levels the legacy canvases (sized once off
        // window.innerWidth when their module loads, so they do not follow a zoom) push the
        // page wider or taller than the window, and the scrollbar that appears sits over the
        // control bar. Restored on the way out so the rest of the app scrolls normally.
        const previousBodyOverflow = document.body.style.overflow;
        const previousRootOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        if (!sessionuser.role.includes('Student')){
            roomClient = new RoomClient({ clientName:'aulasstudent', room_id: `${streamId}`, refer:false, user:sessionuser, name: sessionuser.name, user_id:sessionuser.id, socket:setUpRoomClientSocket(`/${Utils.getBroadcastUrls('server')}.io`, history, socketCallback), eventCallback:eventCallback, setStreamCallback: setStreamCallback})
            // Hand over any measurement that landed while this was still being built.
            if (lineSpeedRef.current) roomClient.setLineSpeed(lineSpeedRef.current)
        }
        chatClientRef.current = getClient()
        setChatClient(chatClientRef.current)
        setUserType();
        setCameraState(false);
        setMuteState(true);
        if (!sessionuser.access.includes("schedule-student")){
            startPublisherInterval();
        }
          return () => {
                onUnmount();
                window.removeEventListener("beforeunload", onUnload)
                document.removeEventListener('contextmenu', onContextMenu);
                document.removeEventListener('keydown', onkeydown);
                document.body.style.overflow = previousBodyOverflow;
                document.documentElement.style.overflow = previousRootOverflow;
                EventRegister.removeEventListener(eventListeners.current)
                }
    }, []);
    // "Stop sharing" moves publishing to 1 and waits for the server's rtmpRemoved, which is
    // what closes the producers and finally sets it back to 0 (after that handler's own 15s
    // grace period). If the event never arrives, none of that runs and the button spins
    // forever with every other control locked out. This performs the same teardown on a
    // timeout so the bar always recovers.
    const clearStopWatchdog = () => {
        if (stopWatchdogRef.current){
            clearTimeout(stopWatchdogRef.current);
            stopWatchdogRef.current = null;
        }
    }
    const armStopWatchdog = () => {
        clearStopWatchdog();
        stopWatchdogRef.current = setTimeout(()=>{
            stopWatchdogRef.current = null;
            if (isPublishingRef.current!==1) return
            roomClient?.closeProducer('audioType');
            roomClient?.closeProducer('videoType');
            roomClient?.closeProducer('screenType');
            isPublishingRef.current = 0;
            setPublishing(0);
            setCameraState(false);
            setMuteState(true);
        }, 20000);
    }
    useEffect(()=>{
        if (isPublishing!==1){
            clearStopWatchdog();
        }
    }, [isPublishing]);

    // Starting a publish has no timeout of its own: when the server never answers with
    // rtmpStarted the bar reads 'Starting…' for the rest of the class and no button helps.
    // Long enough that a teacher choosing a window in the screen-share picker is not cut
    // off, short enough to be recoverable.
    useEffect(()=>{
        if (isPublishing!==1 || ismanuallystoppedproducing.current) return undefined
        const timer = setTimeout(()=>{
            if (isPublishingRef.current!==1) return
            roomClient?.closeProducer('audioType');
            roomClient?.closeProducer('videoType');
            roomClient?.closeProducer('screenType');
            isPublishingRef.current = 0;
            setPublishing(0);
            setCameraState(false);
            setMuteState(true);
            abandonRecordingResume();
            Notification.error("", "Could not start the stream. Try sharing again")
        }, 60000)
        return ()=>clearTimeout(timer)
    }, [isPublishing]);

    // Taking the whole broadcast down, without leaving the class. Everything here was inline
    // in onShareClick's stop branch; it is its own function now because the nothing-left
    // teardown needs the same steps and cannot go through onShareClick — that reads a
    // mic-only publish as a request to *add* video to it, the opposite of stopping.
    const stopPublishing = () => {
        transitionKindRef.current = 'stop'
        ismanuallystoppedproducing.current = true
        ismanuallystoppingrecording.current = true
        if (isRecording.current===2){
            if (isOfflineRecordingRef.current){
                // roomClient.stopLocalRecording()
                // recordingStopped();
                // setRecordDownloadModalVisible(true)
            }else{
                recordingStopped();
            }
        }
        roomClient.closeProducer(videoLabel());
        setTimeout(()=>{
            roomClient.closeProducer('audioType');
        }, 1000);
        isAttemptingShare.current = true
        isPublishingRef.current = 1
        setPublishing(1)
        armStopWatchdog()
    }
    const onShareClick = ()=>{
        if (isRecording.current===1){
            Notification.warning("", "Recording is still starting. Wait for it before changing what you share")
            return
        }
        setWhiteboard(false);
        // Only a fresh start is someone else's business. This used to gate every path
        // through here, which meant a teacher who was already live could be locked out of
        // their own stream by another one going live: the stop below and the mic-only track
        // add both came past this point, so two publishers at once left neither able to stop
        // — and the toast, which talks about starting, was the only thing either one got.
        if(isPublishing===0 && ifAnyOnePublishing()){
            Notification.error("", "Stop the existing stream, to start publishing");
            return
        }
        // Already live on the mic alone — a camera or screen share joins that session
        // rather than stopping it: the audio producer and its transport stay as they are
        // and only the video track is added, exactly what audioAdded does normally.
        if (isPublishing==2 && audioOnlyRef.current){
            // produce() is async: leave mic-only mode only once the track really exists,
            // otherwise anything watching for 'a share started' — the pre-join recording
            // among them — fires against a producer that is not there yet.
            const label = shareType==='screen'?'screenType':'videoType'
            Promise.resolve(roomClient.produce(label, false, boardIntentRef.current ? 'board' : null)).then(()=>{
                if (roomClient?.producerLabel?.has(label)){
                    setAudioOnlyMode(false)
                }
            })
            return
        }
        ismanuallystoppedproducing.current = true
        ismanuallystoppingrecording.current = true
        // Stopping the publish outright. The share button no longer comes here — it owns the
        // screen and swaps tracks rather than ending anything — so this is reached only by a
        // caller that means to take the whole broadcast down.
        if (isPublishing==2){
            stopPublishing()
        }else if(isPublishing==0){
            // Going live. Said out loud because ismanuallystoppedproducing, set a few lines
            // above for reasons that have nothing to do with direction, is true here too.
            transitionKindRef.current = 'start'
            callTimestampsRef.current = [];
            ispublishingmanually.current = true
            isAttemptingShare.current = true
            isPublishingRef.current = 1
            setPublishing(1);
            roomClient.produce('audioType');
        }
    }
    const setStreamCallback = (audio, stream) => {

    }
    const onMicClick = () => {
        // Either direction can move the publish: unmuting from idle starts it, and muting
        // the last thing on the wire ends it. Claim the spinner before doing either.
        claimTransition('mic')
        // Nothing is being shared yet. Going live on the mic alone is allowed, so run the
        // same publish chain a share does and let audioAdded stop it at the audio producer.
        // shareType is pinned to 'camera' so the stage does not read this as a screen share.
        if (isPublishing===0){
            setAudioOnlyMode(true)
            setShareTypeMode('camera')
            onShareClick()
            return
        }
        if (isPublishing!=2){
            return
        }
        if (micIsMuted){
            roomClient.unMute();
            setMuteState(false);
        }else{
            roomClient.mute();
            setMuteState(true);
        }
    }

    // --- pre-redesign, kept for reference -------------------------------------
    // The camera handler as it was before the redesign. Replaced by
    // setCameraEnabled/cameraIsOn below, because stopcamera() only owns the overlay
    // stream opencamera() creates and is a no-op while the camera is the published
    // videoType producer.
    // --------------------------------------------------------------------------
    //     const onCameraClick = () => {
    //         if (isPublishing!=2){
    //             return
    //         }
    //         if (isCamOn){
    //         roomClient.stopcamera();
    //         }else{
    //             roomClient.opencamera();
    //         }
    //     }
    // Camera control for both share modes.
    //
    // In camera mode the published videoType producer *is* the camera, and produce() sends a
    // clone of its track (roomClient.js:1012) — so stopcamera(), which only owns the
    // screen-share overlay stream created by opencamera(), is a no-op there and the camera
    // keeps streaming. Pause/resume the producer instead: exactly what mute() does for audio,
    // which leaves the RTMP link and any running recording alone.
    //
    // In screen mode the camera is the overlay, and open/stopcamera is the right pair.
    const setCameraEnabled = (enabled) => {
        if (isPublishing===0 && enabled){
            // Nothing is being published — turning the camera on means going live with it.
            // This is the only way back to a camera broadcast after "Stop sharing".
            setShareTypeMode('camera')
            onShareClick()
            return
        }
        if (isPublishing===2 && audioOnlyRef.current && enabled){
            // Live on the mic alone: add the camera to that session rather than starting a
            // new one — onShareClick knows how.
            setShareTypeMode('camera')
            onShareClick()
            return
        }
        if (isPublishing!=2){
            return
        }
        if (shareType==='camera'){
            // Release the device instead of pausing the producer: a paused producer still
            // holds the camera open, light and all. swapVideoToStill/swapVideoToCamera keep
            // the producer itself alive, so the stream and the RTMP link never drop.
            const swap = enabled
                ? roomClient.swapVideoToCamera(videoLabel())
                : roomClient.swapVideoToStill(videoLabel(), paintStageFrame)
            Promise.resolve(swap).then((swapped)=>{
                if (!swapped) return
                setCameraState(enabled);
                continueLocalRecording()
            }).catch(()=>{
                Notification.error("", enabled?"Could not turn the camera on":"Could not turn the camera off")
            })
            return
        }
        if (enabled){
            roomClient.opencamera();
        }else{
            roomClient.stopcamera();
        }
    }
    // In camera mode `isCamOn` is written both by the produce() 'cameraOn' event and by our
    // own toggle, and those two can race — leaving the button showing "Camera on" over a
    // paused producer. The producer's own paused flag is the truth, so read that when it
    // exists and fall back to redux otherwise.
    const videoProducerPaused = () => {
        try{
            const producerId = roomClient?.producerLabel?.get('videoType');
            const producer = producerId ? roomClient?.producers?.get(producerId) : null;
            return producer ? !!producer.paused : null;
        }catch(error){
            return null
        }
    }
    // Camera state is whatever the last swap left behind: the producer is no longer paused
    // for camera-off, so videoProducerPaused() above would read "on" the whole time.
    const cameraIsOn = isCamOn
    publishModeRef.current = {
        live: isPublishing===2,
        audioOnly,
        micOn: !micIsMuted,
        cameraOn: cameraIsOn,
        // Mic-only sessions pin shareType to 'camera' but publish no video at all, so the
        // audioOnly flag has to veto both video labels rather than just the screen one.
        screenOn: shareType==='screen' && !audioOnly,
        whiteboardOn: whiteboard,
    };
    // Sustained trouble while holding a quality the line cannot carry, escalating over two
    // reports. roomClient only raises networkWeak after most of a half minute in trouble and
    // then sits on a five minute cooldown, so the second one means the connection has had
    // that long to prove it can hold the choice and has not.
    //
    // The first is a warning and nothing more — a teacher demonstrating something may have
    // good reason to ride out a rough patch. The second stops asking and lowers the quality
    // itself, back to Auto, where the controller keeps it inside what the line affords. A
    // publisher's camera goes off with it: it is the largest thing on their uplink and the
    // most expendable, and dropping it is what gets their audio through.
    //
    // Nobody is removed from the class at any point. A slow connection is a reason to send
    // less, not a reason to end someone's lesson.
    //
    // Returns true when it has handled the report, so the caller leaves the generic
    // "connection is unstable" snackbar alone rather than showing both.
    const escalateWeakNetwork = (data) => {
        const ceiling = lineCeilingRung()
        // Auto is the controller's problem and it is already solving it, and a pin at or
        // below the ceiling is not what is causing this.
        if (videoQuality===null || ceiling===null || videoQuality<=ceiling) return false
        weakStrikesRef.current += 1
        if (weakStrikesRef.current===1){
            // Notification.warning("", `Your connection is struggling at ${VIDEO_LADDER[videoQuality].label}. Lowering the video quality will make the class steadier.`)
            return true
        }
        // Handing the quality back to Auto also clears the strike count, and the next report
        // finds videoQuality null and is left to the generic snackbar above.
        applyVideoQuality(null)
        // Only a publisher has a camera on the wire to give up. Someone watching is already
        // only receiving, so lowering what is asked for is the whole of it.
        const droppingCamera = isPublishing===2 && cameraIsOn
        if (droppingCamera){
            setCameraEnabled(false)
        }
        // Notification.warning("", droppingCamera
        //     ? "Your internet speed is too low for this quality. Video is back on Auto and your camera has been turned off so your audio keeps getting through."
        //     : "Your internet speed is too low for this quality. Video is back on Auto.")
        return true
    }
    escalateWeakNetworkRef.current = escalateWeakNetwork;
    const onCameraClick = () => {
        claimTransition('camera')
        setCameraEnabled(!cameraIsOn);
    }
    // A MediaRecorder holds the track it was handed and cannot follow a replaceTrack — it
    // would quietly freeze on a track that has stopped. Continue on the new one as another
    // segment of the same recording, which lands in the same zip. Called after every swap.
    const continueLocalRecording = () => {
        if (isRecording.current!==2 || !isOfflineRecordingRef.current) return
        if (!restartLocalRecording()){
            recordingStopped();
            setRecordDownloadModalVisible(true);
        }
    }

    // Nothing is going to arrive: drop the recording intent queued behind a share and say why
    // the recording is not starting. Same clean-up the share dialog's Cancel does. The board
    // is no longer among these — it does not queue behind a screen any more.
    const abandonPendingShare = () => {
        afterScreenShareRef.current = null
        if (pendingRecordRef.current){
            pendingRecordRef.current = null
            Notification.warning("", "A recording needs your camera, screen or whiteboard. Nothing is being recorded")
        }
    }
    // Screen sharing, for a class that is already live.
    //
    // The share button used to be the publish switch: with a camera on the wire it read
    // "Stop stream", and the only route to a screen share was to stop everything and start
    // again — a 15s teardown, a second trip through the picker, and audio and video coming
    // back up on two fresh producers with two fresh timelines, which is where the jitter
    // came from. There is already a video producer carrying the camera, and the screen
    // belongs on that producer. replaceTrack puts it there: same producer id, same SSRC,
    // same transport, same RTMP link, and the audio producer never touched — so the two
    // stay in sync for the simple reason that neither of them restarted.
    const startScreenShare = () => {
        if (swappingShareRef.current || !hasVideoProducer()) return
        setSwappingShare(true)
        // In screen mode the camera is the picture-in-picture overlay rather than the thing
        // on the producer, so a camera that is on stays on — as its own capture.
        const keepCamera = cameraIsOn
        Promise.resolve(roomClient.swapVideoToScreen(videoLabel())).then((swapped)=>{
            if (!swapped){
                Notification.error("", "Could not start sharing your screen")
                abandonPendingShare()
                return
            }
            setShareTypeMode('screen')
            setCameraState(false)
            if (keepCamera) roomClient.opencamera()
            continueLocalRecording()
        }).catch((error)=>{
            // Cancelling the picker throws NotAllowedError, and nothing has been touched by
            // then: the camera is still live and the class never noticed. That is not a
            // failure worth a red banner.
            if (error?.name!=='NotAllowedError'){
                Notification.error("", "Could not start sharing your screen")
            }
            // No share is coming, so release whatever was queued behind one — the whiteboard
            // waiting to open, or a recording waiting for something to record. Left armed,
            // waitForScreenShare polls for a further 90 seconds and then drops the intent
            // without ever saying why.
            abandonPendingShare()
        }).finally(()=>{ setSwappingShare(false) })
    }

    // The other half: put the camera back on the producer the screen was riding, again
    // without stopping anything. A camera that was off stays off — the producer goes to the
    // same still frame a camera-off camera class sends, so the stream never has a gap.
    const stopScreenShare = () => {
        if (swappingShareRef.current || !hasVideoProducer()) return
        // What matters is whether anything real is left once the screen goes away, not which
        // producer happened to be carrying it. With the camera off there is nothing: the
        // fallback below is swapVideoToStill, a frozen frame, and publishing that kept the
        // teacher counting as live — the one-publisher rule is about the publish, not about
        // which track is on it — so the room stayed locked against everyone else while the
        // class watched a still image. End the publish instead and the room frees.
        //
        // Keying this on the producer label was wrong: a screen swapped onto a camera class
        // leaves videoLabel() at 'videoType' however the class started, so a teacher who had
        // since turned their camera off still came down here and still held the room.
        //
        // The mic counts as something real: with it on, the screen going away leaves a
        // mic-only class, not an empty publish, and ending everything would cut the teacher
        // off mid-sentence. Nothing left at all is handled by the teardown effect below —
        // it ends the publish and frees the room whichever button turned the last thing off.
        if (!cameraIsOn && micIsMuted){
            onShareClick()
            return
        }
        // The camera is on, so a real broadcast survives the share and goes on holding the
        // room. This ends the share and not the class, exactly as before.
        setSwappingShare(true)
        // The board is only visible to the class through the shared screen, so it cannot
        // outlive the share.
        setWhiteboard(false)
        const keepCamera = cameraIsOn
        // The overlay capture is about to become the producer's own track again, so release
        // it first rather than holding two captures of one device open.
        roomClient.stopcamera()
        const restore = keepCamera
            ? roomClient.swapVideoToCamera(videoLabel())
            : roomClient.swapVideoToStill(videoLabel(), paintStageFrame)
        Promise.resolve(restore).then((swapped)=>{
            if (!swapped){
                Notification.error("", "Could not stop the screen share")
                return
            }
            setShareTypeMode('camera')
            setCameraState(keepCamera)
            continueLocalRecording()
        }).catch(()=>{
            Notification.error("", "Could not stop the screen share")
        }).finally(()=>{ setSwappingShare(false) })
    }
    // Read by the roomClient event handler, which closes over the first render and would
    // otherwise call a stop that still believes the camera is off.
    stopScreenShareRef.current = stopScreenShare;

    // What the share button does now: it owns the screen and nothing else. Ending the class
    // is End class, and turning the picture or the sound off is the camera and mic buttons —
    // so this never stops the stream, which is what made it read "Stop stream" over a class
    // that was only showing a camera.
    const onScreenShareToggle = () => {
        claimTransition('screen')
        if (isRecording.current===1){
            Notification.warning("", "Recording is still starting. Wait for it before changing what you share")
            return
        }
        // Nothing published, or the mic on its own: there is no producer to swap a track on,
        // so this is an ordinary publish and onShareClick already knows how to do one.
        if (isPublishing===0 || (isPublishing===2 && audioOnlyRef.current)){
            setShareTypeMode('screen')
            onShareClick()
            return
        }
        if (isPublishing!==2) return
        if (shareType==='screen'){
            stopScreenShare()
        }else{
            startScreenShare()
        }
    }

    // Is a picture going out? Camera, screen share or the board — the three producers that
    // put video on the wire, and the three the Mic button now hangs off.
    //
    // Read from shareMode rather than the module-level shareType: this drives what the
    // control bar renders, and only the state copy guarantees a render when it changes.
    //
    // The isPublishing===2 gate is not a formality. shareType starts life as 'screen' at
    // module scope, so 'shareMode is screen' is true on the very first render of every
    // class — long before anything is published. Without the gate this reads as "a screen
    // share is on" while the bar sits idle, which is the Mic button appearing next to
    // Camera off / Share screen / Whiteboard with nothing being sent at all. Only a live
    // publish can be sending a picture; the same rule the bar's own isSharingScreen uses.
    const isSendingVideo = isPublishing===2 && (
        cameraIsOn || (shareMode==='screen' && !audioOnly) || whiteboard
    )

    // Is anything actually going out? Mic, camera, screen or the board — any one of them is
    // a broadcast; none of them is an idle publish that nobody can see or hear.
    const isSendingAnything = isSendingVideo || (isPublishing===2 && !micIsMuted)

    // The mic follows the picture, both ways.
    //
    // Off: the Mic button is only on the bar while one of the three video producers is on,
    // so a mic still running after the last one went off would be live with no control
    // anywhere on screen — the class would go on hearing the room. Muting it means the
    // button and the thing it controls go together.
    //
    // On: a picture coming back brings the mic with it. Teaching with a camera on and no
    // sound is not a state anyone means to be in, and the first thing a teacher does after
    // turning a camera on is talk.
    //
    // The one thing that beats "video on means mic on": the teacher pressing Mic themselves.
    // Without it this could only be level-triggered — unmute whenever video is on — and
    // micIsMuted is a dependency, so every deliberate mute would re-run the effect, find
    // video still on, and unmute again. A Mic button that cannot turn the mic off.
    //
    // Set by the bar's own button and nothing else, which matters: applying the lobby's
    // choices calls onMicClick programmatically, and that is not somebody reaching for the
    // control mid-class. Cleared whenever the picture goes, so the next one starts fresh.
    const micUserMutedRef = useRef(false)
    const videoWasOnRef = useRef(false)
    useEffect(()=>{
        if (isPublishing!==2){
            // Not live: nothing to mute, and the next publish starts a fresh crossing.
            videoWasOnRef.current = false
            micUserMutedRef.current = false
            return
        }
        const wasOn = videoWasOnRef.current
        videoWasOnRef.current = isSendingVideo
        if (!isSendingVideo){
            // Only the falling edge here: a publish comes up unmuted and its camera is
            // registered a render or two later, so a level test would mute on that gap and
            // unmute again immediately after — a visible flap, and a pause/resume on the
            // audio producer at the worst possible moment.
            if (wasOn && !micIsMuted){
                roomClient?.mute?.()
                setMuteState(true)
            }
            // An automatic mute is not the teacher's choice, so it must not suppress the
            // unmute the next picture brings with it.
            micUserMutedRef.current = false
            return
        }
        // Level-triggered on the way up, deliberately. The rising edge alone was not enough:
        // a publish comes up unmuted, so the crossing into video finds nothing to do, and
        // anything that mutes a render later — the lobby's own "Mic off" being applied, most
        // of all — then stuck, leaving exactly the camera-on-mic-off the bar was showing.
        // Asking about the state rather than the transition catches all of those, and the
        // ref above is what keeps a hand-muted mic muted.
        if (!micIsMuted || micUserMutedRef.current) return
        roomClient?.unMute?.()
        setMuteState(false)
    }, [isPublishing, isSendingVideo, micIsMuted])

    const isSendingAnythingRef = useRef(false)
    isSendingAnythingRef.current = isSendingAnything
    // Whether this session has ever had something on the wire. Going live and the first
    // 'cameraOn'/unmute landing are two separate renders, so a fresh publish passes through
    // a tick where nothing is on yet — without this, the teardown below would fire on it.
    const hasSentAnythingRef = useRef(false)

    // The room holds one publisher, so a teacher who is live but sending nothing still locks
    // everyone else out of going live. There used to be a Stop stream button for exactly
    // that, which asked the teacher to do by hand what turning the last thing off already
    // means: end the publish. Turning mic, camera, screen and board all off is that request,
    // so the publish comes down on its own and the room frees for the next teacher.
    useEffect(()=>{
        if (isPublishing!==2){
            hasSentAnythingRef.current = false
            return undefined
        }
        if (isSendingAnything){
            hasSentAnythingRef.current = true
            return undefined
        }
        if (!hasSentAnythingRef.current) return undefined
        let timer = null
        const tearDown = () => {
            // Anything turned back on in the meantime, or the publish already ended.
            if (isPublishingRef.current!==2 || isSendingAnythingRef.current) return
            // A recording mid-handshake cannot be torn down under — wait for it to settle
            // and try again, rather than dropping the publish into a half-started recording.
            if (isRecording.current===1){
                timer = setTimeout(tearDown, 1000)
                return
            }
            setWhiteboard(false)
            stopPublishing()
        }
        timer = setTimeout(tearDown, 0)
        return ()=>{ if (timer) clearTimeout(timer) }
    }, [isPublishing, isSendingAnything])

    // Cash in the claim, once, on the edge into the in-between state, and hold it there for
    // the whole transition — reading it on every render would let it expire underneath a
    // spinner that is still turning and hand the label back to the share button mid-stop.
    // Anything that settles the publish clears it, so the next transition starts unowned.
    useEffect(()=>{
        if (isPublishing!==1){
            transitionClaimRef.current = null
            setTransitionOwner(null)
            return
        }
        const claim = transitionClaimRef.current
        setTransitionOwner(claim && (Date.now()-claim.at) < TRANSITION_CLAIM_MS ? claim.control : null)
    }, [isPublishing])

    // The prompt is a question about a camera that is on. If it goes off — from this dialog,
    // from the control bar, or because the share ended — the question has answered itself
    // and the dialog should not be left sitting there over a class with no video.
    // Ignoring a snackbar is a valid answer, so it expires rather than waiting to be
    // dismissed. Safe to let it go: the ABR controller will not raise another for
    // WEAK_PROMPT_COOLDOWN_MS, so nothing flickers straight back.
    useEffect(()=>{
        if (!weakNetworkPrompt) return undefined
        const id = setTimeout(()=>setWeakNetworkPrompt(null), WEAK_NOTICE_MS)
        return ()=>clearTimeout(id)
    }, [weakNetworkPrompt])
    useEffect(()=>{
        if (!cameraIsOn || isPublishing!==2) setWeakNetworkPrompt(null)
    }, [cameraIsOn, isPublishing])
    // Out of space means no space at all, not "not enough for this recording" - that
    // figure only exists once the class has ended. isSubscriptionExpired is the library's
    // other way of refusing content, and the upload flows already treat the two as one
    // case (see createCourseModal.js).
    const isOutOfStorage = (details) => {
        if (details?.isSubscriptionExpired) return true
        const available = details?.spaceAvailable
        return available != null && !isNaN(Number(available)) && Number(available) <= 0
    }
    // The figure AulasSubscriptionModal prints, in bytes - it is also what picks the
    // 'Storage Limit Reached' wording over 'Storage Full!', so it must be a number and
    // never null here. Clamped to 0 for an expired subscription, where whatever space is
    // left cannot be used and quoting it back would read as though the recording had room.
    const availableBytesFor = (details) => {
        if (details?.isSubscriptionExpired) return 0
        const available = Number(details?.spaceAvailable)
        return Number.isFinite(available) && available > 0 ? available : 0
    }
    const onRecord = () => {
        // Say what is missing before the modal rather than after Confirm: the chapter/topic
        // fields in there take real work to fill in, and nothing can be recorded anyway.
        if (isRecording.current===0){
            // The mic is non-negotiable in both modes — a recording with no sound is not one.
            if (!hasAudioProducer()){
                Notification.warning("", "Turn on your mic before recording — the class would be recorded without any sound")
                return
            }
            // Having no video yet is no longer a dead end. A live mic-only class that asks to
            // record online is going to be asked for its screen anyway, and that screen is the
            // missing video: turning the teacher away here would send them off to start a share
            // by hand for no reason. Let the modal open so the mode can be chosen, and let
            // onConfirm ask for the screen when the answer is Online. Offline still needs
            // something to record, and canStartRecording says so from inside onConfirm.
            if (!hasVideoProducer() && isPublishing!==2){
                Notification.warning("", "Start your camera, screen share or whiteboard first, then press REC to record the class")
                return
            }
            setRecordModalVisible(true)
            return
        }
        setRecordModalVisible(true);
    }
    const onCancel = () => {
        setRecordModalVisible(false);
    }
    const registerFileName = (fileName) => {
        const params = {
            fileName: fileName,
            topicName: fileName?.replaceAll('_namespace_',' '),
            roomName: streamId?.split('xxxx')[1],
            hideMsg:true
          }
        if (isOfflineRecordingRef.current){
            if (!(streamId in localRecordingName)){
                if (cardData){
                    cardData.recordingName = fileName
                }
                BroadcastRecordingEdit(params)
                setLocalRecordingName(streamId, fileName);
            }
        }else{
            // Online recordings must be tagged with a chapter/topic per batch (see
            // recordingBatches, set via the Chapter/Topic fields in RecordingModal) — a
            // single Broadcast class can span multiple standards, each needing its own
            // chapter/topic, even though it's all one recorded file. Keep the first
            // batch's values as flat chapterId/chapterName/topicId too, for any backend
            // handling that only reads a single value, alongside the full per-batch list.
            const firstBatch = recordingBatches?.[0] || {};
            params.chapterId = firstBatch.chapterId;
            params.chapterName = firstBatch.chapterName;
            params.topicId = firstBatch.topicId;
            params.chapters = recordingBatches;
            if (activeClass.occurance.videoResourceIds?.length && recordCount==0){
                let params = {
                    videoResourceIds:activeClass.occurance?.videoResourceIds,
                    sectionId: selectedSection.id===-1?undefined:selectedSection.id,
                    sectionName: selectedSection.name,
                    fileName: fileName,
                    streamId: streamId,
                    roomName: streamId?.split('xxxx')[1],
                    fileUrl: streamId,
                    chapterId: firstBatch.chapterId,
                    chapterName: firstBatch.chapterName,
                    topicId: firstBatch.topicId,
                    chapters: recordingBatches,
                  }
                postRecordedVideoLesson(params, ()=>{}, ()=>{})
              }else{
                postRecordCount({roomId:streamId?.split('xxxx')[1]}, ()=>{}, ()=>{})
              }
              if (recordCount===0){
                if (cardData){
                    cardData.recordingName = fileName
                }
                BroadcastRecordingEdit(params)
              }
        }
    }
    const onConfirm = (fileName, isOffline=true) => {
        if (isRecording.current==1){
            return
        }
        // A muted mic is not a missing mic — roomClient.mute() pauses the producer, which
        // leaves the track in place with enabled=false, so the recording runs and captures
        // silence. Nothing to block on, but the teacher should hear about it once.
        if (isRecording.current===0 && micIsMuted){
            Notification.warning("", "Your mic is muted. Unmute it or the recording will have no sound")
        }
        fileName = fileName?fileName:' '
        fileName = fileName.trim(' ')?.split(' ').join('_namespace_')
        const proceedWithRecording = () => {
            if (isRecording.current===0){
                isOfflineRecordingRef.current = isOffline
                recordFileNameRef.current = fileName
            }
            if (isRecording.current===0 && recordingNeedsShare(isOfflineRecordingRef.current)){
                pendingRecordRef.current = {fileName, isOffline: isOfflineRecordingRef.current}
                setRecordModalVisible(false)
                setShareModalReason('record')
                setShareModalStep('pick')
                return
            }
            if (isOfflineRecordingRef.current){
                if (isRecording.current===0){
                    if (!canStartRecording()) return
                    registerFileName(fileName)
                    roomClient.startLocalRecording(videoLabel());
                    recordingStarted();
                }else if (isRecording.current===2){
                    roomClient.stopLocalRecording();
                    recordingStopped();
                    setRecordDownloadModalVisible(true)
                }
                return
            }else{
                if (isRecording.current==2){
                    ismanuallystoppingrecording.current = true
                    isRecording.current = 1
                    isAttemptingRecord.current = true
                    setRecording(1)
                    roomClient.stopRecord()
                }else if (isRecording.current==0){
                    if (!canStartRecording()) return
                    isRecording.current = 1
                    setRecording(1)
                    registerFileName(fileName)
                    isAttemptingRecord.current = true
                    roomClient.startRecord(fileName)
                }
                toggleReloader()
            }
        };

        if (isRecording.current === 0 && !isOffline) {
            if (storageCheckRef.current) return;
            storageCheckRef.current = true;
            isRecording.current = 1;
            setRecording(1);
            getStorageDetails(null, (details) => {
                storageCheckRef.current = false;
                isRecording.current = 0;
                setRecording(0);
                if (details && isOutOfStorage(details)) {
                    setStorageAvailableBytes(availableBytesFor(details));
                    setStorageModalVisible(true);
                    setRecordModalVisible(false);
                    return;
                }
                proceedWithRecording();
            });
            return;
        }

        proceedWithRecording();
    }

    const onDownloadLocalRecording = () => {
        recorder.externalDownloadRecording(streamId, (streamId in localRecordingName)?localRecordingName[streamId]:'default');
        setRecordDownloadModalVisible(false)
        if (leaveClickedRef.current){
            exitClass();
        }
    }
    
    const onDeleteLocalRecording = () => {
        recorder.externalClearData();
        setRecordDownloadModalVisible(false)
        if (leaveClickedRef.current){
            exitClass();
        }
    }

    // Where End class lands. The route wrapper owns that decision — back to the pre-join
    // screen while the class is still inside its scheduled slot, or the schedule home page
    // once the slot has passed — because it is the wrapper that holds both screens. Falls
    // back to the old behaviour wherever <Broadcast/> is mounted without the wrapper.
    const exitClass = () => {
        if (onEndClass){
            // Whether another teacher's class is still running is the one thing the wrapper
            // cannot see for itself — its lobby socket is torn down for as long as this
            // class is mounted, so it has no heartbeats to read. `isPublishing!==2` is what
            // keeps this teacher's own publish out of the answer: the room holds one
            // publisher, so if ours is the stream on the wire then nobody else's is, and
            // what we are leaving behind is a room that can be walked back into.
            onEndClass({othersLive: isAnyonePublishing && isPublishing!==2});
            return;
        }
        history.goBack();
    }

    const onLeave = () => {
        leaveClickedRef.current = true
        ismanuallystoppedproducing.current = true
        ismanuallystoppingrecording.current = true
        if (isOfflineRecordingRef.current && isRecording.current===2){
            roomClient.stopLocalRecording();
            setRecordDownloadModalVisible(true);
        }else{
            exitClass();
        }
    }

    const onUnmount = () => {
        clearStopWatchdog();
        // Hand the class's data usage to the tracker and post it. This is the LIVE module
        // that consumptionTracker has always declared and nothing ever wrote — see
        // trackLiveSession. Fire-and-forget: leaving the class must not wait on analytics.
        try {
            const totals = netTotalsRef.current || {bytesSent: 0, bytesReceived: 0};
            if (totals.bytesSent || totals.bytesReceived){
                // Constructor returns the existing singleton, so this is the same tracker
                // the digital-library player and recordConsumption use.
                const consumptionTracker = new ConsumptionTracker();
                consumptionTracker.setNetworkTotals({
                    received: totals.bytesReceived,
                    sent: totals.bytesSent,
                });
                consumptionTracker.trackLiveSession({
                    id: streamId,
                    durationMs: (joinedAtRef.current ? Date.now() - joinedAtRef.current : 0),
                    received: 0,
                    sent: 0,
                });
                recordConsumption().catch(()=>{});
            }
        } catch (error) {
            // analytics only — never block the exit
        }
        // Prints the per-phase table. Independent of the block above, which only runs when
        // bytes actually moved, so a session that published nothing still gets its summary.
        try {
            consumptionPhaseLogger.finish();
        } catch (error) {
            // console instrumentation — never block the exit
        }
        navigator.mediaDevices?.removeEventListener("devicechange", throttledUpdateDeviceList);
        chatClientRef.current?.sendGroupChat(sessionuser.id, streamId, 
            {
                type: 'Event',
                data: {
                    state:false,
                    user:sessionuser
                },
            }
            )
        stopPublisherInterval();
        clearTimeout(broadcastHealthTimer);
        broadcastHealthTimer = null
        clearGroupChat();
        clearPrivateChat();
        setRightView(false);
        setRightViewType('');
        roomClient?.stopcamera();
        roomClient?.socket?.removeAllListeners();
        roomClient?.socket?.off();
        roomClient?.exit();
        chatClient?.disconnect();
        setChatClient(null);
        if (chatClientRef.current){
            chatClientRef.current?.disconnect();
            chatClientRef.current = null;
        }
    }
    const onMenuClick = () => {
        setMenuVisible((prev)=>!prev)
        closeRightView();
    }
    const closeRightView = () => {
        setRightView(false);
        setRightViewType('');
    }

    const toggleSideMenu = (type) => {
        if ((rightView==false)||(rightViewType=='')){
            setRightView(true);
            setRightViewType(type);

        }
        else{
            if (rightViewType==type){
                setRightView(false); 
            }
            else{
            setRightViewType(type);}
        }
    }

    const onParticipantsClick = () => {
        toggleSideMenu('participantsView')
    }
    const onPrivateChatClick = () => {
        toggleSideMenu('privateChatView')
    }
    const onGroupChatClick = () => {
        toggleSideMenu('groupChatView')
    }

    // The whiteboard goes out as itself now, not as a picture of itself.
    //
    // It used to reach the class only through a screen share: getDisplayMedia, the browser's
    // picker, and the teacher having to find their own window in a list of their windows in
    // order to show a board this app had drawn. But the board is not a screen — it is a stack
    // of <canvas> elements on this very page, and a canvas hands out a MediaStream directly.
    // boardCapture.js composites the layers, captureStream() produces the track, and the
    // producer takes it like any other. No picker, no user gesture to spend, and nothing of
    // the teacher's desktop on the wire but the board.
    //
    // That is also why the share dialog is gone from this path. It existed to be the click
    // getDisplayMedia needed before it would show its picker, and to explain why a teacher who
    // asked for a whiteboard was being asked to choose a window. Neither applies any more.
    const onWhiteboardClick = () => {
        claimTransition('whiteboard')
        if (whiteboard){
            closeBoard()
            return
        }
        // Drawing over a shared screen. The board is an overlay on the picture already going
        // out, exactly as before — the producer is carrying the screen and nothing changes.
        if (isPublishing===2 && shareType==='screen'){
            setWhiteboard(true)
            return
        }
        if (isPublishing===1){
            Notification.warning("", "The stream is still starting. The whiteboard opens once it is live")
            return
        }
        if (isPublishing===2){
            openBoardLive()
            return
        }
        // Publishing from idle, so the same one-publisher rule the share button answers to.
        if (ifAnyOnePublishing()){
            Notification.error("", "Stop the existing stream, to start publishing");
            return
        }
        boardIntentRef.current = true
        setShareTypeMode('board')
        onShareClick()
        // After onShareClick, not before it, and not deferred to a publish-landed effect.
        // onShareClick clears this flag on its way through, so setting it first would be
        // undone — and waiting for isPublishing to reach 2 would be too late: the video
        // producer is built at 'audioAdded', a good deal earlier than that, and the board has
        // to be mounted by then for the capture to have anything to composite. Both writes
        // land in the same batched event handler, so this is the one that survives.
        setWhiteboard(true)
    }

    // Put the board on a producer that is already live — the teacher opened the whiteboard
    // during a camera class or a mic-only one. A shared screen never comes here: there the
    // board stays an overlay on the screen that is already going out.
    const openBoardLive = () => {
        if (swappingShareRef.current) return
        setSwappingShare(true)
        const previousMode = shareType
        const keepCamera = cameraIsOn
        const failed = () => {
            setShareTypeMode(previousMode)
            setWhiteboard(false)
            Notification.error("", "Could not put the whiteboard on the stream")
        }
        // The board is mounted by the boardMode branch of the render, which reads this flag —
        // so opening it is what puts it on the page, and the capture wants something to
        // composite before it starts rather than a white rectangle for its first frames. Both
        // of these are put back by failed() if the attach does not come off.
        setWhiteboard(true)
        setShareTypeMode('board')
        // Mic-only: there is no video producer to swap a track on, so the board becomes one.
        // Same route onShareClick takes when a camera joins a mic-only class.
        const attach = !hasVideoProducer()
            ? () => {
                const label = videoLabel()
                boardIntentRef.current = true
                return Promise.resolve(roomClient.produce(label, false, 'board'))
                    .then(()=>!!roomClient?.producerLabel?.has(label))
            }
            // A camera class, or one sitting on the still frame: the board replaces whatever
            // track is on the producer without the producer, the RTMP link, the audio or a
            // running recording being touched. See roomClient.swapVideoToBoard.
            : () => Promise.resolve(roomClient.swapVideoToBoard(videoLabel()))
        waitForBoard().then(attach).then((ok)=>{
            if (!ok){
                failed()
                return
            }
            setAudioOnlyMode(false)
            // In board mode the camera is the picture-in-picture overlay rather than the thing
            // on the wire — boardCapture composites it into the frame — so a camera that was on
            // carries on as its own capture. setCameraState(false) before opencamera() rather
            // than instead of it: the 'cameraOn' event is what turns it back, exactly as in
            // startScreenShare.
            setCameraState(false)
            if (keepCamera) roomClient.opencamera()
            continueLocalRecording()
        }).catch(failed).finally(()=>{ setSwappingShare(false) })
    }

    // The board is mounted by shouldRenderPassiveCanvas, one render after shareType says
    // 'board'. boardCapture falls back to a white frame when it is not up yet, so this is
    // about the first moment of a board looking like a board rather than about correctness —
    // which is also why it resolves rather than rejects when the board never arrives.
    const waitForBoard = (attempts=20) => new Promise((resolve)=>{
        const tick = (left) => {
            if (isBoardReady() || left<=0){ resolve(true); return }
            setTimeout(()=>tick(left-1), 50)
        }
        tick(attempts)
    })

    // Take the board off the wire: the mirror of openBoardLive, and of stopScreenShare for
    // the screen. The producer stays exactly where it is and only the track on it changes.
    const closeBoard = () => {
        // Drawn over a shared screen, or nothing live at all — the board was never on the
        // producer, so closing it just takes the drawing surface away.
        if (isPublishing!==2 || shareType==='screen'){
            setWhiteboard(false)
            return
        }
        if (swappingShareRef.current) return
        // Nothing real is left once the board goes. Publishing a blank frame would keep the
        // room's one publisher slot held against everyone else, so the broadcast ends instead
        // — the same answer stopScreenShare gives, and for the same reason.
        if (!cameraIsOn && micIsMuted){
            setWhiteboard(false)
            setShareTypeMode('camera')
            onShareClick()
            return
        }
        setSwappingShare(true)
        setWhiteboard(false)
        const keepCamera = cameraIsOn
        // Closing a board over a live camera failed here, every time, and took the camera
        // with it. The overlay capture used to be stopped on this line, before the swap, to
        // avoid holding two captures of one device at once — but a camera does not release
        // synchronously. The getUserMedia inside swapVideoToCamera then asked the OS for a
        // device it had just let go of, got NotReadableError back, and the catch below
        // reported "Could not close the whiteboard"; the overlay was already dead by then,
        // so the teacher was left with the board closed and no camera either.
        //
        // The two captures overlap instead. Chrome hands out more than one stream from a
        // camera quite happily, and the overlay is released in the success branch once the
        // producer is holding a camera of its own — silently, because swapVideoToCamera has
        // already announced that camera, and an off after it would describe the wrong one.
        const restore = keepCamera
            ? roomClient.swapVideoToCamera(videoLabel())
            : roomClient.swapVideoToStill(videoLabel(), paintStageFrame)
        // Nothing about the producer changed if the swap did not happen — the board is still
        // the track on the wire. So put the screen back to what the class is actually being
        // sent, rather than leaving a closed board over a board still being published, and
        // leave the camera overlay running so the retry has something to swap back.
        const restoreFailed = () => {
            setWhiteboard(true)
            setShareTypeMode('board')
            Notification.error("", "Could not close the whiteboard. Please try again.")
        }
        Promise.resolve(restore).then((swapped)=>{
            if (!swapped){
                restoreFailed()
                return
            }
            roomClient.stopcamera(false)
            setShareTypeMode('camera')
            setCameraState(keepCamera)
            continueLocalRecording()
        }).catch(()=>{
            restoreFailed()
        }).finally(()=>{ setSwappingShare(false) })
    }
    // Only the recording flow reaches this now. The whiteboard branch that used to live here
    // is gone with the picker it existed for: the board publishes its own canvas and never
    // asks the browser for a screen, so it neither needs this dialog nor waits on a share.
    const onShareModalConfirm = () => {
        const swapping = isPublishing===2 && !audioOnlyRef.current
        setShareModalStep(null);
        // Replay the record choice the teacher already made, now that it can be honoured.
        // Nothing is pending on the pre-join route — the startPrefs effect below starts that
        // recording itself once both producers are up.
        waitForScreenShare(()=>{
            const pending = pendingRecordRef.current
            pendingRecordRef.current = null
            if (pending) onConfirm(pending.fileName, pending.isOffline)
        })
        // Already live with a picture on the wire: the screen goes onto the producer that is
        // already carrying it. Closing that producer and opening another one is what used to
        // happen here, and the note that stood in its place was right that it cost the RTMP
        // link — this server ends the link with the producer and does not raise it again for
        // the replacement. replaceTrack never closes the producer, so none of that applies:
        // the link, the audio producer and any running recording all carry on. See
        // roomClient.swapVideoToScreen.
        if (swapping){
            startScreenShare()
            return
        }
        setShareTypeMode('screen')
        onShareClick()
    }

    // Opens the per-phase consumption log for this class. Mount, not publish: a student
    // never publishes and their download is the whole story for them. Runs once — the ids it
    // reads are fixed for the life of the page, and restarting would throw away the phases.
    useEffect(()=>{
        consumptionPhaseLogger.start({selfId: sessionuser?.id, streamId});
    }, []);

    // Two things a teacher cannot tell at a glance, announced once each on the way in and
    // whenever they change: whether the class is being recorded, and whether the connection
    // has gone bad. Students are left out of the recording notice — recording state is the
    // publisher's, so their client has nothing truthful to report.
    const joinNoticeRef = useRef(false);
    const wasInternetSlowRef = useRef(false);
    useEffect(()=>{
        if (isStudentUser || connecting || joinNoticeRef.current) return
        // ...and for exactly the same reason, a teacher who is watching somebody else's
        // class is left out too. Recording belongs to whoever holds the room's single
        // publisher slot; a teacher who joined a class already in progress has no recording
        // of their own to have started or skipped, so "class has started without recording"
        // reports another teacher's decision back to them as though it were theirs, about a
        // class they cannot record and did not start.
        //
        // Two ways to be that teacher, and they need different evidence. autoJoined is the
        // one the lobby walked straight in: it is true from the first render, which matters
        // because the heartbeat that decided it was heard on the lobby's socket and this
        // class has only just opened its own — isAnyonePublishing can still be false here.
        // The publisher check covers the one who pressed Re-join with a class already on the
        // wire. Both are conditioned on not publishing, so neither silences the notice once
        // this teacher does start a class of their own — which is why isPublishing is in the
        // deps below, so that moment re-runs this.
        if (isPublishing!==2 && (startPrefs?.autoJoined || isAnyonePublishingRef.current)) return
        // Titled with the severity word, the way every backend snackbar in the app is:
        // Api.js calls Notification[show.type](show.type, show.message), so "success" and
        // "warning" over the message is what a user here already reads everywhere else.
        if (isRecordingState===2){
            joinNoticeRef.current = true
            Notification.success("success", "class has started with recording")
            return
        }
        if (!startPrefs?.recording){
            joinNoticeRef.current = true
            Notification.warning("warning", "class has started without recording")
            return
        }
        const announcePending = () => {
            if (joinNoticeRef.current) return
            joinNoticeRef.current = true
            Notification.warning("warning", "Recording starts once you share your camera, screen or whiteboard with the mic on")
        }
        // Nothing is coming up to record: the pre-join screen was left with the camera off,
        // so the class starts on the mic alone (or on nothing at all) and the recording
        // waits for a share either way. That is already known here, on the way in, so say it
        // now instead of after a grace period that has nothing to wait for.
        if (!startPrefs.camOn){
            announcePending()
            return
        }
        // Chosen on pre-join and a share is on its way: it begins with the first thing
        // published, so wait a few seconds for that before claiming either way. If it does
        // start, this effect runs again on the new state and the timeout is cleared.
        const pendingNotice = setTimeout(announcePending, 8000)
        return ()=>clearTimeout(pendingNotice)
        // isPublishing: see the viewer bail at the top. It also moves the grace period above
        // to start from the publish rather than from the end of connecting, which is the
        // thing it was always waiting for.
    }, [connecting, isStudentUser, isRecordingState, startPrefs, isPublishing])

    useEffect(()=>{
        if (isPublishing===0) return
        if (isInternetSlow && !wasInternetSlowRef.current){
            wasInternetSlowRef.current = true
            // Notification.warning("", "Your network connection is poor. Audio and video may drop")
        }else if (!isInternetSlow && wasInternetSlowRef.current){
            wasInternetSlowRef.current = false
            // Notification.success("", "Network connection is back to normal")
        }
    }, [isInternetSlow, isPublishing])

    // Carries the pre-join choices into the room, once. `startPrefs` is only supplied by
    // broadcastGate — rendering <Broadcast/> directly keeps the old manual Share flow.
    // Publishing always starts in 'camera' mode here: it is getUserMedia, so unlike a
    // screen capture it does not need a fresh user gesture.
    const startPrefsApplied = useRef({publish:false, devices:false, record:false});
    // startLocalRecording reads allTracks for this label and browserRecorder swallows the
    // failure (it just returns -1), so a recording started before the track exists looks
    // like it is running and records nothing. Check the producer is really there first.
    const hasVideoProducer = () => !!roomClient?.producerLabel?.has(videoLabel())
    // roomClient.startLocalRecording reads the audio producer's stream without checking it
    // exists, so a missing mic throws out of the click handler and the REC pill is left
    // half-toggled. Both halves of the mix are checked here instead.
    const hasAudioProducer = () => {
        const producerId = roomClient?.producerLabel?.get('audioType')
        return !!(producerId && roomClient?.allTracks?.get(producerId)?.getAudioTracks?.()?.length)
    }
    // "Is a screen being shared", which is no longer answered by the producer's label: a
    // screen swapped onto a camera class rides the producer that was created as 'videoType'.
    // shareType is what says which of the two is on the wire.
    const hasScreenProducer = () => shareType==='screen' && hasVideoProducer()
    // What a recording actually needs, in both modes, is one video producer and one audio
    // producer — never a screen in particular. This used to demand a screen share for an
    // online recording, on the belief that the backend raised the RTMP link around the
    // screen producer; it does not. Nothing server-side reads a label: `producerLabel` is
    // commented out in Peer.js, `customType` is read nowhere, and every branch in the
    // recorder is on `producer.kind` — audio or video. A camera-only class records fine as
    // long as the mic is on, which is also exactly what the offline MediaRecorder path has
    // always done. So the only thing worth asking for is a video producer when there is no
    // picture at all; canStartRecording() checks both halves either way. Left to the online
    // mode alone, as before — an offline recording that has nothing to record is told so by
    // canStartRecording() rather than being sent to the picker, and that is unchanged.
    const recordingNeedsShare = (isOffline) => !isOffline && !hasVideoProducer()
    // The two ways a screen share can start differ in whether isPublishing ever moves. A
    // switch away from the camera tears the publish down and builds it back (2 -> 1 -> 0 ->
    // 1 -> 2); adding a screen to a mic-only session never leaves 2. An effect keyed on
    // isPublishing therefore fires for the first and never for the second — which is why
    // opening the whiteboard from a mic-only class started the share and left the board shut.
    // Waiting on the producer itself covers both.
    const waitForScreenShare = (action) => {
        afterScreenShareRef.current = action
        let waited = 0
        const timer = setInterval(()=>{
            // Superseded or cancelled: something else owns the outcome now.
            if (afterScreenShareRef.current !== action){ clearInterval(timer); return }
            if (hasScreenProducer()){
                clearInterval(timer)
                afterScreenShareRef.current = null
                action()
                return
            }
            waited += 500
            // Covers the 15s teardown plus however long the picker is left sitting open.
            if (waited >= 90000){
                clearInterval(timer)
                afterScreenShareRef.current = null
            }
        }, 500)
    }
    // A recording is one video track plus one audio track and nothing else, so the only
    // honest answer to "record this class" with nothing shared is to say what is missing.
    // Returns false having already told the teacher which one it is.
    const canStartRecording = () => {
        if (!hasVideoProducer()){
            Notification.warning("", isPublishing===2
                ? "Nothing to record yet. Share your camera, screen or whiteboard, then press REC"
                : "Start your camera, screen share or whiteboard first, then press REC to record the class")
            return false
        }
        if (!hasAudioProducer()){
            Notification.warning("", "Turn on your mic before recording — the class would be recorded without any sound")
            return false
        }
        return true
    }
    // The switch was abandoned — the picker was cancelled, or permission refused — so no new
    // producer is coming and the recording really has ended. The chunks only exist in the
    // room database, so the save prompt that was held back has to be offered now.
    const abandonRecordingResume = () => {
        if (!recordingWasOnRef.current) return
        recordingWasOnRef.current = false
        if (isOfflineRecordingRef.current){
            setRecordDownloadModalVisible(true)
        }
        Notification.warning("", "Recording stopped when the share ended. Save it below, then press REC to start a new one")
    }
    // Re-arms the recording on the producer the switch just built. A local recording lands in
    // the same room database under its own groupId and comes out as another file in the zip —
    // the same continuation restartLocalRecording performs across a camera swap — and a
    // server-side one resumes under the name it already had, so the class does not end up
    // filed in two places. The producers appear a moment after isPublishing turns 2 and
    // startLocalRecording silently records nothing if its track is not there yet, so this
    // waits for both halves rather than firing on the first render.
    useEffect(()=>{
        if (isPublishing!==2 || !recordingWasOnRef.current) return undefined
        let attempts = 0
        let timer = null
        const finish = () => { if (timer) clearInterval(timer); timer = null }
        const tryResume = () => {
            if (!recordingWasOnRef.current){ finish(); return }
            if (!hasVideoProducer() || !hasAudioProducer()){
                // 10s. Long enough for a slow getDisplayMedia, short enough that a teacher is
                // told rather than left believing the class is still being recorded.
                if (++attempts > 20){
                    recordingWasOnRef.current = false
                    finish()
                    Notification.warning("", "Recording could not be resumed after the switch. Press REC to start it again")
                }
                return
            }
            recordingWasOnRef.current = false
            finish()
            if (isOfflineRecordingRef.current){
                // Harmless when it already stopped (browserRecorder swallows it), and
                // necessary when the stop watchdog forced the teardown without ever reaching
                // rtmpRemoved: the recorder would still be holding the track that just died.
                roomClient.stopLocalRecording();
                roomClient.startLocalRecording(videoLabel());
                // resetTimer false: the class is still the same recording, so the clock in the
                // header picks up where it stopped instead of appearing to start over.
                recordingStarted(false);
            }else{
                isRecording.current = 1
                setRecording(1)
                isAttemptingRecord.current = true
                keepRecordTimerRef.current = true
                roomClient.startRecord(recordFileNameRef.current || 'default')
            }
            Notification.success("", "Recording resumed")
        }
        timer = setInterval(tryResume, 500)
        tryResume()
        return ()=>{ if (timer) clearInterval(timer) }
    }, [isPublishing]);
    useEffect(()=>{
        // A student has no lobby start to wait for, so nothing should be spinning for them.
        if (!startPrefs || isStudentUser){
            // Unconditional: React bails out of a set to the value already held, so this
            // needs no read of the state and therefore no dependency on it.
            setPendingStartControl(null)
            return
        }
        if (connecting || !publishEvidenceReady) return
        if (isPublishing===0 && !startPrefsApplied.current.publish){
            startPrefsApplied.current.publish = true
            // The wait is over however this block ends. Every branch below either starts the
            // publish — and isPublishing moving to 1 takes the spinner over in the same
            // batch, so there is no frame where the bar goes idle in between — or decides
            // not to, and then idle is the honest thing to show.
            setPendingStartControl(null)
            // Someone else has the room. onShareClick would stop this anyway, but its message
            // is written for a teacher who chose to share — this one never clicked anything,
            // so say what actually happened to the class they were expecting to start.
            // Marked applied above, so it does not keep retrying: starting later is a
            // decision for the teacher to make with a button, not one to make for them
            // several minutes after they joined.
            if (ifAnyOnePublishing()){
                // Two ways to arrive here, and only one of them is a thwarted intention. A
                // teacher who pressed Start class was told their class would begin and it has
                // not, so the warning stands. One the lobby auto-joined (startPrefs.autoJoined
                // — the room was already running when they got there) never asked to publish
                // anything, and warning them about a class they did not try to start reads as
                // an error they caused; what they need is why their mic, camera, share and
                // board are not on the bar.
                if (startPrefs.autoJoined){
                    Notification.info("", "Another teacher is live in this class. You have joined their class — your own controls come back when they stop.")
                }else{
                    Notification.warning("", "Another teacher is already live in this class. Your class has not started publishing.")
                }
                return
            }
            // A class set to record online used to be sent straight to the screen picker
            // here, on the belief that the backend raised the RTMP link around the screen
            // producer. It does not — the recorder branches on producer.kind and takes one
            // audio plus one video of any sort — so a camera left on at pre-join is already
            // everything the recording needs. Asking for the screen on the way in was
            // therefore a dialog for nothing: it blocked the class behind a browser picker
            // and held the recording until something was picked. With the camera on, publish
            // it exactly as an unrecorded class does and let the record step below fire the
            // moment both producers are up. Only a camera left off has nothing to record,
            // and only then is the screen worth asking for.
            if (startPrefs.recording && startPrefs.recordIsOffline===false && !startPrefs.camOn){
                cameraWasOnRef.current = false
                setShareModalReason('record')
                setShareModalStep('pick')
                return
            }
            // Camera off: publishing it would acquire the device (and hold its light) even
            // with the producer paused, and whiteboard mode needs its own click for
            // getDisplayMedia. But the mic can go live on its own, so an audio-only start
            // honours a mic left on rather than dropping the choice.
            if (!startPrefs.camOn){
                if (startPrefs.micOn){
                    onMicClick()
                }
                return
            }
            // The lobby's camera choice is as much a claim on the spinner as pressing the
            // button would have been, and without it this start is reported as unowned —
            // which puts Starting… on the share button while the camera button, the one
            // thing the teacher actually chose, sits greyed out beside it saying nothing.
            claimTransition('camera')
            setShareTypeMode('camera')
            onShareClick()
            return
        }
        if (isPublishing===2 && !startPrefsApplied.current.devices){
            startPrefsApplied.current.devices = true
            // Publishing comes up unmuted (see the rtmpStarted handler), so this has to work
            // in both directions — a mic left off on pre-join must land muted.
            if (startPrefs.micOn && micIsMuted){
                onMicClick()
            }else if (!startPrefs.micOn && !micIsMuted){
                onMicClick()
            }
        }
        // The producers land a little after isPublishing turns 2, and no state is guaranteed
        // to move in between: the devices step above may have nothing to change (a mic left
        // on comes up unmuted already) and a camera that publishes straight away moves
        // isCamOn before its producer is registered. On those renders the record step below
        // simply never gets a second look, and a pre-join recording is dropped on the floor
        // with no error anywhere. Nudge the effect until both halves are really there.
        // Bounded, because a mic-only class has nothing coming: the recording then waits for
        // the teacher to share, which moves state on its own, and the join notice says so.
        if (isPublishing===2 && startPrefs.recording && !startPrefsApplied.current.record
            && !(hasVideoProducer() && hasAudioProducer())){
            if (producerWaitTick >= 40) return undefined
            const retry = setTimeout(()=>setProducerWaitTick((n)=>n+1), 500)
            return ()=>clearTimeout(retry)
        }
        // Mode of recording and the file name were already answered on pre-join, in this same
        // RecordingModal, so record straight away instead of asking a second time. onConfirm
        // reads selectedSection/recordingBatches from its own closure, so those have to land
        // in state first: one seed pass, then the confirm pass on the render that follows.
        // A recording needs something to record: startLocalRecording reads the videoType or
        // screenType track, and a mic-only broadcast has neither. Hold the pre-join choice
        // until the teacher actually shares something — the notice below says so.
        if (isPublishing===2 && hasVideoProducer() && hasAudioProducer() && startPrefs.recording && !startPrefsApplied.current.record){
            if (startPrefs.recordFileName===undefined){
                startPrefsApplied.current.record = true
                onRecord()
                return
            }

            if (!recordPrefsSeeded){
                setSelectedSection(startPrefs.recordSection ?? {})
                setRecordingBatches(startPrefs.recordBatches ?? [])
                setRecordPrefsSeeded(true)
                return
            }
            startPrefsApplied.current.record = true
            onConfirm(startPrefs.recordFileName, startPrefs.recordIsOffline!==false)
        }
    }, [startPrefs, connecting, isPublishing, micIsMuted, isCamOn, recordPrefsSeeded, audioOnly,
        publishEvidenceReady, producerWaitTick])

    // Attach the local stream whenever the <video> appears or swaps places (whiteboard
    // toggle, camera toggle, share mode change) — the element is mounted conditionally, so
    // the 'cameraOn' event alone cannot be relied on to find it.
    useEffect(()=>{
        if (videoStreamRef.current && localVideoRef.current){
            localVideoRef.current.srcObject = videoStreamRef.current
        }
    }, [whiteboard, cameraIsOn, isPublishing])


    let isAnyonePublishing = ifAnyOnePublishing()
    // Read by onStreamEnded, which is a useCallback and would otherwise close over whatever
    // this was on the render that created it.
    const isAnyonePublishingRef = useRef(false);
    isAnyonePublishingRef.current = isAnyonePublishing;
    // Pending remount of a player that gave up too early. See onStreamEnded.
    const playerRetryRef = useRef(null);

    // Whoever else is publishing, by name. `publishers` is keyed by user id and holds only a
    // boolean, so the name comes from the room's own user list — the same list
    // ifAnyOnePublishing already reads to check the publisher has not gone offline. Self is
    // excluded: the chip that uses this has its own branch for this user, and a teacher whose
    // own id turned up here would be named twice over.
    const remotePublisher = useMemo(()=>{
        const liveId = Object.keys(publishers).find((id)=>
            publishers[id] && onlineUserIds.includes(id) && `${id}`!==`${sessionuser?.id}`)
        if (!liveId) return null
        return {
            id: liveId,
            name: usersList?.find((item)=>`${item.user?.id}`===`${liveId}`)?.user?.name ?? '',
            // Muted until they say otherwise. A publisher whose first heartbeat has not
            // landed yet is more honestly drawn as quiet than as a meter that will sit at
            // zero regardless — and one heartbeat later it is the truth either way.
            micMuted: publisherMic[liveId] !== false,
        }
    }, [publishers, publisherMic, usersList, onlineUserIds, sessionuser?.id])
    // The chip has to outlive the publish that fed it. A class being drained (see below) is
    // still on screen and still audible for another twelve seconds after ifAnyOnePublishing
    // goes false, and with nothing held the name would drop to the fallback and the mic to
    // "muted" for the whole of that tail — a teacher visibly talking under a muted tag, and
    // a name change that reads as a second person having taken over.
    const lastPublisherRef = useRef(null);
    if (remotePublisher) lastPublisherRef.current = remotePublisher;
    const stagePublisher = remotePublisher ?? lastPublisherRef.current;

    // ---- end-of-class drain ---------------------------------------------------------
    // Students were losing the last twelve to sixteen seconds of every class, and the
    // teardown was ours. ifAnyOnePublishing goes false within one 2s publish heartbeat of
    // the teacher clicking stop; VideoBoxRow then swaps the player for the "stream will
    // start" placeholder, and unmounting runs hls.destroy() in hls-player.js. But a viewer
    // sits liveSyncDurationCount x TARGETDURATION behind the live edge — 12s nominally, 16s
    // at the ceiling video.js names — so whatever is still ahead of them at that moment is
    // precisely the end of the lesson, and destroying the player throws all of it away.
    //
    // The backend keeps those segments fetchable for 30s after its encoder exits and asks
    // the client to play through to #EXT-X-ENDLIST instead. So the player now outlives the
    // publish signal: when publishing stops it enters a drain — still mounted, still
    // playing — until the video element runs off the end of the completed playlist, or
    // DRAIN_CEILING_MS passes, whichever comes first.
    //
    // Scoped to students. A teacher who has just ended their own class has no tail to catch
    // up on, and leaving the teacher's stage alone keeps this clear of the PassiveCanvas
    // precedence that side runs on.
    const [draining, setDraining] = useState(false);
    const drainingRef = useRef(false);
    const drainTimerRef = useRef(null);
    const wasPublishingRef = useRef(false);
    // Bumped when a class restarts inside the drain window, so the viewer gets a fresh
    // player. streamId does not change across a stop/start in the same room, and the effect
    // in hls-player.js is keyed on src — without a new key it would not re-run, and the
    // viewer would sit staring at the playlist that has already ended.
    const [playerEpoch, setPlayerEpoch] = useState(0);
    const endDrain = useCallback(()=>{
        if (drainTimerRef.current){
            clearTimeout(drainTimerRef.current);
            drainTimerRef.current = null;
        }
        drainingRef.current = false;
        setDraining(false);
    }, []);
    useEffect(()=>{
        if (isAnyonePublishing){
            wasPublishingRef.current = true;
            if (drainingRef.current){
                endDrain();
                setPlayerEpoch((n)=>n+1);
            }
            return undefined
        }
        // Nothing to drain for a peer that never saw the class running in the first place —
        // otherwise every student who opens a room between classes starts one.
        if (!wasPublishingRef.current) return undefined
        wasPublishingRef.current = false;
        // Anyone watching drains, not only student accounts. This was scoped to isStudentUser
        // on the reasoning that a teacher ending their own class has no tail to catch up on —
        // true for the teacher who pressed stop, and wrong for everybody else. A co-teacher,
        // an admin sitting in, and anyone testing with two non-student logins are all just
        // viewers, and they were watching the class vanish the instant it ended while the fix
        // appeared to do nothing. The teacher who is publishing never reaches here anyway:
        // their own stage is the local camera, not this player.
        drainingRef.current = true;
        setDraining(true);
        drainTimerRef.current = setTimeout(()=>{
            drainTimerRef.current = null;
            drainingRef.current = false;
            setDraining(false);
        }, DRAIN_CEILING_MS);
        return undefined
    }, [isAnyonePublishing, endDrain]);
    useEffect(()=>()=>{ if (drainTimerRef.current) clearTimeout(drainTimerRef.current) }, []);
    // Playback ran off the end of the playlist: either the ENDLIST has been reached, or the
    // player spent its 10s manifest-404 window without a playlist appearing (hls-player.js).
    //
    // The second case is not the end of anything while somebody is still publishing — it is
    // the player having asked too early. Bumping the epoch remounts it, which is the only way
    // back: hls.js has called stopLoad() on itself by then and will not retry on its own.
    // That gives an indefinite ~10s retry cycle for as long as the class is live, which is
    // the behaviour the mobile client has always had.
    const onStreamEnded = useCallback(()=>{
        endDrain();
        if (!isAnyonePublishingRef.current) return
        if (playerRetryRef.current) return
        playerRetryRef.current = setTimeout(()=>{
            playerRetryRef.current = null;
            if (!isAnyonePublishingRef.current) return
            setPlayerEpoch((n)=>n+1);
        }, 2000);
    }, [endDrain]);
    useEffect(()=>()=>{ if (playerRetryRef.current) clearTimeout(playerRetryRef.current) }, []);
    // What the stage should show. Both read a drain as "still live", so the player is never
    // pulled out from under a viewer who has not caught up yet.
    const stageIsLive = isAnyonePublishing || draining;
    // Whether the stage is showing this user or somebody else. Mirrors the branch order
    // inside .bn-camera-stage exactly: a publishing teacher's own camera or avatar comes
    // first, the remote player only when this user is not publishing and someone else is,
    // and the idle avatar is this user again. The name chip reads it.
    const stageShowsSelf = !isStudentUser && (isPublishing===2 || !stageIsLive);

    // The same meter, for the teacher on the other end of the stream.
    //
    // There is no mediasoup consumer to read here — everyone watching is watching HLS — so
    // the level is measured off the <video> that is already decoding it. captureStream()
    // taps the element without re-routing it, so the class is not muted by being measured,
    // and hls.js feeds the element through MediaSource, which makes the tap same-origin even
    // though the segments come from broadcast.aulas.in. Chrome and Edge have it outright,
    // Firefox spells it mozCaptureStream, and Safari has neither: there the bars stay flat
    // and the chip still says muted or not from the heartbeat, which is the part that
    // carries the meaning.
    //
    // It writes --bn-mic onto the same root as the hook above, which is safe because the two
    // are never active together: this one only runs while the stage is showing somebody
    // else, and that is exactly when this user is not publishing and the first one is idle.
    const captureRemoteAudio = useCallback(()=>{
        const element = remoteMediaRef.current
        if (!element) return null
        try {
            const capture = element.captureStream || element.mozCaptureStream
            return capture ? capture.call(element) : null
        } catch (error) {
            // Not supported, or the element is not far enough along to be tapped yet. The
            // hook retries on its own rebind interval.
            return null
        }
    }, [])
    useMicLevel(micRootRef, captureRemoteAudio,
        !stageShowsSelf && stageIsLive && stagePublisher?.micMuted === false);
    // The relayed `loadplayer` is no longer a precondition, only an accelerator.
    //
    // It is the publisher's `fileCreating` flag carried over the 2s chat heartbeat, and it
    // turned out to be a far more fragile thing to gate on than the playlist itself: it
    // depends on the backend monitor's 6s poll reaching the publisher's tab, on that tab not
    // having reconnected since, and on the heartbeat arriving — three ways to be told "no
    // stream" about a stream that is being written perfectly well. The mobile client asks for
    // the playlist and lets the player sort it out, and mobile played throughout the whole
    // bug. This does the same.
    //
    // Nothing is lost by being wrong in the other direction: asking for a playlist that is
    // not there yet costs a 404 that hls-player.js already treats as ordinary, retries for
    // 10s, and now re-arms above. `loadplayer` stays in the diagnostic below because it is
    // still the right signal for whether the monitor->heartbeat path is healthy — it is just
    // no longer allowed to keep a working stream off the screen.
    const playerShouldMount = isAnyonePublishing || draining;

    // TEMP DIAGNOSTIC (safe to remove). The stage shows "Stream will start playing
    // automatically when it's live" exactly when this is false. Only the heartbeat can cause
    // that now, so there are two ways left rather than three:
    //
    //   isAnyonePublishing false, publishers empty    -> no Event heartbeat is arriving at all
    //   isAnyonePublishing false, publishers has them -> the publisher is not in onlineUserIds
    //
    // loadplayer no longer gates anything (see playerShouldMount). It is kept here because it
    // still reports on the monitor -> publisher -> heartbeat path: `isAnyonePublishing true,
    // loadplayer false` while the picture plays fine means that path is broken and only the
    // player's own retry is carrying the stream.
    const stageDiag = `${isAnyonePublishing}|${loadplayer}|${draining}`;
    if (stageDiagRef.current !== stageDiag){
        stageDiagRef.current = stageDiag;
        console.log('[BN-DIAG stage]', {
            playerShouldMount,
            isAnyonePublishing,
            loadplayer,
            draining,
            publishers: {...publishers},
            onlineUserIds,
            myIsPublishing: isPublishing,
        });
    }


      const privateUnread = useMemo(()=>{
        let c = 0;
        for (let id in unreadCount.private){
          c += unreadCount.private[id]
        }
        return c
      }, [unreadCount]);

      // The badge on the Participants button: students who are here, not every connection.
      // A co-host, an admin sitting in or a second teacher shows in the list but is not the
      // class, and this number is the teacher's read of how many of their students turned
      // up. roleOf is the same rule that labels each row in the panel, so the badge and the
      // list cannot disagree. Same count as the lobby's badge, for the same reason.
      const onlineCount = useMemo(()=>{
        return (usersList ?? []).filter((item)=>
            item.statustoshow==='online' && roleOf(item?.user ?? {})==='Student'
        ).length
      }, [usersList])


      // ---- side panel chat ----------------------------------------------------------
      // Same payloads the old RightColumn sent through chatClient; only the UI is new.
      const chatUser = useMemo(()=>({
        id: sessionuser?.id,
        name: sessionuser?.name,
        avatar: `${Api._s3_url}${sessionuser?.image}`,
      }), [sessionuser]);
      const sendGroupText = (text) => {
        chatClientRef.current?.sendGroupChat(sessionuser.id, streamId, {
            type: 'Text',
            data: {id: uuidv4(), text, createdAt: new Date(), user: chatUser},
            userId: sessionuser.id,
            roomId: streamId,
        })
      }
      const sendPrivateText = (text) => {
        if (!currentPrivateChatReciever?.id) return
        chatClientRef.current?.sendPrivateChat(sessionuser.id, streamId, currentPrivateChatReciever.id, {
            type: 'Text',
            data: {id: uuidv4(), text, createdAt: new Date(), user: chatUser},
            userId: sessionuser.id,
            roomId: streamId,
            user: sessionuser,
        })
      }
      // Pictures go up through /chat/upload, which stores the message itself - so unlike a
      // text send there is no postChat afterwards. The URL comes back in the callback and
      // is what gets published to the room.
      const imageParams = (file) => ({
        file,
        userId: sessionuser.id,
        roomName: streamId?.split('xxxx')[1],
        type: 'image',
      })
      const sendGroupImage = (file) => {
        postChatImage(imageParams(file), chatUser, (newMessage)=>{
            chatClientRef.current?.sendGroupChat(sessionuser.id, streamId, {
                type: 'Image',
                data: newMessage,
                userId: sessionuser.id,
                roomId: streamId,
            })
        }, 'Group')
      }
      const sendPrivateImage = (file) => {
        // postChatImage reads the recipient off redux, so a thread that was never opened
        // through setCurrentPrivateChatReciever would upload against the wrong person.
        if (!currentPrivateChatReciever?.id) return
        postChatImage(imageParams(file), chatUser, (newMessage)=>{
            chatClientRef.current?.sendPrivateChat(sessionuser.id, streamId, currentPrivateChatReciever.id, {
                type: 'Image',
                data: newMessage,
                userId: sessionuser.id,
                roomId: streamId,
                user: sessionuser,
            })
        }, 'Private')
      }
      const markGroupRead = () => {
        updateUnreadCount('group', 0)
        postMessageOpenStatus({type:'Group', roomName: streamId?.split('xxxx')[1]})
      }
      const markThreadRead = (id) => {
        updateUnreadCount('privateSpecific', 0, id)
        // The panel and the thread list both carry ids as strings — they come from React keys
        // and Object.keys(privateMessages) — but update-chat-read validates senderId as a
        // number and rejects the whole call otherwise. Send it as one.
        const senderId = Number(id)
        if (!Number.isFinite(senderId)) return
        postMessageOpenStatus({type:'Private', roomName: streamId?.split('xxxx')[1], senderId})
      }
      const chatThreads = useMemo(()=>{
        const byId = new Map();
        (usersList ?? []).forEach((item)=>{
            if (item?.user?.id!==undefined) byId.set(`${item.user.id}`, item)
        })
        const allIds = new Set([
            ...Object.keys(privateMessages ?? {}),
            ...Array.from(byId.keys())
        ]);
        return Array.from(allIds)
            // setCurrentPrivateChatReciever seeds this map with the user object as the key,
            // which stringifies to "[object Object]" — skip anything that isn't an id.
            .filter((id)=>/^\d+$/.test(id) && `${id}`!==`${sessionuser?.id}`)
            .map((id)=>{
                const thread = privateMessages[id] ?? []
                const last = thread[thread.length-1]
                const info = byId.get(`${id}`)
                const user = info?.user ?? last?.user
                if (!user) return null;
                const image = user?.image && !`${user.image}`.includes('default.png')
                    ? `${Api._s3_url}${user.image}` : ''
                return {
                    id: `${id}`,
                    name: user?.name ?? 'Participant',
                    image,
                    // Three states, not two. The room only reports people it knows about, so
                    // someone with no usersList entry has *unknown* presence rather than
                    // confirmed absence — this read false and drew them a red dot, which said
                    // "away" about people nothing was known about.
                    online: info ? info.statustoshow === 'online' : undefined,
                    // Asked isStudent of the room's record and fell through to 'Co-host'
                    // whenever there wasn't one, so every student the room had no entry for
                    // was labelled a co-host. roleOf reads the privileges instead.
                    role: roleOf(user),
                    lastMessage: last?.type==='Image' ? 'Photo' : last?.text,
                    lastMessageTime: last?.createdAt,
                    unread: unreadCount?.private?.[id] ?? 0,
                    raw: user,
                }
            }).filter(Boolean)
      }, [privateMessages, usersList, unreadCount, sessionuser]);
      const panelTab = rightViewType==='participantsView' ? 'participants' : 'chat';
      // Private is what has to be asked for - the Private pill, a row's message button, a
      // thread - and everything else lands on the group. Read the other way round, the one
      // state nobody names ('', which is what closing the panel leaves behind) meant
      // "private", so any render that caught it opened the chat on the wrong side.
      const chatMode = (rightViewType==='privateChatView'||rightViewType==='messageStudent') ? 'private' : 'group';
      const activeThread = rightViewType==='messageStudent' && currentPrivateChatReciever?.id
        ? {id: `${currentPrivateChatReciever.id}`, name: currentPrivateChatReciever.name}
        : null;

      // Present/Absent, built from both things that know about people: the class roster
      // join-class handed over (everyone invited, seeded absent) and the room's own user
      // list (whoever is actually connected). The reducer merges these two as well, but only
      // at the moment a `userList` event arrives and only against the roster its closure was
      // built with — an empty roster there left Absent permanently empty. Merging here off
      // live redux state means the absent half is right from the first render and stays right
      // however the two sources arrive.
      const {presentPeople, absentPeople} = useMemo(()=>{
        const selfId = `${sessionuser?.id ?? ''}`
        const avatar = (image) =>
            image && !`${image}`.includes('default.png') ? `${Api._s3_url}${image}` : ''
        const byId = new Map()

        // Invited but not heard from — absent until the room says otherwise below.
        ;(broadcastStudentsList ?? []).forEach((item)=>{
            const id = `${item?.id ?? item?.userId ?? ''}`
            if (!id) return
            byId.set(id, {
                id,
                name: item.name ?? item.userName ?? 'Student',
                image: avatar(item.image),
                role: roleOf(item),
                online: false,
                muted: false,
                isSelf: id === selfId,
                raw: item,
            })
        })

        // Whoever the room reports: students on the roster (whose status this fills in),
        // and everyone who is not — a co-host, an admin sitting in, a second teacher. They
        // are kept rather than filtered out, because roleOf names each one by privilege, so
        // the row says what the person actually is instead of guessing "Co-host".
        ;(usersList ?? []).forEach((item)=>{
            const user = item?.user ?? {}
            const id = `${user.id ?? user.userId ?? ''}`
            if (!id) return
            const existing = byId.get(id)
            const isSelf = id === selfId
            // The room's record of a user holds whatever it was handed at join time and
            // frequently no privileges at all. For ourselves the full account is already
            // in session — the same object /user/account-details fills — so read our own
            // standing from there rather than from what the room echoed back.
            const role = roleOf(isSelf ? {...user, ...sessionuser} : user)
            byId.set(id, {
                id,
                name: user.name ?? user.userName ?? existing?.name ?? 'Participant',
                image: avatar(user.image) || existing?.image || '',
                // roleOf answers "Student" when a payload carries nothing elevated, which is
                // also what it cannot tell apart from a payload that simply said nothing. So
                // an elevated label already established for this person is not thrown away.
                role: role === 'Student' && existing?.role ? existing.role : role,
                online: item.statustoshow === 'online',
                muted: existing?.muted ?? false,
                isSelf,
                raw: user,
            })
        })

        // Ourselves, when the room has not echoed us back yet. We are plainly here — the
        // panel is being read from inside the class — and a list that shows everyone else
        // but not you reads as a bug.
        if (selfId && !byId.has(selfId)) {
            byId.set(selfId, {
                id: selfId,
                name: sessionuser?.name ?? 'You',
                image: avatar(sessionuser?.image),
                role: roleOf(sessionuser ?? {}),
                online: true,
                muted: false,
                isSelf: true,
                raw: sessionuser ?? {},
            })
        }

        const rows = [...byId.values()]
        return {
            presentPeople: rows.filter((row)=>row.online),
            absentPeople: rows.filter((row)=>!row.online),
        }
      }, [usersList, broadcastStudentsList, sessionuser])

      // Our own uplink score, when the server is reporting one for us. Video first: it is
      // the stream that shows damage, and audio survives loss that video does not.
      const ownScore = useMemo(()=>{
        const mine = producerScores[`${sessionuser?.id}`];
        if (!mine) return null
        const values = [mine.video, mine.audio].filter((value)=>Number.isFinite(value));
        return values.length ? Math.min(...values) : null
      }, [producerScores, sessionuser?.id])

      // userId -> {bars, score} for the participants panel. Audio and video are scored
      // separately; the row shows the worse of the two, since that is the one degrading the
      // class. Anyone not publishing has no entry and gets no meter.
      const participantSignals = useMemo(()=>{
        const map = {};
        Object.entries(producerScores).forEach(([userId, kinds])=>{
            const values = Object.values(kinds).filter((value)=>Number.isFinite(value));
            if (!values.length) return
            const score = Math.min(...values);
            map[userId] = {score, bars: scoreToBars(score)};
        });
        return map
      }, [producerScores])

      const quality = useMemo(()=>connectionQuality({
        lossPct: netStats?.lossPct ?? 0,
        rtt: netStats?.rtt ?? null,
        score: ownScore,
        // The three that separate a bad line from a full uplink from a busy machine. All
        // of them are already in the 2s sample; nothing new is measured for this.
        limitedBy: netStats?.limitedBy ?? null,
        estimateBps: netStats?.availableOutgoingBitrate ?? null,
        rungCostBps: netStats?.rungCostBps ?? null,
        // What is actually going out, so an estimate that is merely unexercised is not read
        // as one that is exhausted. See `pressing` in connectionQuality.
        sendBps: netStats?.upBps ?? null,
      }), [netStats, ownScore])
      // Pulled out as primitives. The verdict is a fresh object on every 2s sample, so
      // anything comparing or depending on it by identity would fire every time — which,
      // for the re-test trigger below, would mean a speed test every two seconds.
      const qualityLevel = quality.level;
      const qualityCause = quality.cause;

      // What is actually on the wire, from the frame sizes in the 2s stats sample rather
      // than from what the menu asked for. The two can disagree — a pin the encoder cannot
      // meet, a preferred-layer request the server ignored — and when they do, this is the
      // one worth showing. Publishing reads the send side; watching reads the receive side.
      //
      // Lives here, with the other values derived from netStats, rather than beside the
      // quality-menu state it feeds: it closes over isPublishing, which is declared further
      // down the body, and a useMemo above that point reads it inside its temporal dead zone.
      const measuredVideo = useMemo(()=>{
        const frame = isPublishing===2 && !isStudentUser
            ? netStats?.videoSending
            : (netStats?.videoReceiving ?? netStats?.videoSending);
        if (!frame?.height) return null
        return {
            label: labelForHeight(frame.height),
            detail: describeFrame(frame),
            direction: frame === netStats?.videoSending ? 'sending' : 'receiving',
        }
      }, [netStats, isPublishing, isStudentUser])

      // ---- measured line speed ------------------------------------------------------
      // What the connection can actually carry, from a real transfer rather than from the
      // call's own statistics. See networkSpeedTest.js for why the two cannot be the same
      // number, and why this is not left running.
      //
      // Measured in the direction this peer uses. A teacher publishes, so the figure that
      // decides their rung is upload; a student only receives, so theirs stays download.
      // Feeding a download number to the encoder is the bug this fixes: on an asymmetric
      // line it reported several times the uplink that existed, the encoder ramped into it,
      // and the loss that followed was reported back to the teacher as bad wifi.
      const [lineSpeed, setLineSpeed] = useState(null);      // {bps, bytes, at, direction}
      const [speedTesting, setSpeedTesting] = useState(false);
      const [speedDrop, setSpeedDrop] = useState(null);      // {from, to} while it is down
      // busy guards against overlapping tests — two at once would each measure half a line
      // and both report it as slow. lastAt enforces the cooldown.
      const speedRunRef = useRef({busy: false, lastAt: 0});
      const mountedRef = useRef(true);
      useEffect(()=>()=>{ mountedRef.current = false }, [])

      const runSpeedTest = useCallback(async (options)=>{
        if (speedRunRef.current.busy) return
        speedRunRef.current.busy = true
        if (mountedRef.current) setSpeedTesting(true)
        // Publishers are measured upward, students downward. Nothing else in the flow
        // changes: both probes return the same {bps, bytes, at}, so rungForSpeed and
        // codecOptionsForRung never learn which direction produced the number.
        const result = isStudentUser
            ? await measureDownlink(options)
            : await measureUplink(options.uplink)
        speedRunRef.current.busy = false
        speedRunRef.current.lastAt = Date.now()
        if (!mountedRef.current) return
        setSpeedTesting(false)
        // A failed test leaves the previous figure standing. A live class is the wrong place
        // to report that a measurement endpoint was unreachable.
        if (!result) return
        // The ladder's ceiling and the start bitrate of the next producer both come from
        // this, so it goes in whether or not anything is publishing yet.
        //
        // Kept in a ref as well as pushed. The join-time test starts on mount but roomClient
        // is not constructed until the connect flow runs, so the first and most important
        // measurement can land before there is anything to give it to — which is what left
        // the encoder starting at the no-measurement fallback of 900kbps.
        lineSpeedRef.current = result.bps
        roomClient?.setLineSpeed?.(result.bps)
        setLineSpeed((previous)=>{
            setSpeedDrop(previous && result.bps < previous.bps * SPEED_DROP_RATIO
                ? {from: previous.bps, to: result.bps}
                : null)
            // Tagged for the header, which has to say which direction it is showing — an
            // upload figure under a ↓ is a worse readout than no figure at all. The probes
            // themselves stay on the {bps, bytes, at} contract; only the display carries it.
            return {...result, direction: isStudentUser ? 'down' : 'up'}
        })
      }, [isStudentUser])

      // On join, once.
      useEffect(()=>{ runSpeedTest(SPEED_TEST_JOIN) }, [runSpeedTest])

      // And again whenever the live signals say the line has changed underneath us. The
      // quality verdict is the trigger rather than the raw numbers because it already
      // applies the thresholds and the worst-wins rule; a bare rtt reading crosses back and
      // forth constantly and would spend the cooldown on nothing.
      const lastQualityRef = useRef(null);
      // No in-class probe while a screen is being shared.
      //
      // measureUplink fills the uplink on purpose — that is how it measures one — and the
      // uplink it fills is the one carrying the audio. For the second or two it runs, audio
      // RTP queues behind a megabyte of incompressible bytes and comes out the other side in
      // a burst. That is audible, and it is on a timer: every 120s, or every 60s once the
      // line reads weak — which a 2 Mbps screen share is precisely what causes. Sharing
      // therefore doubled the rate at which the class interrupted itself.
      //
      // Suspending it costs nothing, which is the part that makes this the right fix rather
      // than a trade. The only consumer of the measurement is the video ladder, and the
      // ladder is already standing down: a screen share publishes one encoding, produce()
      // sets _videoRung to null, and _adaptVideoRung returns on its first line while that
      // holds. So during a share we were spending the class's bandwidth on a number nothing
      // would read. The join-time test is untouched — it runs before anything is published.
      // The board stands the ladder down exactly as a screen share does (swapVideoToBoard),
      // so the same reasoning applies: there is no rung for a speed test to inform.
      const screenShareLive = isPublishing === 2 && (shareMode === 'screen' || shareMode === 'board');
      useEffect(()=>{
        const previous = lastQualityRef.current;
        lastQualityRef.current = qualityLevel;
        if (previous === null || previous === qualityLevel) return
        if (screenShareLive) return
        if (Date.now() - speedRunRef.current.lastAt < SPEED_RECHECK_COOLDOWN_MS) return
        runSpeedTest(SPEED_TEST_RECHECK)
      }, [qualityLevel, runSpeedTest, screenShareLive])

      // Staleness floor for a connection steady enough never to trip the verdict, and the
      // shorter one that applies while the ladder is held at 360p waiting for a reading that
      // says the line has come back.
      const weakLine = netStats?.weakLine ?? false;
      useEffect(()=>{
        const id = setInterval(()=>{
            // Same reason as above: a share means the ladder is not listening, so the probe
            // would be pure cost. The figure on screen simply ages, which the age stamp
            // beside it already reports honestly.
            if (screenShareLive) return
            const floor = weakLine ? SPEED_WEAK_REFRESH_MS : SPEED_IDLE_REFRESH_MS;
            if (Date.now() - speedRunRef.current.lastAt < floor) return
            runSpeedTest(SPEED_TEST_RECHECK)
        }, 15000);
        return ()=>clearInterval(id)
      }, [runSpeedTest, weakLine, screenShareLive])

      // The existing banner, its sound and the "connection is back to normal" notice all key
      // off isInternetSlow, so the new verdict is fed back into it rather than replacing it.
      useEffect(()=>{
        setIsInternetSlow(qualityLevel==='poor')
      }, [qualityLevel])

    if (connecting){
        return (
            <div className='full-height full-width r-c-c-c'>
                {connectFailed
                    ?
                    <>
                        <div className='text-sm bold-600 color-black'>Could not connect to the class</div>
                        <div className='text-xs a2grey m-t-5 text-center' style={{maxWidth:360}}>
                            The class did not finish setting up. Check your connection, then try again.
                        </div>
                        <div className='r-ac m-t-20'>
                            <button type='button' onClick={()=>window.location.reload()}
                                style={{padding:"7px 18px", marginRight:10, borderRadius:999, cursor:"pointer",
                                        border:"1px solid #d9d5e3", background:"#fff", color:"#191919",
                                        fontFamily:"inherit", fontSize:13}}>
                                Try again
                            </button>
                            <button type='button' onClick={()=>history.goBack()}
                                style={{padding:"7px 18px", borderRadius:999, cursor:"pointer",
                                        border:"1px solid #594099", background:"#594099", color:"#fff",
                                        fontFamily:"inherit", fontSize:13}}>
                                Go back
                            </button>
                        </div>
                    </>
                    :
                    <Loader style={{color:"#5448b7", fontSize:40}}/>
                }
            </div>
        )
    }
    const shouldRenderPassiveCanvas = shareType !== 'camera' || (shareType!='camera' && isPublishing !== 2) || whiteboard;

    // --- pre-redesign render tree, kept for reference --------------------------
    // The class screen exactly as it was before the redesign: TopRow, the
    // DummyVideoView/VideoBoxRow branches, ActionBoxRow and RightColumn. Every
    // component it names is still defined and imported, so this can be pasted back
    // as-is. The new tree below renders the same data through LiveTopBar,
    // LiveControlBar and ParticipantsPanel/ChatPanel.
    // --------------------------------------------------------------------------
    //     return (
    //         <div className="display-flex relative" style={{width:"100%", height:"101%", backgroundColor:"white"}}>
    //             <div className="full-height r-jsb-fc" 
    //                  style={{width:rightView==false?"100%":"75%", 
    //                         }}>
    //                 <TopRow setRightViewType={setRightViewType} 
    //                         userCount={onlineCount} 
    //                         setRightView={setRightView} 
    //                         rightView={rightView}
    //                         rightViewType={rightViewType}
    //                         broadcastSelectedClass={broadcastSelectedClass}
    //                         isPublishing={isPublishing}
    //                         recordTimer={recordTimer}
    //                         onMenuClick={onMenuClick}
    //                         isMenuVisible={isMenuVisible}
    //                         isRecordingState={isRecordingState}
    //                         isInternetSlow={isInternetSlow}
    //                         />
    //                 {(shareType==='screen' || whiteboard) && isCamOn?
    //                 <VideoView key="localvideo" muted={true} ref={localVideoRef} style={{top:-parseInt(window.innerHeight/2)+200, left:window.innerWidth-300}} visible={isCamOn}/>
    //                 :
    //                 shareType==='camera' && isCamOn?
    //                 <DummyVideoView  key="localvideo" muted={true} ref={localVideoRef} rightView={rightView} visible={isCamOn&&isPublishing!=0} micIsMuted={micIsMuted}/>
    //                 :null
    //                 }
    //                 {
    //                 shareType==='camera' && isPublishing===2 && !whiteboard?
    //                 null:
    //                 !sessionuser.access.includes("schedule-student") && !isAnyonePublishing
    //                 ?
    //                 null
    //                 :
    //                 <VideoBoxRow rightView={rightView} 
    //                              streamId={streamId}
    //                              sessionuser={sessionuser}
    //                              ifAnyOnePublishing={isAnyonePublishing&&loadplayer}
    //                              reloadToggler={reloadToggler}
    //                              toggleReloader={toggleReloader}
    //                              isMenuVisible={isMenuVisible}
    //                              activeClass={activeClass}
    //                              />
    //                 }
    //                 <PassiveCanvas
    //                     reactiveCanvas={false}
    //                     chat={chatClient}
    //                     streamId={streamId}
    //                     closeRightView={closeRightView}
    //                     visible={
    //                         shouldRenderPassiveCanvas &&
    //                         !sessionuser.access.includes("schedule-student") &&
    //                         !isAnyonePublishing
    //                     }
    //                     />
    //                 {
    //                     isMenuVisible?
    //                         <ActionBoxRow adapter={roomClient} 
    //                         onParticipantsClick={onParticipantsClick}
    //                         chat={chatClient}
    //                         onCameraClick={onCameraClick}
    //                         streamId={streamId}
    //                         sessionuser={sessionuser}
    //                         chatClient={chatClient}
    //                         isPublishing={isPublishing}
    //                         onShareClick={onShareClick}
    //                         ifAnyOnePublishing={ifAnyOnePublishing}
    //                         onMicClick={onMicClick}
    //                         onLeave={onLeave}
    //                         isCamOn={isCamOn}
    //                         micIsMuted={micIsMuted}
    //                         popover={popover}
    //                         setPopover={setPopover}
    //                         onPrivateChatClick={onPrivateChatClick}
    //                         onGroupChatClick={onGroupChatClick}
    //                         whiteboard={whiteboard}
    //                         setWhiteboard={setWhiteboard}
    //                         onRecordClick={onRecord}
    //                         isRecordingState={isRecordingState}
    //                         groupUnreadCount={unreadCount.group}
    //                         privateUnreadCount={privateUnread}
    //                         onlineCount={onlineCount}
    //                         />
    //                     :null
    //                 }
    //                 <div style={{zIndex:10, backgroundColor:"green", position:"fixed", top:0, left:0}} className='r-c-c'>
    //                     {/* <div onClick={()=>{roomClient.startLocalRecording(shareType==='screen'?'screenType':'videoType')}}>start recording</div>
    //                     <div onClick={()=>{roomClient.stopLocalRecording()}}>stop recording</div>
    //                     <div onClick={()=>{recorder.downloadRecording()}}>save recording</div> */}
    //
    //                     {/* <div onClick={()=>{roomClient.mockcloseProducer('audioType')}}>close audio</div>
    //                     <div onClick={()=>{roomClient.mockcloseProducer('videoType')}}>close video</div>
    //                     <div onClick={()=>{roomClient.mockcloseProducer('screenType')}}>close screen</div> */}
    //                     {/* <div onClick={()=>{roomClient.exitRoom()}}>exit</div>
    //                     <div onClick={()=>{roomClient.exit()}}>exit</div> */}
    //                     {/* <div onClick={()=>{roomClient.stopRecord()}}>mock close Recording</div> */}
    //                 </div>
    //             </div>
    //             {rightView==true && isMenuVisible
    //             ?
    //                 <RightColumn inc={inc} 
    //                             setInc={setInc} 
    //                             chat={chatClient}
    //                             chatClient={chatClient}
    //                             />
    //             :
    //             null}
    //             {isRecordModalVisible ?  <RecordingModal visible={isRecordModalVisible} 
    //                                 title={'Confirm'} onCancel={onCancel} onConfirm={onConfirm} 
    //                                 recordCount={recordCount}
    //                                 localRecordingCount={(streamId in localRecordingName)?1:0}
    //                                 fullmodalloading={isRecording.current===1} 
    //                                 content={isRecording.current===2?'Are you sure you want to stop recording?':'Are you sure you want to record the class?'}
    //                                 selectedSection={selectedSection}
    //                                 isRecording={isRecordingState}
    //                                 setSelectedSection={setSelectedSection}
    //                                 getVideoResourceSections={getVideoResourceSections}
    //                                 selectedSchedule={activeClass.occurance}
    //                                 sectionList={sectionList}
    //                                 recordingBatches={recordingBatches}
    //                                 setRecordingBatches={setRecordingBatches}
    //                                 postCreateTopic={postCreateTopic}
    //                                 />:null}
    //             {isAccessModalVisible?  <ConfirmationModal visible={isAccessModalVisible} 
    //                                 title={'Confirm'} onCancel={onAccessDeny} onConfirm={onAccessGrant} content={'Allow your browser to share the contents of your screen ?'}/>:null}
    //             {isRecordDownloadModalVisible?  <ConfirmationModal visible={isRecordDownloadModalVisible} 
    //                     title={'Offline Recording Video'} isNoButtonRed={true} confirmTitle={'Download'} rejectTitle={'Delete'} onCancel={onDeleteLocalRecording} onConfirm={onDownloadLocalRecording} 
    //                     content={"If chosen 'delete', this recording will be lost forever"} maskClosable={false}/>:null}
    //             <PageDataLoader visible={broadcastLoader}/>
    //         </div>
    //     )
    // Whiteboard mode keeps the legacy full-bleed canvas; everything else gets the inset
    // stage card. When nothing is being published, shareType has been reset to 'screen' by
    // the isPublishing===0 effect, so only trust it while actually live.
    // Only the board itself takes over the screen now. A screen share with the board closed
    // keeps the ordinary stage, which is what makes Close board visibly do something.
    const boardMode = whiteboard;
    // The self view is always mirrored, in every mode. This used to be conditional and the
    // condition is gone on purpose, so here is the whole argument.
    //
    // Mirroring is a courtesy to the person looking at their own camera, and it only holds
    // while those pixels stay on their machine. The old rule dropped it in screen mode because
    // the camera is not published there — roomClient.opencamera keeps that stream local and
    // only the screen goes on the wire — so whatever the class sees of the teacher's camera is
    // whatever the screen capture picked up, which is this very element. Mirrored, it would
    // reach them reversed, and anything held up to the camera would read backwards.
    //
    // That reasoning is sound but it only applies when the teacher shares *this tab*. Share a
    // slide deck, a PDF, an IDE — which is what screen sharing is normally for — and this
    // element is not in the captured region at all, nobody but the teacher ever sees it, and
    // un-mirroring it buys the class nothing. What it costs is paid every time: the self view
    // visibly flips the instant Share screen is pressed, which is disorienting in the middle
    // of teaching and reads as a bug rather than as a considered trade.
    //
    // So the majority case wins. The same pixels genuinely cannot be mirrored for one viewer
    // and not the other, and this picks the viewer who is looking at them in every session
    // over the one who only sees them when a particular window is shared.
    //
    // Board mode never had a reason to drop the mirror either way: boardCapture's paintPip()
    // reaches the class through context.drawImage(video, …), which reads the raw decoded frame
    // — CSS transforms have no effect on it, so students get an un-mirrored picture regardless
    // of what this class name says.
    const selfieClass = 'bn-selfie';

    const controlBar = (
        <LiveControlBar isStudent={isStudentUser}
            /* the bar lives inside .bn-main, which already stops at the panel's edge */
            rightView={false}
            floating={boardMode}
            isPublishing={isPublishing}
            audioOnly={audioOnly}
            /* Another teacher holds the room. Every way of going live routes through
               onShareClick, so while this is true none of them can start — say so on the
               buttons instead of letting a click find out from a toast. */
            othersSharing={!!isAnyonePublishing}
            isStopping={isPublishing===1 && transitionKindRef.current==='stop'}
            /* Which button shows the spinner. Null hands it back to Share, which is where
               a transition nobody clicked for (a reconnect, the pre-join start) belongs. */
            /* Before the publish starts moving there is no claim to cash in yet, so the
               lobby's own choice stands in for one — see pendingStartControl. */
            transitionOwner={transitionOwner ?? pendingStartControl}
            startPending={!!pendingStartControl}
            micIsMuted={micIsMuted}
            isCamOn={cameraIsOn}
            shareType={shareMode}
            shareSwapping={shareSwapping}
            whiteboard={boardMode}
            /* One of camera, screen or board has to be on for the mic to be offered at all.
               The button goes the instant the last one does, and the effect beside
               isSendingVideo mutes the mic with it. */
            showMic={isSendingVideo}
            /* Only a press of this button counts as the teacher choosing. Applying the
               lobby's preferences calls onMicClick too, and that must not read as one. */
            onMicClick={()=>{
                micUserMutedRef.current = !micIsMuted
                onMicClick()
            }}
            onCameraClick={onCameraClick}
            onShareClick={onScreenShareToggle}
            onWhiteboardClick={onWhiteboardClick}
            onLeave={onLeave}
            onParticipantsClick={onParticipantsClick}
            onChatClick={()=>{
                onGroupChatClick()
                markGroupRead()
            }}
            onGroupChatClick={onGroupChatClick}
            onPrivateChatClick={onPrivateChatClick}
            onlineCount={onlineCount}
            videoQuality={videoQuality}
            videoQualityLabel={measuredVideo?.label ?? ''}
            videoQualityDetail={measuredVideo?.detail ?? ''}
            videoQualityDirection={measuredVideo?.direction ?? ''}
            videoLimitedBy={netStats?.limitedBy ?? null}
            // Quality picker withdrawn — see applyVideoQuality for why and how to restore it.
            // LiveControlBar renders the menu only when onVideoQualityChange is passed, so
            // leaving it off is the entire switch:
            //   onVideoQualityChange={onVideoQualityChange}
            groupUnreadCount={unreadCount.group}
            privateUnreadCount={privateUnread}
            />
    );
    // Column shell: the top bar runs the full width — REC and Live sit above the side panel,
    // not only above the stage — with the stage and panel side by side below it.
    return (
        <div className="bn-shell relative"
             ref={micRootRef}
             style={{width:"100%",
                     height:"100%",
                     display:"flex",
                     flexDirection:"column",
                     backgroundColor:boardMode?"white":"#f5f4f8"}}>
                <LiveTopBar subjectInitial={subjectBadge.initial}
                        subjectIcon={subjectBadge.icon}
                        title={classTitle}
                        subtitle={isPublishing===2?'In session':'Setting up'}
                        isRecordingState={isRecordingState}
                        recordTimer={recordTimer}
                        /* Recording is raised on this peer's own producers, so it belongs to
                           whoever is actually publishing — and only while nobody else is.
                           Another teacher's class is not this one's to record. */
                        canRecord={isPublishing===2 && !isAnyonePublishing}
                        onRecordClick={onRecord}
                        isStudent={isStudentUser}
                        rightView={rightView}
                        quality={qualityLevel}
                        qualityCause={qualityCause}
                        netStats={netStats}
                        lineSpeed={lineSpeed}
                        videoRung={videoRung}
                        speedTesting={speedTesting}
                        speedDrop={speedDrop}
                        onSpeedRetest={()=>runSpeedTest(SPEED_TEST_RECHECK)}
                        formatBytes={formatBytes}
                        formatBitrate={formatBitrate}
                        formatSpeed={formatSpeed}
                        />
                <div className="bn-body">
                <div className="bn-main" style={{position:"relative", overflow:"hidden"}}>
                {boardMode?
                <>
                {/* Board and camera together: the self view sits over the board as a
                    picture-in-picture. The legacy VideoView placed itself with
                    window.innerHeight/innerWidth arithmetic (top:-innerHeight/2+200), which
                    in this layout lands far above the viewport — the camera was publishing
                    the whole time, it just could not be seen. .bn-pip anchors it to the
                    stage's own top-right instead. */}
                {cameraIsOn?
                <DraggablePip className="bn-pip" title="Drag to move your camera">
                    <video key="localvideo" className={selfieClass} ref={localVideoRef} autoPlay playsInline muted/>
                    <div className="bn-pip-chip">
                        <span>{sessionuser?.name} (You)</span>
                        <MicChip muted={micIsMuted} bars={3}/>
                    </div>
                </DraggablePip>
                :null
                }
                {
                !sessionuser.access.includes("schedule-student") && !isAnyonePublishing
                ?
                null
                :
                <VideoBoxRow rightView={rightView}
                             streamId={streamId}
                             sessionuser={sessionuser}
                             ifAnyOnePublishing={playerShouldMount}
                             onStreamEnded={onStreamEnded}
                             playerKey={playerEpoch}
                             reloadToggler={reloadToggler}
                             toggleReloader={toggleReloader}
                             isMenuVisible={isMenuVisible}
                             activeClass={activeClass}
                             mediaRef={remoteMediaRef}
                             />
                }
                <PassiveCanvas
                    reactiveCanvas={false}
                    chat={chatClient}
                    streamId={streamId}
                    rightView={rightView}
                    closeRightView={closeRightView}
                    visible={
                        shouldRenderPassiveCanvas &&
                        !sessionuser.access.includes("schedule-student") &&
                        !isAnyonePublishing
                    }
                    checkStorageAndProceed={(proceed, onFailure) => {
                        if (storageCheckRef.current) {
                            if (onFailure) onFailure();
                            return;
                        }
                        storageCheckRef.current = true;
                        getStorageDetails(null, (details) => {
                            storageCheckRef.current = false;
                            if (details && isOutOfStorage(details)) {
                                setStorageAvailableBytes(availableBytesFor(details));
                                setStorageModalVisible(true);
                                if (onFailure) onFailure();
                                return;
                            }
                            proceed();
                        });
                    }}
                    />
                {isPublishing===2 && !isStudentUser?
                    <div className="bn-stage-name-chip bn-above-bar">
                        <span>{sessionuser?.name} (You)</span>
                        <MicChip muted={micIsMuted}/>
                    </div>
                :null}
                {controlBar}
                </>
                :
                /* Default stage: the inset card. No canvas here — the whiteboard only opens
                   when the teacher asks for it, which is also when screen sharing starts. */
                <div className="bn-stage-area">
                    <div className="bn-stage-row">
                        <div className="bn-tile">
                            <div className="bn-camera-stage">
                                {/* Publishing teacher sees their own camera; everyone else sees
                                    whoever is publishing. Same precedence the old layout used. */}
                                {isPublishing===2 && !isStudentUser?
                                    cameraIsOn?
                                    <video key="localvideo" className={selfieClass} ref={localVideoRef} autoPlay playsInline muted
                                           style={{width:"100%", height:"100%", objectFit:"cover"}}/>
                                    :
                                    <StageAvatar initials={initialsOf(sessionuser?.name)}/>
                                :stageIsLive?
                                <VideoBoxRow rightView={rightView}
                                             streamId={streamId}
                                             sessionuser={sessionuser}
                                             ifAnyOnePublishing={playerShouldMount}
                                             onStreamEnded={onStreamEnded}
                                             playerKey={playerEpoch}
                                             reloadToggler={reloadToggler}
                                             toggleReloader={toggleReloader}
                                             isMenuVisible={isMenuVisible}
                                             activeClass={activeClass}
                                             mediaRef={remoteMediaRef}
                                             />
                                :isStudentUser?
                                <div className="bn-preview-off">Waiting for your teacher to start.</div>
                                :
                                <StageAvatar initials={initialsOf(sessionuser?.name)}/>
                                }
                            </div>
                            {!isStudentUser?
                            <div className="bn-stage-name-chip">
                                {/* The chip names whoever the stage is showing, which is not
                                    always this user. A teacher who joins a class another
                                    teacher is already publishing watches their colleague's
                                    picture, and this said "(You)" across the bottom of it.
                                    Both branches carry a mic chip and both are measured: the
                                    mute flag comes off that publisher's own heartbeat and the
                                    bars off the audio actually arriving, so what a viewer
                                    sees here is the same thing the publisher sees of
                                    themselves. */}
                                {stageShowsSelf?
                                <>
                                    <span>{sessionuser?.name} (You)</span>
                                    <MicChip muted={micIsMuted}/>
                                </>
                                :
                                <>
                                    <span>{stagePublisher?.name || 'Teacher'}</span>
                                    <MicChip muted={stagePublisher?.micMuted !== false}/>
                                </>
                                }
                            </div>
                            :null}
                        </div>
                    </div>
                    {controlBar}
                </div>
                }
                <div style={{zIndex:10, backgroundColor:"green", position:"fixed", top:0, left:0}} className='r-c-c'>
                    {/* <div onClick={()=>{roomClient.startLocalRecording(shareType==='screen'?'screenType':'videoType')}}>start recording</div>
                    <div onClick={()=>{roomClient.stopLocalRecording()}}>stop recording</div>
                    <div onClick={()=>{recorder.downloadRecording()}}>save recording</div> */}
                
                    {/* <div onClick={()=>{roomClient.mockcloseProducer('audioType')}}>close audio</div>
                    <div onClick={()=>{roomClient.mockcloseProducer('videoType')}}>close video</div>
                    <div onClick={()=>{roomClient.mockcloseProducer('screenType')}}>close screen</div> */}
                    {/* <div onClick={()=>{roomClient.exitRoom()}}>exit</div>
                    <div onClick={()=>{roomClient.exit()}}>exit</div> */}
                    {/* <div onClick={()=>{roomClient.stopRecord()}}>mock close Recording</div> */}
                </div>
            </div>
            {rightView==true && isMenuVisible
            ?
                <ParticipantsPanel
                            present={presentPeople}
                            absent={absentPeople}
                            signals={participantSignals}
                            chatUnread={unreadCount.group + privateUnread}
                            activeTab={panelTab}
                            onTabChange={(tab)=>{
                                if (tab==='chat'){
                                    setRightViewType('groupChatView')
                                    markGroupRead()
                                }else{
                                    setRightViewType('participantsView')
                                }
                            }}
                            onClose={closeRightView}
                            onMessage={(person)=>{
                                // Same hand-off the old UserCard did: pick the recipient, then
                                // open their thread.
                                if (isStudentUser && person.raw?.isStudent) return
                                setCurrentPrivateChatReciever(person.raw)
                                setRightViewType('messageStudent')
                                markThreadRead(person.id)
                            }}
                            chatSlot={
                                <ChatPanel mode={chatMode}
                                    groupUnread={unreadCount.group}
                                    privateUnread={privateUnread}
                                    onModeChange={(mode)=>{
                                        if (mode==='group'){
                                            setRightViewType('groupChatView')
                                            markGroupRead()
                                        }else{
                                            setRightViewType('privateChatView')
                                        }
                                    }}
                                    selfId={sessionuser?.id}
                                    groupMessages={groupMessages}
                                    threads={chatThreads}
                                    activeThread={activeThread}
                                    threadMessages={activeThread ? (privateMessages?.[activeThread.id] ?? []) : []}
                                    onOpenThread={(thread)=>{
                                        setCurrentPrivateChatReciever(thread.raw ?? {id: thread.id, name: thread.name})
                                        setRightViewType('messageStudent')
                                        markThreadRead(thread.id)
                                    }}
                                    onCloseThread={()=>setRightViewType('privateChatView')}
                                    onSendGroup={sendGroupText}
                                    onSendPrivate={sendPrivateText}
                                    onSendGroupImage={sendGroupImage}
                                    onSendPrivateImage={sendPrivateImage}
                                    canSend={!!chatClient}
                                    />
                            }
                            />
            :
            null}
            </div>
            {shareModalStep ?
                <ShareScreenModal
                    title={'Share your screen to record?'}
                    body={'Recording needs something to record and your camera is off. Share a screen instead — pick the screen students should see and recording starts once it is shared.'}
                    confirmLabel={'Allow & share'}
                    onCancel={()=>{
                        const reason = shareModalReason
                        setShareModalStep(null);
                        // Nothing is going to arrive, so stop whatever was waiting on a share.
                        afterScreenShareRef.current = null;
                        abandonRecordingResume();
                        if (reason!=='record') return
                        // The screen was only being asked for so the class could be recorded.
                        // Drop that choice and say why, rather than leaving a REC setting the
                        // backend cannot honour and letting it fail silently later.
                        pendingRecordRef.current = null
                        Notification.warning("", "A recording needs your camera, screen or whiteboard. Nothing is being recorded")
                        // Pre-join route: the class has not gone live at all yet, so fall back
                        // to the ordinary start the prefs asked for instead of leaving the
                        // teacher sitting on a dead stage with no way back.
                        if (isPublishing===0){
                            cameraWasOnRef.current = false
                            if (startPrefs?.camOn){
                                setShareTypeMode('camera')
                                onShareClick()
                            }else if (startPrefs?.micOn){
                                onMicClick()
                            }
                        }
                    }}
                    onConfirm={onShareModalConfirm}
                    />
            :null}
            {isRecordModalVisible ?  <RecordingModal visible={isRecordModalVisible} 
                                title={'Confirm'} onCancel={onCancel} onConfirm={onConfirm} 
                                recordCount={recordCount}
                                localRecordingCount={(streamId in localRecordingName)?1:0}
                                fullmodalloading={isRecording.current===1} 
                                content={isRecording.current===2?'Are you sure you want to stop recording?':'Are you sure you want to record the class?'}
                                selectedSection={selectedSection}
                                isRecording={isRecordingState}
                                setSelectedSection={setSelectedSection}
                                getVideoResourceSections={getVideoResourceSections}
                                selectedSchedule={activeClass.occurance}
                                sectionList={sectionList}
                                recordingBatches={recordingBatches}
                                setRecordingBatches={setRecordingBatches}
                                postCreateTopic={postCreateTopic}
                                />:null}
            {/* The same modal the Digital Library upload flows raise, in the same variant:
                passing availableStorageBytes is what selects 'Storage Limit Reached' with
                the figure in it over the plain 'Storage Full!' copy. No fromSchedule - what
                has run out is library storage, not broadcast minutes, so Upgrade Storage
                belongs at /digital-library/buy-storage like every other caller of this
                variant. */}
            {isStorageModalVisible ? <AulasSubscriptionModal
                                isModalVisible={isStorageModalVisible}
                                handleCancel={()=>setStorageModalVisible(false)}
                                availableStorageBytes={storageAvailableBytes}
                                user={sessionuser}
                                />:null}
            {isAccessModalVisible?  <ConfirmationModal visible={isAccessModalVisible} 
                                title={'Confirm'} onCancel={onAccessDeny} onConfirm={onAccessGrant} content={'Allow your browser to share the contents of your screen ?'}/>:null}
            {isRecordDownloadModalVisible?  <ConfirmationModal visible={isRecordDownloadModalVisible} 
                    title={'Offline Recording Video'} isNoButtonRed={true} confirmTitle={'Download'} rejectTitle={'Delete'} onCancel={onDeleteLocalRecording} onConfirm={onDownloadLocalRecording} 
                    content={"If chosen 'delete', this recording will be lost forever"} maskClosable={false}/>:null}
            {/* Named for the move it offers rather than the problem it reports: "your
                connection is unstable" on its own leaves the teacher with bad news and
                nothing to do about it. The measured figure stays out of the body: a number
                mid-lesson invites reading it rather than acting on it, and the one move
                worth making is the same at 0.4 Mbps as at 4.

                A snackbar rather than a dialog: this arrives mid-lesson, and a modal stops
                the teacher dead to answer a question about video quality - which is never
                more urgent than whatever they were saying. Keeping the camera on stays the
                default by doing nothing at all, so only the one move that needs a click
                gets a button. */}
            {weakNetworkPrompt ? <div className="bn-snackbar" role="status">
                    <div className="bn-snackbar-text">
                        <span className="bn-snackbar-title">Your connection is unstable</span>
                        Turning off your camera frees the connection for your audio.
                    </div>
                    <button type="button" className="bn-snackbar-action"
                            onClick={()=>{
                                setWeakNetworkPrompt(null)
                                setCameraEnabled(false)
                            }}>
                        Turn off camera
                    </button>
                    <button type="button" className="bn-snackbar-close" title="Dismiss"
                            onClick={()=>setWeakNetworkPrompt(null)}>
                        <FiX size={16}/>
                    </button>
                </div>:null}
            {/* Asked before the pick is applied, not after: the point is that the choice is
                made knowingly. Choosing it anyway is honoured in full — setVideoQuality does
                not clamp it — and the escalation above is what handles it if the line then
                cannot hold it. */}
            {qualityWarning ? <ConfirmationModal
                    visible={true}
                    title={`${VIDEO_LADDER[qualityWarning.rung].label} is not recommended`}
                    content={`Your internet speed currently supports about ${VIDEO_LADDER[qualityWarning.ceiling].label}. At ${VIDEO_LADDER[qualityWarning.rung].label} the video is likely to break up, and the class may see less than ${VIDEO_LADDER[qualityWarning.rung].label} anyway.`}
                    confirmTitle={`Use ${VIDEO_LADDER[qualityWarning.rung].label} anyway`}
                    rejectTitle={`Stay on ${VIDEO_LADDER[qualityWarning.ceiling].label}`}
                    onConfirm={()=>{
                        const {rung} = qualityWarning
                        setQualityWarning(null)
                        applyVideoQuality(rung)
                    }}
                    onCancel={()=>{
                        const {ceiling} = qualityWarning
                        setQualityWarning(null)
                        // Declining is not "do nothing" — the menu still reads whatever it
                        // read before. Settle it on what the line actually carries, so the
                        // label and the picture agree.
                        applyVideoQuality(ceiling)
                    }}
                    onClose={()=>setQualityWarning(null)}
                    />:null}
            <PageDataLoader visible={broadcastLoader}/>
        </div>
    )
}

const mapStateToProps = state=>{
    const {rightView, isCamOn,streamId,
            userCount, userType, rightViewType,
            broadcastLoader, micIsMuted,
            sectionList, unreadCount, usersList,
            localRecordingName, groupMessages, privateMessages,
            currentPrivateChatReciever} = state.broadcast;
    const {user} = state.session;
    const {orgData} = state.loginNew;
    const {broadcastSelectedClass, broadcastStudentsList, activeClass, recordCount, cardData} = state.schedule;
    const sessionuser = user;
    return {
        orgData,
        rightView, isCamOn, userCount,
        sessionuser, userType, rightViewType,streamId,
        broadcastSelectedClass, broadcastStudentsList,
        broadcastLoader,
        micIsMuted,
        activeClass,
        sectionList,
        recordCount,
        unreadCount,
        usersList,
        localRecordingName,
        cardData,
        groupMessages,
        privateMessages,
        currentPrivateChatReciever
    }
}

const mapDispatchToProps = (dispatch)=>({
    setRightViewType: (newView) => dispatch(setRightViewType(newView)),
    setMuteState: (bool)=>dispatch(setMuteState(bool)),
    setCameraState: (bool)=>dispatch(setCameraState(bool)),
    clearGroupChat: ()=>dispatch(clearGroupChat()),
    updateUserList: (usersList, broadcastList) => dispatch(updateUserList(usersList, broadcastList)),
    updateUserCount: (usercount)=>dispatch(updateUserCount(usercount)),
    addMessageToGroup: (newMessage) => dispatch(addMessageToGroup(newMessage)),
    setUserType: ()=>dispatch(setUserType()),
    setRightView: (bool)=>dispatch(setRightView(bool)),
    addMessageToPrivate: (reciever, newMessage)=>dispatch(addMessageToPrivate(reciever, newMessage)),
    setStreamId: (newId)=>dispatch(setStreamId(newId)),
    postChat: (message, chatType)=>dispatch(postChat(message, chatType)),
    postChatImage: (params, user, callback, type)=>dispatch(postChatImage(params, user, callback, type)),
    clearPrivateChat: ()=>dispatch(clearPrivateChat()),
    getVideoResourceSections: (id, callback) => dispatch(getVideoResourceSections(id, callback)),
    postRecordedVideoLesson: (params, callback, successCallback) => dispatch(postRecordedVideoLesson(params, callback, successCallback)),
    postRecordCount: (params, callback, successCallback) => dispatch(postRecordCount(params, callback, successCallback)),
    getRoomData: () => dispatch(getRoomData()),
    updateUnreadCount: (key, val, id) => dispatch(updateUnreadCount(key, val, id)),
    BroadcastRecordingEdit: (p, c, sc) => dispatch(BroadcastRecordingEdit(p, c, sc)),
    setLocalRecordingName: (key, val) => dispatch(setLocalRecordingName(key, val)),
    setCurrentPrivateChatReciever: (user) => dispatch(setCurrentPrivateChatReciever(user)),
    postMessageOpenStatus: (params) => dispatch(postMessageOpenStatus(params)),
    postCreateTopic: (object, callback, successCallback) => dispatch(postCreateTopic(object, callback, successCallback)),
    getStorageDetails: (callback, successCallback) => dispatch(getStorageDetails(callback, successCallback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Broadcast)